export var CoreManagement;
(function (CoreManagement) {
    /**
     * Add a blob to a case interacion.
     *
     * @export
     * @class AddBlobToCaseInteraction
     * @implements {EvaService}
     */
    class AddBlobToCaseInteraction {
        name = 'CoreManagement:AddBlobToCaseInteraction';
        path = '/message/AddBlobToCaseInteraction';
        request;
        response;
    }
    CoreManagement.AddBlobToCaseInteraction = AddBlobToCaseInteraction;
    /**
     * Add a price list to a loyalty program. NOTE THAT you can only add one pricelist per currency to a loyalty program.
     *
     * @export
     * @class AddLoyaltyProgramPriceList
     * @implements {EvaService}
     */
    class AddLoyaltyProgramPriceList {
        name = 'CoreManagement:AddLoyaltyProgramPriceList';
        path = '/message/AddLoyaltyProgramPriceList';
        request;
        response;
    }
    CoreManagement.AddLoyaltyProgramPriceList = AddLoyaltyProgramPriceList;
    /**
     * Add a custom field requirement to the loyalty program. NOTE THAT a custom field can only be set once as a requirement.
     *
     * @export
     * @class AddLoyaltyProgramRequiredCustomField
     * @implements {EvaService}
     */
    class AddLoyaltyProgramRequiredCustomField {
        name = 'CoreManagement:AddLoyaltyProgramRequiredCustomField';
        path = '/message/AddLoyaltyProgramRequiredCustomField';
        request;
        response;
    }
    CoreManagement.AddLoyaltyProgramRequiredCustomField = AddLoyaltyProgramRequiredCustomField;
    /**
     * Add a package to a carrier
     *
     * @export
     * @class AddPackageToCarrier
     * @implements {EvaService}
     */
    class AddPackageToCarrier {
        name = 'CoreManagement:AddPackageToCarrier';
        path = '/message/AddPackageToCarrier';
        request;
        response;
    }
    CoreManagement.AddPackageToCarrier = AddPackageToCarrier;
    /**
     * Add personalized promotion products for a user.
     *
     * @export
     * @class AddPersonalizedPromotionsProducts
     * @implements {EvaService}
     */
    class AddPersonalizedPromotionsProducts {
        name = 'CoreManagement:AddPersonalizedPromotionsProducts';
        path = '/message/AddPersonalizedPromotionsProducts';
        request;
        response;
    }
    CoreManagement.AddPersonalizedPromotionsProducts = AddPersonalizedPromotionsProducts;
    /**
     * Adds or updates the given products to the assortment.

When the given products are all root products, the request will automaticly update all childeren.
But if the list is a mixed product list, all updates will be applied according to the given information.
     *
     * @export
     * @class AddProductsToAssortment
     * @implements {EvaService}
     */
    class AddProductsToAssortment {
        name = 'CoreManagement:AddProductsToAssortment';
        path = '/message/AddProductsToAssortment';
        request;
        response;
    }
    CoreManagement.AddProductsToAssortment = AddProductsToAssortment;
    /**
     * Add required custom fields to ManualDiscount
     *
     * @export
     * @class AddRequiredCustomFieldsToManualDiscount
     * @implements {EvaService}
     */
    class AddRequiredCustomFieldsToManualDiscount {
        name = 'CoreManagement:AddRequiredCustomFieldsToManualDiscount';
        path = '/message/AddRequiredCustomFieldsToManualDiscount';
        request;
        response;
    }
    CoreManagement.AddRequiredCustomFieldsToManualDiscount = AddRequiredCustomFieldsToManualDiscount;
    /**
     * Add security roles to ManualDiscount
     *
     * @export
     * @class AddRolesToManualDiscount
     * @implements {EvaService}
     */
    class AddRolesToManualDiscount {
        name = 'CoreManagement:AddRolesToManualDiscount';
        path = '/message/AddRolesToManualDiscount';
        request;
        response;
    }
    CoreManagement.AddRolesToManualDiscount = AddRolesToManualDiscount;
    /**
     * Register user bought product.
     *
     * @export
     * @class AddUserBoughtProductDetail
     * @implements {EvaService}
     */
    class AddUserBoughtProductDetail {
        name = 'CoreManagement:AddUserBoughtProductDetail';
        path = '/message/AddUserBoughtProductDetail';
        request;
        response;
    }
    CoreManagement.AddUserBoughtProductDetail = AddUserBoughtProductDetail;
    /**
     * Answer a survey question
     *
     * @export
     * @class AnswerSurveyQuestion
     * @implements {EvaService}
     */
    class AnswerSurveyQuestion {
        name = 'CoreManagement:AnswerSurveyQuestion';
        path = '/message/AnswerSurveyQuestion';
        request;
        response;
    }
    CoreManagement.AnswerSurveyQuestion = AnswerSurveyQuestion;
    /**
     * Archive a case.
     *
     * @export
     * @class ArchiveCase
     * @implements {EvaService}
     */
    class ArchiveCase {
        name = 'CoreManagement:ArchiveCase';
        path = '/message/ArchiveCase';
        request;
        response;
    }
    CoreManagement.ArchiveCase = ArchiveCase;
    /**
     * Archive an existing discount
     *
     * @export
     * @class ArchiveDiscount
     * @implements {EvaService}
     */
    class ArchiveDiscount {
        name = 'CoreManagement:ArchiveDiscount';
        path = '/message/ArchiveDiscount';
        request;
        response;
    }
    CoreManagement.ArchiveDiscount = ArchiveDiscount;
    /**
     * Archive a personalized promotion.
     *
     * @export
     * @class ArchivePersonalizedPromotion
     * @implements {EvaService}
     */
    class ArchivePersonalizedPromotion {
        name = 'CoreManagement:ArchivePersonalizedPromotion';
        path = '/message/ArchivePersonalizedPromotion';
        request;
        response;
    }
    CoreManagement.ArchivePersonalizedPromotion = ArchivePersonalizedPromotion;
    /**
     * Archive a point awarding rule
     *
     * @export
     * @class ArchivePointAwardingRule
     * @implements {EvaService}
     */
    class ArchivePointAwardingRule {
        name = 'CoreManagement:ArchivePointAwardingRule';
        path = '/message/ArchivePointAwardingRule';
        request;
        response;
    }
    CoreManagement.ArchivePointAwardingRule = ArchivePointAwardingRule;
    /**
     * Archive the user bought product.
     *
     * @export
     * @class ArchiveUserBoughtProduct
     * @implements {EvaService}
     */
    class ArchiveUserBoughtProduct {
        name = 'CoreManagement:ArchiveUserBoughtProduct';
        path = '/message/ArchiveUserBoughtProduct';
        request;
        response;
    }
    CoreManagement.ArchiveUserBoughtProduct = ArchiveUserBoughtProduct;
    /**
     * Attach an assortment to specified organization units or -set
     *
     * @export
     * @class AttachAssortmentToOrganizationUnit
     * @implements {EvaService}
     */
    class AttachAssortmentToOrganizationUnit {
        name = 'CoreManagement:AttachAssortmentToOrganizationUnit';
        path = '/message/AttachAssortmentToOrganizationUnit';
        request;
        response;
    }
    CoreManagement.AttachAssortmentToOrganizationUnit = AttachAssortmentToOrganizationUnit;
    /**
     * Attach blob to case.
     *
     * @export
     * @class AttachBlobToCase
     * @implements {EvaService}
     */
    class AttachBlobToCase {
        name = 'CoreManagement:AttachBlobToCase';
        path = '/message/AttachBlobToCase';
        request;
        response;
    }
    CoreManagement.AttachBlobToCase = AttachBlobToCase;
    /**
     * Attach functionalities to a role.
     *
     * @export
     * @class AttachFunctionalitiesToRole
     * @implements {EvaService}
     */
    class AttachFunctionalitiesToRole {
        name = 'CoreManagement:AttachFunctionalitiesToRole';
        path = '/message/AttachFunctionalitiesToRole';
        request;
        response;
    }
    CoreManagement.AttachFunctionalitiesToRole = AttachFunctionalitiesToRole;
    /**
     * Attach a loyalty program to an order
     *
     * @export
     * @class AttachLoyaltyProgramToOrder
     * @implements {EvaService}
     */
    class AttachLoyaltyProgramToOrder {
        name = 'CoreManagement:AttachLoyaltyProgramToOrder';
        path = '/message/AttachLoyaltyProgramToOrder';
        request;
        response;
    }
    CoreManagement.AttachLoyaltyProgramToOrder = AttachLoyaltyProgramToOrder;
    /**
     * Resets the Financial Periods for given OU and all children to which the auditing provider applies. **Use with care!**
     *
     * @export
     * @class AuditingResetFinancialPeriods
     * @implements {EvaService}
     */
    class AuditingResetFinancialPeriods {
        name = 'CoreManagement:AuditingResetFinancialPeriods';
        path = '/message/AuditingResetFinancialPeriods';
        request;
        response;
    }
    CoreManagement.AuditingResetFinancialPeriods = AuditingResetFinancialPeriods;
    /**
     * Update the private key version and reset the auditing chain.
     *
     * @export
     * @class AuditingSetPrivateKey
     * @implements {EvaService}
     */
    class AuditingSetPrivateKey {
        name = 'CoreManagement:AuditingSetPrivateKey';
        path = '/message/AuditingSetPrivateKey';
        request;
        response;
    }
    CoreManagement.AuditingSetPrivateKey = AuditingSetPrivateKey;
    /**
     * Auditing service for uploading your public and private key configuration
     *
     * @export
     * @class AuditingUploadKeySet
     * @implements {EvaService}
     */
    class AuditingUploadKeySet {
        name = 'CoreManagement:AuditingUploadKeySet';
        path = '/message/AuditingUploadKeySet';
        request;
        response;
    }
    CoreManagement.AuditingUploadKeySet = AuditingUploadKeySet;
    /**
     * Validates the current settings and properties of an auditing provider.
     *
     * @export
     * @class AuditingValidateConfiguration
     * @implements {EvaService}
     */
    class AuditingValidateConfiguration {
        name = 'CoreManagement:AuditingValidateConfiguration';
        path = '/message/AuditingValidateConfiguration';
        request;
        response;
    }
    CoreManagement.AuditingValidateConfiguration = AuditingValidateConfiguration;
    /**
     * Block a users subscription without unsubscribing.
     *
     * @export
     * @class BlockUserSubscription
     * @implements {EvaService}
     */
    class BlockUserSubscription {
        name = 'CoreManagement:BlockUserSubscription';
        path = '/message/BlockUserSubscription';
        request;
        response;
    }
    CoreManagement.BlockUserSubscription = BlockUserSubscription;
    /**
     * Returns the product count within the persisted product search template
When product id is given, it wil checks if a product is part of the persisted product search template result.
NOTE THAT after product search template creation/update if can take a few minutes for the result to be updated.
     *
     * @export
     * @class CheckProductSearchTemplate
     * @implements {EvaService}
     */
    class CheckProductSearchTemplate {
        name = 'CoreManagement:CheckProductSearchTemplate';
        path = '/message/CheckProductSearchTemplate';
        request;
        response;
    }
    CoreManagement.CheckProductSearchTemplate = CheckProductSearchTemplate;
    /**
     * Removes all unused settings. Set ReportOnly to let this service return all settings that would be deleted.
     *
     * @export
     * @class CleanupSettings
     * @implements {EvaService}
     */
    class CleanupSettings {
        name = 'CoreManagement:CleanupSettings';
        path = '/message/CleanupSettings';
        request;
        response;
    }
    CoreManagement.CleanupSettings = CleanupSettings;
    /**
     * Removes all untyped settings. Set ReportOnly to let this service return all settings that would be deleted.
     *
     * @export
     * @class CleanupUntypedSettings
     * @implements {EvaService}
     */
    class CleanupUntypedSettings {
        name = 'CoreManagement:CleanupUntypedSettings';
        path = '/message/CleanupUntypedSettings';
        request;
        response;
    }
    CoreManagement.CleanupUntypedSettings = CleanupUntypedSettings;
    /**
     * -
     *
     * @export
     * @class CorrectProductCostPriceLedgers
     * @implements {EvaService}
     */
    class CorrectProductCostPriceLedgers {
        name = 'CoreManagement:CorrectProductCostPriceLedgers';
        path = '/message/CorrectProductCostPriceLedgers';
        request;
        response;
    }
    CoreManagement.CorrectProductCostPriceLedgers = CorrectProductCostPriceLedgers;
    /**
     * Create a new Account to be used in Cookbook. Name and ObjectAccount are required.
     *
     * @export
     * @class CreateAccount
     * @implements {EvaService}
     */
    class CreateAccount {
        name = 'CoreManagement:CreateAccount';
        path = '/message/CreateAccount';
        request;
        response;
    }
    CoreManagement.CreateAccount = CreateAccount;
    /**
     * Create a new assortment.
You can provide either OrganizationUnitIDs or and OrganizationUnitSetID (which will translate to OrganizationUnitIDs) to be attached to the assortment that is being created.
OrganizationUnitIDs will take precedence over OrganizationUnitSetID.
     *
     * @export
     * @class CreateAssortment
     * @implements {EvaService}
     */
    class CreateAssortment {
        name = 'CoreManagement:CreateAssortment';
        path = '/message/CreateAssortment';
        request;
        response;
    }
    CoreManagement.CreateAssortment = CreateAssortment;
    /**
     * Create a new Carrier
     *
     * @export
     * @class CreateCarrier
     * @implements {EvaService}
     */
    class CreateCarrier {
        name = 'CoreManagement:CreateCarrier';
        path = '/message/CreateCarrier';
        request;
        response;
    }
    CoreManagement.CreateCarrier = CreateCarrier;
    /**
     * Create a new case.
     *
     * @export
     * @class CreateCase
     * @implements {EvaService}
     */
    class CreateCase {
        name = 'CoreManagement:CreateCase';
        path = '/message/CreateCase';
        request;
        response;
    }
    CoreManagement.CreateCase = CreateCase;
    /**
     * Creates a new case interaction
     *
     * @export
     * @class CreateCaseInteraction
     * @implements {EvaService}
     */
    class CreateCaseInteraction {
        name = 'CoreManagement:CreateCaseInteraction';
        path = '/message/CreateCaseInteraction';
        request;
        response;
    }
    CoreManagement.CreateCaseInteraction = CreateCaseInteraction;
    /**
     * Creates a new case status
     *
     * @export
     * @class CreateCaseStatus
     * @implements {EvaService}
     */
    class CreateCaseStatus {
        name = 'CoreManagement:CreateCaseStatus';
        path = '/message/CreateCaseStatus';
        request;
        response;
    }
    CoreManagement.CreateCaseStatus = CreateCaseStatus;
    /**
     * Creates a new case topic
     *
     * @export
     * @class CreateCaseTopic
     * @implements {EvaService}
     */
    class CreateCaseTopic {
        name = 'CoreManagement:CreateCaseTopic';
        path = '/message/CreateCaseTopic';
        request;
        response;
    }
    CoreManagement.CreateCaseTopic = CreateCaseTopic;
    /**
     * Creates a new cash expense type.
It's not possible to create a cash expense type with a name that is already in use.

The amount type specifies whether or not this type can be used to also register positive 'expenses' (so: income).
An example of this might be tips left by a customer.
     *
     * @export
     * @class CreateCashExpenseType
     * @implements {EvaService}
     */
    class CreateCashExpenseType {
        name = 'CoreManagement:CreateCashExpenseType';
        path = '/message/CreateCashExpenseType';
        request;
        response;
    }
    CoreManagement.CreateCashExpenseType = CreateCashExpenseType;
    /**
     * Create a new CashHandler
     *
     * @export
     * @class CreateCashHandler
     * @implements {EvaService}
     */
    class CreateCashHandler {
        name = 'CoreManagement:CreateCashHandler';
        path = '/message/CreateCashHandler';
        request;
        response;
    }
    CoreManagement.CreateCashHandler = CreateCashHandler;
    /**
     * Create a new CheckoutOption
     *
     * @export
     * @class CreateCheckoutOption
     * @implements {EvaService}
     */
    class CreateCheckoutOption {
        name = 'CoreManagement:CreateCheckoutOption';
        path = '/message/CreateCheckoutOption';
        request;
        response;
    }
    CoreManagement.CreateCheckoutOption = CreateCheckoutOption;
    /**
     * Create a new CheckoutOptionCategory
     *
     * @export
     * @class CreateCheckoutOptionCategory
     * @implements {EvaService}
     */
    class CreateCheckoutOptionCategory {
        name = 'CoreManagement:CreateCheckoutOptionCategory';
        path = '/message/CreateCheckoutOptionCategory';
        request;
        response;
    }
    CoreManagement.CreateCheckoutOptionCategory = CreateCheckoutOptionCategory;
    /**
     * Create a new ClientApplication.
     *
     * @export
     * @class CreateClientApplication
     * @implements {EvaService}
     */
    class CreateClientApplication {
        name = 'CoreManagement:CreateClientApplication';
        path = '/message/CreateClientApplication';
        request;
        response;
    }
    CoreManagement.CreateClientApplication = CreateClientApplication;
    /**
     * Creates a new Company, which represents a legal entity in EVA. Both Users and OrganizationUnits can have a Company that they are a part of.
     *
     * @export
     * @class CreateCompany
     * @implements {EvaService}
     */
    class CreateCompany {
        name = 'CoreManagement:CreateCompany';
        path = '/message/CreateCompany';
        request;
        response;
    }
    CoreManagement.CreateCompany = CreateCompany;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateCostPriceCalculation
     * @implements {EvaService}
     */
    class CreateCostPriceCalculation {
        name = 'CoreManagement:CreateCostPriceCalculation';
        path = '/message/CreateCostPriceCalculation';
        request;
        response;
    }
    CoreManagement.CreateCostPriceCalculation = CreateCostPriceCalculation;
    /**
     * Create a new Culture
     *
     * @export
     * @class CreateCulture
     * @implements {EvaService}
     */
    class CreateCulture {
        name = 'CoreManagement:CreateCulture';
        path = '/message/CreateCulture';
        request;
        response;
    }
    CoreManagement.CreateCulture = CreateCulture;
    /**
     * Create a new custom field.
     *
     * @export
     * @class CreateCustomField
     * @implements {EvaService}
     */
    class CreateCustomField {
        name = 'CoreManagement:CreateCustomField';
        path = '/message/CreateCustomField';
        request;
        response;
    }
    CoreManagement.CreateCustomField = CreateCustomField;
    /**
     * Create a new device
     *
     * @export
     * @class CreateDevice
     * @implements {EvaService}
     */
    class CreateDevice {
        name = 'CoreManagement:CreateDevice';
        path = '/message/CreateDevice';
        request;
        response;
    }
    CoreManagement.CreateDevice = CreateDevice;
    /**
     * Create a new discount
     *
     * @export
     * @class CreateDiscount
     * @implements {EvaService}
     */
    class CreateDiscount {
        name = 'CoreManagement:CreateDiscount';
        path = '/message/CreateDiscount';
        request;
        response;
    }
    CoreManagement.CreateDiscount = CreateDiscount;
    /**
     * Create a new DiscountCampaign
     *
     * @export
     * @class CreateDiscountCampaign
     * @implements {EvaService}
     */
    class CreateDiscountCampaign {
        name = 'CoreManagement:CreateDiscountCampaign';
        path = '/message/CreateDiscountCampaign';
        request;
        response;
    }
    CoreManagement.CreateDiscountCampaign = CreateDiscountCampaign;
    /**
     * Create a DiscountCoupon
     *
     * @export
     * @class CreateDiscountCoupon
     * @implements {EvaService}
     */
    class CreateDiscountCoupon {
        name = 'CoreManagement:CreateDiscountCoupon';
        path = '/message/CreateDiscountCoupon';
        request;
        response;
    }
    CoreManagement.CreateDiscountCoupon = CreateDiscountCoupon;
    /**
     * Create a discount from the given template with the overwrites with the values given in the request.
     *
     * @export
     * @class CreateDiscountFromTemplate
     * @implements {EvaService}
     */
    class CreateDiscountFromTemplate {
        name = 'CoreManagement:CreateDiscountFromTemplate';
        path = '/message/CreateDiscountFromTemplate';
        request;
        response;
    }
    CoreManagement.CreateDiscountFromTemplate = CreateDiscountFromTemplate;
    /**
     * Create a new DiscountLayer
     *
     * @export
     * @class CreateDiscountLayer
     * @implements {EvaService}
     */
    class CreateDiscountLayer {
        name = 'CoreManagement:CreateDiscountLayer';
        path = '/message/CreateDiscountLayer';
        request;
        response;
    }
    CoreManagement.CreateDiscountLayer = CreateDiscountLayer;
    /**
     * Create a new discount template
     *
     * @export
     * @class CreateDiscountTemplate
     * @implements {EvaService}
     */
    class CreateDiscountTemplate {
        name = 'CoreManagement:CreateDiscountTemplate';
        path = '/message/CreateDiscountTemplate';
        request;
        response;
    }
    CoreManagement.CreateDiscountTemplate = CreateDiscountTemplate;
    /**
     * Create a new Employee
     *
     * @export
     * @class CreateEmployeeUser
     * @implements {EvaService}
     */
    class CreateEmployeeUser {
        name = 'CoreManagement:CreateEmployeeUser';
        path = '/message/CreateEmployeeUser';
        request;
        response;
    }
    CoreManagement.CreateEmployeeUser = CreateEmployeeUser;
    /**
     * Create endpoint configurations.

Endpoint Configurations allow you to configure specific endpoints taht can be used for example for EventExportConfigurations.

- Make sure to catch & store the `SecretKey1` and `SecretKey2`, as there will be no other way of retrieving them after this service call!
     *
     * @export
     * @class CreateEndpointConfiguration
     * @implements {EvaService}
     */
    class CreateEndpointConfiguration {
        name = 'CoreManagement:CreateEndpointConfiguration';
        path = '/message/CreateEndpointConfiguration';
        request;
        response;
    }
    CoreManagement.CreateEndpointConfiguration = CreateEndpointConfiguration;
    /**
     * Create a new entity field validator
     *
     * @export
     * @class CreateEntityFieldValidator
     * @implements {EvaService}
     */
    class CreateEntityFieldValidator {
        name = 'CoreManagement:CreateEntityFieldValidator';
        path = '/message/CreateEntityFieldValidator';
        request;
        response;
    }
    CoreManagement.CreateEntityFieldValidator = CreateEntityFieldValidator;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateFraudItem
     * @implements {EvaService}
     */
    class CreateFraudItem {
        name = 'CoreManagement:CreateFraudItem';
        path = '/message/CreateFraudItem';
        request;
        response;
    }
    CoreManagement.CreateFraudItem = CreateFraudItem;
    /**
     * Create a new GiftCardConfiguration
     *
     * @export
     * @class CreateGiftCardConfiguration
     * @implements {EvaService}
     */
    class CreateGiftCardConfiguration {
        name = 'CoreManagement:CreateGiftCardConfiguration';
        path = '/message/CreateGiftCardConfiguration';
        request;
        response;
    }
    CoreManagement.CreateGiftCardConfiguration = CreateGiftCardConfiguration;
    /**
     * Creates a new PIN login for current user.

This PIN will only be valid for a limited amount of time, and only for the provided `OrganizationUnitID` (or your current organization unit if left null).
     *
     * @export
     * @class CreateIdentificationPinForEmployee
     * @implements {EvaService}
     */
    class CreateIdentificationPinForEmployee {
        name = 'CoreManagement:CreateIdentificationPinForEmployee';
        path = '/message/CreateIdentificationPinForEmployee';
        request;
        response;
    }
    CoreManagement.CreateIdentificationPinForEmployee = CreateIdentificationPinForEmployee;
    /**
     * Creates a new inquiry
     *
     * @export
     * @class CreateInquiry
     * @implements {EvaService}
     */
    class CreateInquiry {
        name = 'CoreManagement:CreateInquiry';
        path = '/message/CreateInquiry';
        request;
        response;
    }
    CoreManagement.CreateInquiry = CreateInquiry;
    /**
     * Creates an inquiry item
     *
     * @export
     * @class CreateInquiryItem
     * @implements {EvaService}
     */
    class CreateInquiryItem {
        name = 'CoreManagement:CreateInquiryItem';
        path = '/message/CreateInquiryItem';
        request;
        response;
    }
    CoreManagement.CreateInquiryItem = CreateInquiryItem;
    /**
     * Create a new LoyaltyProgram
     *
     * @export
     * @class CreateLoyaltyProgram
     * @implements {EvaService}
     */
    class CreateLoyaltyProgram {
        name = 'CoreManagement:CreateLoyaltyProgram';
        path = '/message/CreateLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.CreateLoyaltyProgram = CreateLoyaltyProgram;
    /**
     * Create a new LoyaltyProgramCondition
     *
     * @export
     * @class CreateLoyaltyProgramCondition
     * @implements {EvaService}
     */
    class CreateLoyaltyProgramCondition {
        name = 'CoreManagement:CreateLoyaltyProgramCondition';
        path = '/message/CreateLoyaltyProgramCondition';
        request;
        response;
    }
    CoreManagement.CreateLoyaltyProgramCondition = CreateLoyaltyProgramCondition;
    /**
     * Create a new LoyaltyProgramGroup
     *
     * @export
     * @class CreateLoyaltyProgramGroup
     * @implements {EvaService}
     */
    class CreateLoyaltyProgramGroup {
        name = 'CoreManagement:CreateLoyaltyProgramGroup';
        path = '/message/CreateLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.CreateLoyaltyProgramGroup = CreateLoyaltyProgramGroup;
    /**
     * Create a new LoyaltyProgramPaymentType
     *
     * @export
     * @class CreateLoyaltyProgramPaymentType
     * @implements {EvaService}
     */
    class CreateLoyaltyProgramPaymentType {
        name = 'CoreManagement:CreateLoyaltyProgramPaymentType';
        path = '/message/CreateLoyaltyProgramPaymentType';
        request;
        response;
    }
    CoreManagement.CreateLoyaltyProgramPaymentType = CreateLoyaltyProgramPaymentType;
    /**
     * Create a loyalty program product limitation.
     *
     * @export
     * @class CreateLoyaltyProgramProductLimitation
     * @implements {EvaService}
     */
    class CreateLoyaltyProgramProductLimitation {
        name = 'CoreManagement:CreateLoyaltyProgramProductLimitation';
        path = '/message/CreateLoyaltyProgramProductLimitation';
        request;
        response;
    }
    CoreManagement.CreateLoyaltyProgramProductLimitation = CreateLoyaltyProgramProductLimitation;
    /**
     * Create a new MessageTemplate
     *
     * @export
     * @class CreateMessageTemplate
     * @implements {EvaService}
     */
    class CreateMessageTemplate {
        name = 'CoreManagement:CreateMessageTemplate';
        path = '/message/CreateMessageTemplate';
        request;
        response;
    }
    CoreManagement.CreateMessageTemplate = CreateMessageTemplate;
    /**
     * Creates a new OpenCashDrawerReason. Name and Description can both be localized through the LocalizeOpenCashDrawerReason service later.
     *
     * @export
     * @class CreateOpenCashDrawerReason
     * @implements {EvaService}
     */
    class CreateOpenCashDrawerReason {
        name = 'CoreManagement:CreateOpenCashDrawerReason';
        path = '/message/CreateOpenCashDrawerReason';
        request;
        response;
    }
    CoreManagement.CreateOpenCashDrawerReason = CreateOpenCashDrawerReason;
    /**
     * Create a new OpeningHoursType
     *
     * @export
     * @class CreateOpeningHoursType
     * @implements {EvaService}
     */
    class CreateOpeningHoursType {
        name = 'CoreManagement:CreateOpeningHoursType';
        path = '/message/CreateOpeningHoursType';
        request;
        response;
    }
    CoreManagement.CreateOpeningHoursType = CreateOpeningHoursType;
    /**
     * Create or update a users employee data.
     *
     * @export
     * @class CreateOrUpdateEmployeeData
     * @implements {EvaService}
     */
    class CreateOrUpdateEmployeeData {
        name = 'CoreManagement:CreateOrUpdateEmployeeData';
        path = '/message/CreateOrUpdateEmployeeData';
        request;
        response;
    }
    CoreManagement.CreateOrUpdateEmployeeData = CreateOrUpdateEmployeeData;
    /**
     * Create or update OrganizationUnitSetPaymentType

A PaymentType, OrganizationUnitSet and RefundPriority are required

When this OrganizationUnitSet doesn't have this PaymentType yet, it will be created. If it already exists the fields will be updated.
     *
     * @export
     * @class CreateOrUpdateOrganizationUnitSetPaymentType
     * @implements {EvaService}
     */
    class CreateOrUpdateOrganizationUnitSetPaymentType {
        name = 'CoreManagement:CreateOrUpdateOrganizationUnitSetPaymentType';
        path = '/message/CreateOrUpdateOrganizationUnitSetPaymentType';
        request;
        response;
    }
    CoreManagement.CreateOrUpdateOrganizationUnitSetPaymentType = CreateOrUpdateOrganizationUnitSetPaymentType;
    /**
     * Adds one set (`SubsetID`) as the subset of another set (`SetID`).
  If this subset relation already exists, the type is updated.

  The Type determines whether the relation is additive or subtractive.
  If it's additive, the SubsetID and and all its subsets (recursively) becomes part of this set.

  If it's subtractive, the SubsetID and all its subsets will not be part of this set.
     *
     * @export
     * @class CreateOrUpdateOrganizationUnitSubset
     * @implements {EvaService}
     */
    class CreateOrUpdateOrganizationUnitSubset {
        name = 'CoreManagement:CreateOrUpdateOrganizationUnitSubset';
        path = '/message/CreateOrUpdateOrganizationUnitSubset';
        request;
        response;
    }
    CoreManagement.CreateOrUpdateOrganizationUnitSubset = CreateOrUpdateOrganizationUnitSubset;
    /**
     * Create or update a VisibilityGroup to VisibilityGroup configuration.
     *
     * @export
     * @class CreateOrUpdateVisibilityGroupConfiguration
     * @implements {EvaService}
     */
    class CreateOrUpdateVisibilityGroupConfiguration {
        name = 'CoreManagement:CreateOrUpdateVisibilityGroupConfiguration';
        path = '/message/CreateOrUpdateVisibilityGroupConfiguration';
        request;
        response;
    }
    CoreManagement.CreateOrUpdateVisibilityGroupConfiguration = CreateOrUpdateVisibilityGroupConfiguration;
    /**
     * Create custom "OrderLedgerType"
     *
     * @export
     * @class CreateOrderLedgerType
     * @implements {EvaService}
     */
    class CreateOrderLedgerType {
        name = 'CoreManagement:CreateOrderLedgerType';
        path = '/message/CreateOrderLedgerType';
        request;
        response;
    }
    CoreManagement.CreateOrderLedgerType = CreateOrderLedgerType;
    /**
     * Create an organization unit country
     *
     * @export
     * @class CreateOrganizationUnitCountry
     * @implements {EvaService}
     */
    class CreateOrganizationUnitCountry {
        name = 'CoreManagement:CreateOrganizationUnitCountry';
        path = '/message/CreateOrganizationUnitCountry';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitCountry = CreateOrganizationUnitCountry;
    /**
     * Create a new additional currency for an OrganizationUnit

It is required to define the CashHandler
     *
     * @export
     * @class CreateOrganizationUnitCurrency
     * @implements {EvaService}
     */
    class CreateOrganizationUnitCurrency {
        name = 'CoreManagement:CreateOrganizationUnitCurrency';
        path = '/message/CreateOrganizationUnitCurrency';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitCurrency = CreateOrganizationUnitCurrency;
    /**
     * Attach a language directly to an organization unit.
     *
     * @export
     * @class CreateOrganizationUnitLanguage
     * @implements {EvaService}
     */
    class CreateOrganizationUnitLanguage {
        name = 'CoreManagement:CreateOrganizationUnitLanguage';
        path = '/message/CreateOrganizationUnitLanguage';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitLanguage = CreateOrganizationUnitLanguage;
    /**
     * Create new OpeningHours for OrganizationUnits

Multiple items can be created in a single request. Also multiple OrganizationUnits are allowed.

It's not allowed to create multiple items for a single day on the same store. This is checked for Day based openinghours and Date based openinghours.

Openinghours wit a Date component override the openinghours on Day level. They are called SpecialOpeningHours most of the time.

To close a store on a regular day, just don't create an openinghour for that day (or delete it).
To close a store on a specific date, create an openinghour with StartTime=null, EndTime=null
     *
     * @export
     * @class CreateOrganizationUnitOpeningHours
     * @implements {EvaService}
     */
    class CreateOrganizationUnitOpeningHours {
        name = 'CoreManagement:CreateOrganizationUnitOpeningHours';
        path = '/message/CreateOrganizationUnitOpeningHours';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitOpeningHours = CreateOrganizationUnitOpeningHours;
    /**
     * Creates a new `OrganizationUnitSet`.

  Optionally a definition can be provided, which defines a set of filters.
  Any `OrganizationUnit` that matches the filters are automatically part of the set.

  If a definition is provided without any filters, it's ignored.

  The ScopeID refers to an `OrganizationUnitSetScope` and can be used to create collections of sets for specific purposes, such as discounts.
     *
     * @export
     * @class CreateOrganizationUnitSet
     * @implements {EvaService}
     */
    class CreateOrganizationUnitSet {
        name = 'CoreManagement:CreateOrganizationUnitSet';
        path = '/message/CreateOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitSet = CreateOrganizationUnitSet;
    /**
     * Creates a new OrganizationUnitSetScope.

When OrganizationUnitUniqueInScope is specified as true, then a single OrganizationUnit can only occur once
among all OrganizationUnitSets that have this scope.
     *
     * @export
     * @class CreateOrganizationUnitSetScope
     * @implements {EvaService}
     */
    class CreateOrganizationUnitSetScope {
        name = 'CoreManagement:CreateOrganizationUnitSetScope';
        path = '/message/CreateOrganizationUnitSetScope';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitSetScope = CreateOrganizationUnitSetScope;
    /**
     * Create an OrganizationUnitShippingMethod

A ShippingMethod, OrganizationUnit and Priority are required
     *
     * @export
     * @class CreateOrganizationUnitShippingMethod
     * @implements {EvaService}
     */
    class CreateOrganizationUnitShippingMethod {
        name = 'CoreManagement:CreateOrganizationUnitShippingMethod';
        path = '/message/CreateOrganizationUnitShippingMethod';
        request;
        response;
    }
    CoreManagement.CreateOrganizationUnitShippingMethod = CreateOrganizationUnitShippingMethod;
    /**
     * Create a new package, with dimensions in millimeters (mm) and weight in grams (g).
     *
     * @export
     * @class CreatePackage
     * @implements {EvaService}
     */
    class CreatePackage {
        name = 'CoreManagement:CreatePackage';
        path = '/message/CreatePackage';
        request;
        response;
    }
    CoreManagement.CreatePackage = CreatePackage;
    /**
     * Create a new custom PaymentMethod.
     *
     * @export
     * @class CreatePaymentMethod
     * @implements {EvaService}
     */
    class CreatePaymentMethod {
        name = 'CoreManagement:CreatePaymentMethod';
        path = '/message/CreatePaymentMethod';
        request;
        response;
    }
    CoreManagement.CreatePaymentMethod = CreatePaymentMethod;
    /**
     * Create a new PaymentTransactionLedgerType
     *
     * @export
     * @class CreatePaymentTransactionLedgerType
     * @implements {EvaService}
     */
    class CreatePaymentTransactionLedgerType {
        name = 'CoreManagement:CreatePaymentTransactionLedgerType';
        path = '/message/CreatePaymentTransactionLedgerType';
        request;
        response;
    }
    CoreManagement.CreatePaymentTransactionLedgerType = CreatePaymentTransactionLedgerType;
    /**
     * Create a new PaymentType.
     *
     * @export
     * @class CreatePaymentType
     * @implements {EvaService}
     */
    class CreatePaymentType {
        name = 'CoreManagement:CreatePaymentType';
        path = '/message/CreatePaymentType';
        request;
        response;
    }
    CoreManagement.CreatePaymentType = CreatePaymentType;
    /**
     * Create a new personalized promotion.
     *
     * @export
     * @class CreatePersonalizedPromotion
     * @implements {EvaService}
     */
    class CreatePersonalizedPromotion {
        name = 'CoreManagement:CreatePersonalizedPromotion';
        path = '/message/CreatePersonalizedPromotion';
        request;
        response;
    }
    CoreManagement.CreatePersonalizedPromotion = CreatePersonalizedPromotion;
    /**
     * Create a point awarding rule.
     *
     * @export
     * @class CreatePointAwardingRule
     * @implements {EvaService}
     */
    class CreatePointAwardingRule {
        name = 'CoreManagement:CreatePointAwardingRule';
        path = '/message/CreatePointAwardingRule';
        request;
        response;
    }
    CoreManagement.CreatePointAwardingRule = CreatePointAwardingRule;
    /**
     * Create a new PriceList
     *
     * @export
     * @class CreatePriceList
     * @implements {EvaService}
     */
    class CreatePriceList {
        name = 'CoreManagement:CreatePriceList';
        path = '/message/CreatePriceList';
        request;
        response;
    }
    CoreManagement.CreatePriceList = CreatePriceList;
    /**
     * Create a new PriceListAdjustment
     *
     * @export
     * @class CreatePriceListAdjustment
     * @implements {EvaService}
     */
    class CreatePriceListAdjustment {
        name = 'CoreManagement:CreatePriceListAdjustment';
        path = '/message/CreatePriceListAdjustment';
        request;
        response;
    }
    CoreManagement.CreatePriceListAdjustment = CreatePriceListAdjustment;
    /**
     * Create a new PriceListManualInputAdjustment
     *
     * @export
     * @class CreatePriceListManualInputAdjustment
     * @implements {EvaService}
     */
    class CreatePriceListManualInputAdjustment {
        name = 'CoreManagement:CreatePriceListManualInputAdjustment';
        path = '/message/CreatePriceListManualInputAdjustment';
        request;
        response;
    }
    CoreManagement.CreatePriceListManualInputAdjustment = CreatePriceListManualInputAdjustment;
    /**
     * Create a new PriceListOrganizationUnit
     *
     * @export
     * @class CreatePriceListOrganizationUnit
     * @implements {EvaService}
     */
    class CreatePriceListOrganizationUnit {
        name = 'CoreManagement:CreatePriceListOrganizationUnit';
        path = '/message/CreatePriceListOrganizationUnit';
        request;
        response;
    }
    CoreManagement.CreatePriceListOrganizationUnit = CreatePriceListOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreatePriceListUsageType
     * @implements {EvaService}
     */
    class CreatePriceListUsageType {
        name = 'CoreManagement:CreatePriceListUsageType';
        path = '/message/CreatePriceListUsageType';
        request;
        response;
    }
    CoreManagement.CreatePriceListUsageType = CreatePriceListUsageType;
    /**
     * Creates a printer type
     *
     * @export
     * @class CreatePrinterType
     * @implements {EvaService}
     */
    class CreatePrinterType {
        name = 'CoreManagement:CreatePrinterType';
        path = '/message/CreatePrinterType';
        request;
        response;
    }
    CoreManagement.CreatePrinterType = CreatePrinterType;
    /**
     * Creates a barcode for a product for a specific unit of measure.

Optionally adds a record in the ProductUnitOfMeasure conversion table for the supplied Quantity.
     *
     * @export
     * @class CreateProductBarcode
     * @implements {EvaService}
     */
    class CreateProductBarcode {
        name = 'CoreManagement:CreateProductBarcode';
        path = '/message/CreateProductBarcode';
        request;
        response;
    }
    CoreManagement.CreateProductBarcode = CreateProductBarcode;
    /**
     * Create a new ProductGiftCard
     *
     * @export
     * @class CreateProductGiftCard
     * @implements {EvaService}
     */
    class CreateProductGiftCard {
        name = 'CoreManagement:CreateProductGiftCard';
        path = '/message/CreateProductGiftCard';
        request;
        response;
    }
    CoreManagement.CreateProductGiftCard = CreateProductGiftCard;
    /**
     * Create a new Product Requirement
     *
     * @export
     * @class CreateProductRequirement
     * @implements {EvaService}
     */
    class CreateProductRequirement {
        name = 'CoreManagement:CreateProductRequirement';
        path = '/message/CreateProductRequirement';
        request;
        response;
    }
    CoreManagement.CreateProductRequirement = CreateProductRequirement;
    /**
     * Create a new ProductSearchTemplate
     *
     * @export
     * @class CreateProductSearchTemplate
     * @implements {EvaService}
     */
    class CreateProductSearchTemplate {
        name = 'CoreManagement:CreateProductSearchTemplate';
        path = '/message/CreateProductSearchTemplate';
        request;
        response;
    }
    CoreManagement.CreateProductSearchTemplate = CreateProductSearchTemplate;
    /**
     * Create a new ProductUnitOfMeasure
     *
     * @export
     * @class CreateProductUnitOfMeasure
     * @implements {EvaService}
     */
    class CreateProductUnitOfMeasure {
        name = 'CoreManagement:CreateProductUnitOfMeasure';
        path = '/message/CreateProductUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.CreateProductUnitOfMeasure = CreateProductUnitOfMeasure;
    /**
     * Creates a new refund reason.
     *
     * @export
     * @class CreateRefundCorrectionReason
     * @implements {EvaService}
     */
    class CreateRefundCorrectionReason {
        name = 'CoreManagement:CreateRefundCorrectionReason';
        path = '/message/CreateRefundCorrectionReason';
        request;
        response;
    }
    CoreManagement.CreateRefundCorrectionReason = CreateRefundCorrectionReason;
    /**
     * Create a return reason
     *
     * @export
     * @class CreateReturnReason
     * @implements {EvaService}
     */
    class CreateReturnReason {
        name = 'CoreManagement:CreateReturnReason';
        path = '/message/CreateReturnReason';
        request;
        response;
    }
    CoreManagement.CreateReturnReason = CreateReturnReason;
    /**
     * Create a new role.
     *
     * @export
     * @class CreateRole
     * @implements {EvaService}
     */
    class CreateRole {
        name = 'CoreManagement:CreateRole';
        path = '/message/CreateRole';
        request;
        response;
    }
    CoreManagement.CreateRole = CreateRole;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class CreateRoleSet
     * @implements {EvaService}
     */
    class CreateRoleSet {
        name = 'CoreManagement:CreateRoleSet';
        path = '/message/CreateRoleSet';
        request;
        response;
    }
    CoreManagement.CreateRoleSet = CreateRoleSet;
    /**
     * Create a `ShippingCost`
     *
     * @export
     * @class CreateShippingCost
     * @implements {EvaService}
     */
    class CreateShippingCost {
        name = 'CoreManagement:CreateShippingCost';
        path = '/message/CreateShippingCost';
        request;
        response;
    }
    CoreManagement.CreateShippingCost = CreateShippingCost;
    /**
     * Create a new ShippingMethod
     *
     * @export
     * @class CreateShippingMethod
     * @implements {EvaService}
     */
    class CreateShippingMethod {
        name = 'CoreManagement:CreateShippingMethod';
        path = '/message/CreateShippingMethod';
        request;
        response;
    }
    CoreManagement.CreateShippingMethod = CreateShippingMethod;
    /**
     * Creates a new ShippingMethodTransportationTime.
     *
     * @export
     * @class CreateShippingMethodTransportationTime
     * @implements {EvaService}
     */
    class CreateShippingMethodTransportationTime {
        name = 'CoreManagement:CreateShippingMethodTransportationTime';
        path = '/message/CreateShippingMethodTransportationTime';
        request;
        response;
    }
    CoreManagement.CreateShippingMethodTransportationTime = CreateShippingMethodTransportationTime;
    /**
     * Creates a new ShippingRestriction.
     *
     * @export
     * @class CreateShippingRestriction
     * @implements {EvaService}
     */
    class CreateShippingRestriction {
        name = 'CoreManagement:CreateShippingRestriction';
        path = '/message/CreateShippingRestriction';
        request;
        response;
    }
    CoreManagement.CreateShippingRestriction = CreateShippingRestriction;
    /**
     * Create a new station for an OrganizationUnit.
     *
     * @export
     * @class CreateStation
     * @implements {EvaService}
     */
    class CreateStation {
        name = 'CoreManagement:CreateStation';
        path = '/message/CreateStation';
        request;
        response;
    }
    CoreManagement.CreateStation = CreateStation;
    /**
     * Creates a StockAllocationRule for the SupplierOrganizationUnitID and OrganizationUnitID.

- If `ProductID` is left null, this is a 'catch-all' rule, meaning that the rule applies to all products (but it can still be overriden by a rule with a specific `ProductID`).
Only a reservation can be a catch-all rule, a limitation must specify a `ProductID` or a `ProductSearchTemplateID`.
- `RefillPeriodInDays` is ignored when the Type is not a `Limitation`, as only a `Limitation` can be refilled.
- If `ValueType` is `Percentage`, then `Value` must be between 0 and 100.
- `OrganizationUnitSupplierID` is a reference to a supplier relationship between OrganizationUnits, not to an OrganizationUnit.
This is for example the supplier relationship between a warehouse and a store. Available OrganizationUnitSuppliers can be found through `ListOrganizationUnitSuppliers`.
- When left empty, OrganizationUnitID defaults to the OrganizationUnitID on the OrganizationUnitSupplier. So if the supplier relationship is between a warehouse and a store, this will
default to the store. When specified, the OrganizationUnitID *must* be one that the supplier of the relationship *directly* supplies to.
For example, if a supplier relationship exists between a warehouse and a country OrganizationUnit then you *can't* specify a store that falls
under that country OrganizationUnit. In that case, you should create a StockAllocationRule between the country and the store,
not between the warehouse and the store.
     *
     * @export
     * @class CreateStockAllocationRule
     * @implements {EvaService}
     */
    class CreateStockAllocationRule {
        name = 'CoreManagement:CreateStockAllocationRule';
        path = '/message/CreateStockAllocationRule';
        request;
        response;
    }
    CoreManagement.CreateStockAllocationRule = CreateStockAllocationRule;
    /**
     * Create a new StockLabel

Name is required
     *
     * @export
     * @class CreateStockLabel
     * @implements {EvaService}
     */
    class CreateStockLabel {
        name = 'CoreManagement:CreateStockLabel';
        path = '/message/CreateStockLabel';
        request;
        response;
    }
    CoreManagement.CreateStockLabel = CreateStockLabel;
    /**
     * Create a custom stock mutation reason.
     *
     * @export
     * @class CreateStockMutationReason
     * @implements {EvaService}
     */
    class CreateStockMutationReason {
        name = 'CoreManagement:CreateStockMutationReason';
        path = '/message/CreateStockMutationReason';
        request;
        response;
    }
    CoreManagement.CreateStockMutationReason = CreateStockMutationReason;
    /**
     * Create a new Subscription
     *
     * @export
     * @class CreateSubscription
     * @implements {EvaService}
     */
    class CreateSubscription {
        name = 'CoreManagement:CreateSubscription';
        path = '/message/CreateSubscription';
        request;
        response;
    }
    CoreManagement.CreateSubscription = CreateSubscription;
    /**
     * Creates a new SubscriptionOrganizationUnitSet and returns the ID of the new record.
     *
     * @export
     * @class CreateSubscriptionOrganizationUnitSet
     * @implements {EvaService}
     */
    class CreateSubscriptionOrganizationUnitSet {
        name = 'CoreManagement:CreateSubscriptionOrganizationUnitSet';
        path = '/message/CreateSubscriptionOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.CreateSubscriptionOrganizationUnitSet = CreateSubscriptionOrganizationUnitSet;
    /**
     * Create a new SupplierProduct
     *
     * @export
     * @class CreateSupplierProduct
     * @implements {EvaService}
     */
    class CreateSupplierProduct {
        name = 'CoreManagement:CreateSupplierProduct';
        path = '/message/CreateSupplierProduct';
        request;
        response;
    }
    CoreManagement.CreateSupplierProduct = CreateSupplierProduct;
    /**
     * Creates a new survey
     *
     * @export
     * @class CreateSurvey
     * @implements {EvaService}
     */
    class CreateSurvey {
        name = 'CoreManagement:CreateSurvey';
        path = '/message/CreateSurvey';
        request;
        response;
    }
    CoreManagement.CreateSurvey = CreateSurvey;
    /**
     * Creates a new survey
     *
     * @export
     * @class CreateSurveyQuestion
     * @implements {EvaService}
     */
    class CreateSurveyQuestion {
        name = 'CoreManagement:CreateSurveyQuestion';
        path = '/message/CreateSurveyQuestion';
        request;
        response;
    }
    CoreManagement.CreateSurveyQuestion = CreateSurveyQuestion;
    /**
     * Creates a new survey question route
     *
     * @export
     * @class CreateSurveyQuestionRoute
     * @implements {EvaService}
     */
    class CreateSurveyQuestionRoute {
        name = 'CoreManagement:CreateSurveyQuestionRoute';
        path = '/message/CreateSurveyQuestionRoute';
        request;
        response;
    }
    CoreManagement.CreateSurveyQuestionRoute = CreateSurveyQuestionRoute;
    /**
     * Create a new UnitOfMeasure
     *
     * @export
     * @class CreateUnitOfMeasure
     * @implements {EvaService}
     */
    class CreateUnitOfMeasure {
        name = 'CoreManagement:CreateUnitOfMeasure';
        path = '/message/CreateUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.CreateUnitOfMeasure = CreateUnitOfMeasure;
    /**
     * Create a new UnitPriceCorrectionReason
     *
     * @export
     * @class CreateUnitPriceCorrectionReason
     * @implements {EvaService}
     */
    class CreateUnitPriceCorrectionReason {
        name = 'CoreManagement:CreateUnitPriceCorrectionReason';
        path = '/message/CreateUnitPriceCorrectionReason';
        request;
        response;
    }
    CoreManagement.CreateUnitPriceCorrectionReason = CreateUnitPriceCorrectionReason;
    /**
     * Create a new UserOrigin
     *
     * @export
     * @class CreateUserOrigin
     * @implements {EvaService}
     */
    class CreateUserOrigin {
        name = 'CoreManagement:CreateUserOrigin';
        path = '/message/CreateUserOrigin';
        request;
        response;
    }
    CoreManagement.CreateUserOrigin = CreateUserOrigin;
    /**
     * Creates a new UserRequirement and returns the ID of the new record.
     *
     * @export
     * @class CreateUserRequirement
     * @implements {EvaService}
     */
    class CreateUserRequirement {
        name = 'CoreManagement:CreateUserRequirement';
        path = '/message/CreateUserRequirement';
        request;
        response;
    }
    CoreManagement.CreateUserRequirement = CreateUserRequirement;
    /**
     * Creates a new UserRequirementSet and returns the ID of the new record.
     *
     * @export
     * @class CreateUserRequirementSet
     * @implements {EvaService}
     */
    class CreateUserRequirementSet {
        name = 'CoreManagement:CreateUserRequirementSet';
        path = '/message/CreateUserRequirementSet';
        request;
        response;
    }
    CoreManagement.CreateUserRequirementSet = CreateUserRequirementSet;
    /**
     * Create a new VisibilityGroup.
     *
     * @export
     * @class CreateVisibilityGroup
     * @implements {EvaService}
     */
    class CreateVisibilityGroup {
        name = 'CoreManagement:CreateVisibilityGroup';
        path = '/message/CreateVisibilityGroup';
        request;
        response;
    }
    CoreManagement.CreateVisibilityGroup = CreateVisibilityGroup;
    /**
     * Deactivates a survey.
NOTE THAT this deactivates all published versions of the survey, so it can no longer be responded to at the end of the grace period.
It will also take the survey back into draft.
The survey is re-enabled when a new version is published.
     *
     * @export
     * @class DeactivateSurvey
     * @implements {EvaService}
     */
    class DeactivateSurvey {
        name = 'CoreManagement:DeactivateSurvey';
        path = '/message/DeactivateSurvey';
        request;
        response;
    }
    CoreManagement.DeactivateSurvey = DeactivateSurvey;
    /**
     * Delete an existing Account
     *
     * @export
     * @class DeleteAccount
     * @implements {EvaService}
     */
    class DeleteAccount {
        name = 'CoreManagement:DeleteAccount';
        path = '/message/DeleteAccount';
        request;
        response;
    }
    CoreManagement.DeleteAccount = DeleteAccount;
    /**
     * Delete an existing assortment
     *
     * @export
     * @class DeleteAssortment
     * @implements {EvaService}
     */
    class DeleteAssortment {
        name = 'CoreManagement:DeleteAssortment';
        path = '/message/DeleteAssortment';
        request;
        response;
    }
    CoreManagement.DeleteAssortment = DeleteAssortment;
    /**
     * Detaches and deletes a blob from a case.
     *
     * @export
     * @class DeleteCaseBlob
     * @implements {EvaService}
     */
    class DeleteCaseBlob {
        name = 'CoreManagement:DeleteCaseBlob';
        path = '/message/DeleteCaseBlob';
        request;
        response;
    }
    CoreManagement.DeleteCaseBlob = DeleteCaseBlob;
    /**
     * Delete a case interaction
     *
     * @export
     * @class DeleteCaseInteraction
     * @implements {EvaService}
     */
    class DeleteCaseInteraction {
        name = 'CoreManagement:DeleteCaseInteraction';
        path = '/message/DeleteCaseInteraction';
        request;
        response;
    }
    CoreManagement.DeleteCaseInteraction = DeleteCaseInteraction;
    /**
     * Delete a case status
     *
     * @export
     * @class DeleteCaseStatus
     * @implements {EvaService}
     */
    class DeleteCaseStatus {
        name = 'CoreManagement:DeleteCaseStatus';
        path = '/message/DeleteCaseStatus';
        request;
        response;
    }
    CoreManagement.DeleteCaseStatus = DeleteCaseStatus;
    /**
     * Delete a case topic. NOTE THAT sub topics will also be deleted.
     *
     * @export
     * @class DeleteCaseTopic
     * @implements {EvaService}
     */
    class DeleteCaseTopic {
        name = 'CoreManagement:DeleteCaseTopic';
        path = '/message/DeleteCaseTopic';
        request;
        response;
    }
    CoreManagement.DeleteCaseTopic = DeleteCaseTopic;
    /**
     * Deletes a cash expense type.
     *
     * @export
     * @class DeleteCashExpenseType
     * @implements {EvaService}
     */
    class DeleteCashExpenseType {
        name = 'CoreManagement:DeleteCashExpenseType';
        path = '/message/DeleteCashExpenseType';
        request;
        response;
    }
    CoreManagement.DeleteCashExpenseType = DeleteCashExpenseType;
    /**
     * Delete a CashHandler
     *
     * @export
     * @class DeleteCashHandler
     * @implements {EvaService}
     */
    class DeleteCashHandler {
        name = 'CoreManagement:DeleteCashHandler';
        path = '/message/DeleteCashHandler';
        request;
        response;
    }
    CoreManagement.DeleteCashHandler = DeleteCashHandler;
    /**
     * Delete a CheckoutOption
     *
     * @export
     * @class DeleteCheckoutOption
     * @implements {EvaService}
     */
    class DeleteCheckoutOption {
        name = 'CoreManagement:DeleteCheckoutOption';
        path = '/message/DeleteCheckoutOption';
        request;
        response;
    }
    CoreManagement.DeleteCheckoutOption = DeleteCheckoutOption;
    /**
     * Delete a CheckoutOptionCategory
     *
     * @export
     * @class DeleteCheckoutOptionCategory
     * @implements {EvaService}
     */
    class DeleteCheckoutOptionCategory {
        name = 'CoreManagement:DeleteCheckoutOptionCategory';
        path = '/message/DeleteCheckoutOptionCategory';
        request;
        response;
    }
    CoreManagement.DeleteCheckoutOptionCategory = DeleteCheckoutOptionCategory;
    /**
     * Delete a ClientApplication
     *
     * @export
     * @class DeleteClientApplication
     * @implements {EvaService}
     */
    class DeleteClientApplication {
        name = 'CoreManagement:DeleteClientApplication';
        path = '/message/DeleteClientApplication';
        request;
        response;
    }
    CoreManagement.DeleteClientApplication = DeleteClientApplication;
    /**
     * Deletes a Company. If a Company is still in use by Users or OrganizationUnits this service will return an error.
     *
     * @export
     * @class DeleteCompany
     * @implements {EvaService}
     */
    class DeleteCompany {
        name = 'CoreManagement:DeleteCompany';
        path = '/message/DeleteCompany';
        request;
        response;
    }
    CoreManagement.DeleteCompany = DeleteCompany;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteCostPriceCalculation
     * @implements {EvaService}
     */
    class DeleteCostPriceCalculation {
        name = 'CoreManagement:DeleteCostPriceCalculation';
        path = '/message/DeleteCostPriceCalculation';
        request;
        response;
    }
    CoreManagement.DeleteCostPriceCalculation = DeleteCostPriceCalculation;
    /**
     * Delete a Culture
     *
     * @export
     * @class DeleteCulture
     * @implements {EvaService}
     */
    class DeleteCulture {
        name = 'CoreManagement:DeleteCulture';
        path = '/message/DeleteCulture';
        request;
        response;
    }
    CoreManagement.DeleteCulture = DeleteCulture;
    /**
     * Delete a CustomField
     *
     * @export
     * @class DeleteCustomField
     * @implements {EvaService}
     */
    class DeleteCustomField {
        name = 'CoreManagement:DeleteCustomField';
        path = '/message/DeleteCustomField';
        request;
        response;
    }
    CoreManagement.DeleteCustomField = DeleteCustomField;
    /**
     * Delete a device
     *
     * @export
     * @class DeleteDevice
     * @implements {EvaService}
     */
    class DeleteDevice {
        name = 'CoreManagement:DeleteDevice';
        path = '/message/DeleteDevice';
        request;
        response;
    }
    CoreManagement.DeleteDevice = DeleteDevice;
    /**
     * Delete a DiscountCampaign
     *
     * @export
     * @class DeleteDiscountCampaign
     * @implements {EvaService}
     */
    class DeleteDiscountCampaign {
        name = 'CoreManagement:DeleteDiscountCampaign';
        path = '/message/DeleteDiscountCampaign';
        request;
        response;
    }
    CoreManagement.DeleteDiscountCampaign = DeleteDiscountCampaign;
    /**
     * Delete a DiscountLayer
     *
     * @export
     * @class DeleteDiscountLayer
     * @implements {EvaService}
     */
    class DeleteDiscountLayer {
        name = 'CoreManagement:DeleteDiscountLayer';
        path = '/message/DeleteDiscountLayer';
        request;
        response;
    }
    CoreManagement.DeleteDiscountLayer = DeleteDiscountLayer;
    /**
     * Delete an existing discount template
     *
     * @export
     * @class DeleteDiscountTemplate
     * @implements {EvaService}
     */
    class DeleteDiscountTemplate {
        name = 'CoreManagement:DeleteDiscountTemplate';
        path = '/message/DeleteDiscountTemplate';
        request;
        response;
    }
    CoreManagement.DeleteDiscountTemplate = DeleteDiscountTemplate;
    /**
     * Remove a users employee data.
     *
     * @export
     * @class DeleteEmployeeData
     * @implements {EvaService}
     */
    class DeleteEmployeeData {
        name = 'CoreManagement:DeleteEmployeeData';
        path = '/message/DeleteEmployeeData';
        request;
        response;
    }
    CoreManagement.DeleteEmployeeData = DeleteEmployeeData;
    /**
     * Service for deleting a existing `EndpointConfiguration`
     *
     * @export
     * @class DeleteEndpointConfiguration
     * @implements {EvaService}
     */
    class DeleteEndpointConfiguration {
        name = 'CoreManagement:DeleteEndpointConfiguration';
        path = '/message/DeleteEndpointConfiguration';
        request;
        response;
    }
    CoreManagement.DeleteEndpointConfiguration = DeleteEndpointConfiguration;
    /**
     * Delete a entity field validator
     *
     * @export
     * @class DeleteEntityFieldValidator
     * @implements {EvaService}
     */
    class DeleteEntityFieldValidator {
        name = 'CoreManagement:DeleteEntityFieldValidator';
        path = '/message/DeleteEntityFieldValidator';
        request;
        response;
    }
    CoreManagement.DeleteEntityFieldValidator = DeleteEntityFieldValidator;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteFraudItem
     * @implements {EvaService}
     */
    class DeleteFraudItem {
        name = 'CoreManagement:DeleteFraudItem';
        path = '/message/DeleteFraudItem';
        request;
        response;
    }
    CoreManagement.DeleteFraudItem = DeleteFraudItem;
    /**
     * Delete a GiftCardConfiguration
     *
     * @export
     * @class DeleteGiftCardConfiguration
     * @implements {EvaService}
     */
    class DeleteGiftCardConfiguration {
        name = 'CoreManagement:DeleteGiftCardConfiguration';
        path = '/message/DeleteGiftCardConfiguration';
        request;
        response;
    }
    CoreManagement.DeleteGiftCardConfiguration = DeleteGiftCardConfiguration;
    /**
     * Delete an inquiry
     *
     * @export
     * @class DeleteInquiry
     * @implements {EvaService}
     */
    class DeleteInquiry {
        name = 'CoreManagement:DeleteInquiry';
        path = '/message/DeleteInquiry';
        request;
        response;
    }
    CoreManagement.DeleteInquiry = DeleteInquiry;
    /**
     * Deletes an inquiry item
     *
     * @export
     * @class DeleteInquiryItem
     * @implements {EvaService}
     */
    class DeleteInquiryItem {
        name = 'CoreManagement:DeleteInquiryItem';
        path = '/message/DeleteInquiryItem';
        request;
        response;
    }
    CoreManagement.DeleteInquiryItem = DeleteInquiryItem;
    /**
     * Delete a LoyaltyProgram
     *
     * @export
     * @class DeleteLoyaltyProgram
     * @implements {EvaService}
     */
    class DeleteLoyaltyProgram {
        name = 'CoreManagement:DeleteLoyaltyProgram';
        path = '/message/DeleteLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.DeleteLoyaltyProgram = DeleteLoyaltyProgram;
    /**
     * Delete a LoyaltyProgramCondition
     *
     * @export
     * @class DeleteLoyaltyProgramCondition
     * @implements {EvaService}
     */
    class DeleteLoyaltyProgramCondition {
        name = 'CoreManagement:DeleteLoyaltyProgramCondition';
        path = '/message/DeleteLoyaltyProgramCondition';
        request;
        response;
    }
    CoreManagement.DeleteLoyaltyProgramCondition = DeleteLoyaltyProgramCondition;
    /**
     * Delete the LoyaltyProgramGroup
     *
     * @export
     * @class DeleteLoyaltyProgramGroup
     * @implements {EvaService}
     */
    class DeleteLoyaltyProgramGroup {
        name = 'CoreManagement:DeleteLoyaltyProgramGroup';
        path = '/message/DeleteLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.DeleteLoyaltyProgramGroup = DeleteLoyaltyProgramGroup;
    /**
     * Delete a LoyaltyProgramPaymentType
     *
     * @export
     * @class DeleteLoyaltyProgramPaymentType
     * @implements {EvaService}
     */
    class DeleteLoyaltyProgramPaymentType {
        name = 'CoreManagement:DeleteLoyaltyProgramPaymentType';
        path = '/message/DeleteLoyaltyProgramPaymentType';
        request;
        response;
    }
    CoreManagement.DeleteLoyaltyProgramPaymentType = DeleteLoyaltyProgramPaymentType;
    /**
     * Delete a loyalty program product limitation.
     *
     * @export
     * @class DeleteLoyaltyProgramProductLimitation
     * @implements {EvaService}
     */
    class DeleteLoyaltyProgramProductLimitation {
        name = 'CoreManagement:DeleteLoyaltyProgramProductLimitation';
        path = '/message/DeleteLoyaltyProgramProductLimitation';
        request;
        response;
    }
    CoreManagement.DeleteLoyaltyProgramProductLimitation = DeleteLoyaltyProgramProductLimitation;
    /**
     * Delete a MessageTemplate
     *
     * @export
     * @class DeleteMessageTemplate
     * @implements {EvaService}
     */
    class DeleteMessageTemplate {
        name = 'CoreManagement:DeleteMessageTemplate';
        path = '/message/DeleteMessageTemplate';
        request;
        response;
    }
    CoreManagement.DeleteMessageTemplate = DeleteMessageTemplate;
    /**
     * Deletes an OpenCashDrawerReason
     *
     * @export
     * @class DeleteOpenCashDrawerReason
     * @implements {EvaService}
     */
    class DeleteOpenCashDrawerReason {
        name = 'CoreManagement:DeleteOpenCashDrawerReason';
        path = '/message/DeleteOpenCashDrawerReason';
        request;
        response;
    }
    CoreManagement.DeleteOpenCashDrawerReason = DeleteOpenCashDrawerReason;
    /**
     * Delete a OpeningHoursType
     *
     * @export
     * @class DeleteOpeningHoursType
     * @implements {EvaService}
     */
    class DeleteOpeningHoursType {
        name = 'CoreManagement:DeleteOpeningHoursType';
        path = '/message/DeleteOpeningHoursType';
        request;
        response;
    }
    CoreManagement.DeleteOpeningHoursType = DeleteOpeningHoursType;
    /**
     * Delete existing "OrderLedgerType"
     *
     * @export
     * @class DeleteOrderLedgerType
     * @implements {EvaService}
     */
    class DeleteOrderLedgerType {
        name = 'CoreManagement:DeleteOrderLedgerType';
        path = '/message/DeleteOrderLedgerType';
        request;
        response;
    }
    CoreManagement.DeleteOrderLedgerType = DeleteOrderLedgerType;
    /**
     * Delete an organization unit country
     *
     * @export
     * @class DeleteOrganizationUnitCountry
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitCountry {
        name = 'CoreManagement:DeleteOrganizationUnitCountry';
        path = '/message/DeleteOrganizationUnitCountry';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitCountry = DeleteOrganizationUnitCountry;
    /**
     * Delete an additional Currency
     *
     * @export
     * @class DeleteOrganizationUnitCurrency
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitCurrency {
        name = 'CoreManagement:DeleteOrganizationUnitCurrency';
        path = '/message/DeleteOrganizationUnitCurrency';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitCurrency = DeleteOrganizationUnitCurrency;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteOrganizationUnitGroup
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitGroup {
        name = 'CoreManagement:DeleteOrganizationUnitGroup';
        path = '/message/DeleteOrganizationUnitGroup';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitGroup = DeleteOrganizationUnitGroup;
    /**
     * Detach a language that is directly attached to an organization unit.
     *
     * @export
     * @class DeleteOrganizationUnitLanguage
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitLanguage {
        name = 'CoreManagement:DeleteOrganizationUnitLanguage';
        path = '/message/DeleteOrganizationUnitLanguage';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitLanguage = DeleteOrganizationUnitLanguage;
    /**
     * Delete a single existing OpeningHour for an OrganizationUnit
     *
     * @export
     * @class DeleteOrganizationUnitOpeningHours
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitOpeningHours {
        name = 'CoreManagement:DeleteOrganizationUnitOpeningHours';
        path = '/message/DeleteOrganizationUnitOpeningHours';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitOpeningHours = DeleteOrganizationUnitOpeningHours;
    /**
     * Deletes an OrganizationUnitSet by its ID.

  It's currently not possible to delete a set that is still in use. Trying to do so will return an OrganizationUnitSets:CannotDeleteInUse error.
     *
     * @export
     * @class DeleteOrganizationUnitSet
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitSet {
        name = 'CoreManagement:DeleteOrganizationUnitSet';
        path = '/message/DeleteOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitSet = DeleteOrganizationUnitSet;
    /**
     * Delete an OrganizationUnitSetPaymentType

A PaymentType and OrganizationUnitSet are required
     *
     * @export
     * @class DeleteOrganizationUnitSetPaymentType
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitSetPaymentType {
        name = 'CoreManagement:DeleteOrganizationUnitSetPaymentType';
        path = '/message/DeleteOrganizationUnitSetPaymentType';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitSetPaymentType = DeleteOrganizationUnitSetPaymentType;
    /**
     * Deletes a OrganizationUnitSetScope.

It's not possible to delete a scope that is still in use by an OrganizationUnitSet.
     *
     * @export
     * @class DeleteOrganizationUnitSetScope
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitSetScope {
        name = 'CoreManagement:DeleteOrganizationUnitSetScope';
        path = '/message/DeleteOrganizationUnitSetScope';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitSetScope = DeleteOrganizationUnitSetScope;
    /**
     * Delete an OrganizationUnitShippingMethod
     *
     * @export
     * @class DeleteOrganizationUnitShippingMethod
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitShippingMethod {
        name = 'CoreManagement:DeleteOrganizationUnitShippingMethod';
        path = '/message/DeleteOrganizationUnitShippingMethod';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitShippingMethod = DeleteOrganizationUnitShippingMethod;
    /**
     * Removes a subset (SubsetID) from a set (SetID). If it doesn't exist, nothing happens.
     *
     * @export
     * @class DeleteOrganizationUnitSubset
     * @implements {EvaService}
     */
    class DeleteOrganizationUnitSubset {
        name = 'CoreManagement:DeleteOrganizationUnitSubset';
        path = '/message/DeleteOrganizationUnitSubset';
        request;
        response;
    }
    CoreManagement.DeleteOrganizationUnitSubset = DeleteOrganizationUnitSubset;
    /**
     * Delete a package
     *
     * @export
     * @class DeletePackage
     * @implements {EvaService}
     */
    class DeletePackage {
        name = 'CoreManagement:DeletePackage';
        path = '/message/DeletePackage';
        request;
        response;
    }
    CoreManagement.DeletePackage = DeletePackage;
    /**
     * Delete a PaymentMethod
     *
     * @export
     * @class DeletePaymentMethod
     * @implements {EvaService}
     */
    class DeletePaymentMethod {
        name = 'CoreManagement:DeletePaymentMethod';
        path = '/message/DeletePaymentMethod';
        request;
        response;
    }
    CoreManagement.DeletePaymentMethod = DeletePaymentMethod;
    /**
     * Delete a PaymentTransactionLedgerType. Only custom made types can be deleted that are not in use.
     *
     * @export
     * @class DeletePaymentTransactionLedgerType
     * @implements {EvaService}
     */
    class DeletePaymentTransactionLedgerType {
        name = 'CoreManagement:DeletePaymentTransactionLedgerType';
        path = '/message/DeletePaymentTransactionLedgerType';
        request;
        response;
    }
    CoreManagement.DeletePaymentTransactionLedgerType = DeletePaymentTransactionLedgerType;
    /**
     * Delete a PaymentType
     *
     * @export
     * @class DeletePaymentType
     * @implements {EvaService}
     */
    class DeletePaymentType {
        name = 'CoreManagement:DeletePaymentType';
        path = '/message/DeletePaymentType';
        request;
        response;
    }
    CoreManagement.DeletePaymentType = DeletePaymentType;
    /**
     * Delete a PriceList
     *
     * @export
     * @class DeletePriceList
     * @implements {EvaService}
     */
    class DeletePriceList {
        name = 'CoreManagement:DeletePriceList';
        path = '/message/DeletePriceList';
        request;
        response;
    }
    CoreManagement.DeletePriceList = DeletePriceList;
    /**
     * Delete an existing PriceListAdjustment
     *
     * @export
     * @class DeletePriceListAdjustment
     * @implements {EvaService}
     */
    class DeletePriceListAdjustment {
        name = 'CoreManagement:DeletePriceListAdjustment';
        path = '/message/DeletePriceListAdjustment';
        request;
        response;
    }
    CoreManagement.DeletePriceListAdjustment = DeletePriceListAdjustment;
    /**
     * Delete a PriceListManualInputAdjustment
     *
     * @export
     * @class DeletePriceListManualInputAdjustment
     * @implements {EvaService}
     */
    class DeletePriceListManualInputAdjustment {
        name = 'CoreManagement:DeletePriceListManualInputAdjustment';
        path = '/message/DeletePriceListManualInputAdjustment';
        request;
        response;
    }
    CoreManagement.DeletePriceListManualInputAdjustment = DeletePriceListManualInputAdjustment;
    /**
     * Delete a PriceListOrganizationUnit
     *
     * @export
     * @class DeletePriceListOrganizationUnit
     * @implements {EvaService}
     */
    class DeletePriceListOrganizationUnit {
        name = 'CoreManagement:DeletePriceListOrganizationUnit';
        path = '/message/DeletePriceListOrganizationUnit';
        request;
        response;
    }
    CoreManagement.DeletePriceListOrganizationUnit = DeletePriceListOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeletePriceListUsageType
     * @implements {EvaService}
     */
    class DeletePriceListUsageType {
        name = 'CoreManagement:DeletePriceListUsageType';
        path = '/message/DeletePriceListUsageType';
        request;
        response;
    }
    CoreManagement.DeletePriceListUsageType = DeletePriceListUsageType;
    /**
     * Deletes a printer type
     *
     * @export
     * @class DeletePrinterType
     * @implements {EvaService}
     */
    class DeletePrinterType {
        name = 'CoreManagement:DeletePrinterType';
        path = '/message/DeletePrinterType';
        request;
        response;
    }
    CoreManagement.DeletePrinterType = DeletePrinterType;
    /**
     * Delete a barcode from eva

When it's SupplierBarcode all matching barcodes will be removed
     *
     * @export
     * @class DeleteProductBarcode
     * @implements {EvaService}
     */
    class DeleteProductBarcode {
        name = 'CoreManagement:DeleteProductBarcode';
        path = '/message/DeleteProductBarcode';
        request;
        response;
    }
    CoreManagement.DeleteProductBarcode = DeleteProductBarcode;
    /**
     * Delete a ProductGiftCard
     *
     * @export
     * @class DeleteProductGiftCard
     * @implements {EvaService}
     */
    class DeleteProductGiftCard {
        name = 'CoreManagement:DeleteProductGiftCard';
        path = '/message/DeleteProductGiftCard';
        request;
        response;
    }
    CoreManagement.DeleteProductGiftCard = DeleteProductGiftCard;
    /**
     * Delete an existing Product Requirement
     *
     * @export
     * @class DeleteProductRequirement
     * @implements {EvaService}
     */
    class DeleteProductRequirement {
        name = 'CoreManagement:DeleteProductRequirement';
        path = '/message/DeleteProductRequirement';
        request;
        response;
    }
    CoreManagement.DeleteProductRequirement = DeleteProductRequirement;
    /**
     * Delete a ProductSearchTemplate
     *
     * @export
     * @class DeleteProductSearchTemplate
     * @implements {EvaService}
     */
    class DeleteProductSearchTemplate {
        name = 'CoreManagement:DeleteProductSearchTemplate';
        path = '/message/DeleteProductSearchTemplate';
        request;
        response;
    }
    CoreManagement.DeleteProductSearchTemplate = DeleteProductSearchTemplate;
    /**
     * Delete a ProductUnitOfMeasure
     *
     * @export
     * @class DeleteProductUnitOfMeasure
     * @implements {EvaService}
     */
    class DeleteProductUnitOfMeasure {
        name = 'CoreManagement:DeleteProductUnitOfMeasure';
        path = '/message/DeleteProductUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.DeleteProductUnitOfMeasure = DeleteProductUnitOfMeasure;
    /**
     * Deletes a refund reason. Note that it can still be seen on orders that have this field, but you can no longer use it.
     *
     * @export
     * @class DeleteRefundCorrectionReason
     * @implements {EvaService}
     */
    class DeleteRefundCorrectionReason {
        name = 'CoreManagement:DeleteRefundCorrectionReason';
        path = '/message/DeleteRefundCorrectionReason';
        request;
        response;
    }
    CoreManagement.DeleteRefundCorrectionReason = DeleteRefundCorrectionReason;
    /**
     * Delete a return reason
     *
     * @export
     * @class DeleteReturnReason
     * @implements {EvaService}
     */
    class DeleteReturnReason {
        name = 'CoreManagement:DeleteReturnReason';
        path = '/message/DeleteReturnReason';
        request;
        response;
    }
    CoreManagement.DeleteReturnReason = DeleteReturnReason;
    /**
     * Delete a role.
     *
     * @export
     * @class DeleteRole
     * @implements {EvaService}
     */
    class DeleteRole {
        name = 'CoreManagement:DeleteRole';
        path = '/message/DeleteRole';
        request;
        response;
    }
    CoreManagement.DeleteRole = DeleteRole;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DeleteRoleSet
     * @implements {EvaService}
     */
    class DeleteRoleSet {
        name = 'CoreManagement:DeleteRoleSet';
        path = '/message/DeleteRoleSet';
        request;
        response;
    }
    CoreManagement.DeleteRoleSet = DeleteRoleSet;
    /**
     * Delete a `ShippingCost`
     *
     * @export
     * @class DeleteShippingCost
     * @implements {EvaService}
     */
    class DeleteShippingCost {
        name = 'CoreManagement:DeleteShippingCost';
        path = '/message/DeleteShippingCost';
        request;
        response;
    }
    CoreManagement.DeleteShippingCost = DeleteShippingCost;
    /**
     * Deletes a ShippingMethodTransportationTime.
     *
     * @export
     * @class DeleteShippingMethodTransportationTime
     * @implements {EvaService}
     */
    class DeleteShippingMethodTransportationTime {
        name = 'CoreManagement:DeleteShippingMethodTransportationTime';
        path = '/message/DeleteShippingMethodTransportationTime';
        request;
        response;
    }
    CoreManagement.DeleteShippingMethodTransportationTime = DeleteShippingMethodTransportationTime;
    /**
     * Deletes a ShippingRestriction by its ID.
     *
     * @export
     * @class DeleteShippingRestriction
     * @implements {EvaService}
     */
    class DeleteShippingRestriction {
        name = 'CoreManagement:DeleteShippingRestriction';
        path = '/message/DeleteShippingRestriction';
        request;
        response;
    }
    CoreManagement.DeleteShippingRestriction = DeleteShippingRestriction;
    /**
     * Delete a station
     *
     * @export
     * @class DeleteStation
     * @implements {EvaService}
     */
    class DeleteStation {
        name = 'CoreManagement:DeleteStation';
        path = '/message/DeleteStation';
        request;
        response;
    }
    CoreManagement.DeleteStation = DeleteStation;
    /**
     * Deletes a StockAllocationRule.
     *
     * @export
     * @class DeleteStockAllocationRule
     * @implements {EvaService}
     */
    class DeleteStockAllocationRule {
        name = 'CoreManagement:DeleteStockAllocationRule';
        path = '/message/DeleteStockAllocationRule';
        request;
        response;
    }
    CoreManagement.DeleteStockAllocationRule = DeleteStockAllocationRule;
    /**
     * Delete a custom stock mutation reason.
     *
     * @export
     * @class DeleteStockMutationReason
     * @implements {EvaService}
     */
    class DeleteStockMutationReason {
        name = 'CoreManagement:DeleteStockMutationReason';
        path = '/message/DeleteStockMutationReason';
        request;
        response;
    }
    CoreManagement.DeleteStockMutationReason = DeleteStockMutationReason;
    /**
     * Delete a Subscription.
     *
     * @export
     * @class DeleteSubscription
     * @implements {EvaService}
     */
    class DeleteSubscription {
        name = 'CoreManagement:DeleteSubscription';
        path = '/message/DeleteSubscription';
        request;
        response;
    }
    CoreManagement.DeleteSubscription = DeleteSubscription;
    /**
     * Deletes a SubscriptionOrganizationUnitSet by its ID.
     *
     * @export
     * @class DeleteSubscriptionOrganizationUnitSet
     * @implements {EvaService}
     */
    class DeleteSubscriptionOrganizationUnitSet {
        name = 'CoreManagement:DeleteSubscriptionOrganizationUnitSet';
        path = '/message/DeleteSubscriptionOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.DeleteSubscriptionOrganizationUnitSet = DeleteSubscriptionOrganizationUnitSet;
    /**
     * Delete a SupplierProduct
     *
     * @export
     * @class DeleteSupplierProduct
     * @implements {EvaService}
     */
    class DeleteSupplierProduct {
        name = 'CoreManagement:DeleteSupplierProduct';
        path = '/message/DeleteSupplierProduct';
        request;
        response;
    }
    CoreManagement.DeleteSupplierProduct = DeleteSupplierProduct;
    /**
     * Update a survey
     *
     * @export
     * @class DeleteSurvey
     * @implements {EvaService}
     */
    class DeleteSurvey {
        name = 'CoreManagement:DeleteSurvey';
        path = '/message/DeleteSurvey';
        request;
        response;
    }
    CoreManagement.DeleteSurvey = DeleteSurvey;
    /**
     * Delete a survey question
     *
     * @export
     * @class DeleteSurveyQuestion
     * @implements {EvaService}
     */
    class DeleteSurveyQuestion {
        name = 'CoreManagement:DeleteSurveyQuestion';
        path = '/message/DeleteSurveyQuestion';
        request;
        response;
    }
    CoreManagement.DeleteSurveyQuestion = DeleteSurveyQuestion;
    /**
     * Delete a survey question route.
     *
     * @export
     * @class DeleteSurveyQuestionRoute
     * @implements {EvaService}
     */
    class DeleteSurveyQuestionRoute {
        name = 'CoreManagement:DeleteSurveyQuestionRoute';
        path = '/message/DeleteSurveyQuestionRoute';
        request;
        response;
    }
    CoreManagement.DeleteSurveyQuestionRoute = DeleteSurveyQuestionRoute;
    /**
     * Delete a UnitOfMeasure
     *
     * @export
     * @class DeleteUnitOfMeasure
     * @implements {EvaService}
     */
    class DeleteUnitOfMeasure {
        name = 'CoreManagement:DeleteUnitOfMeasure';
        path = '/message/DeleteUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.DeleteUnitOfMeasure = DeleteUnitOfMeasure;
    /**
     * Delete a UnitPriceCorrectionReason
     *
     * @export
     * @class DeleteUnitPriceCorrectionReason
     * @implements {EvaService}
     */
    class DeleteUnitPriceCorrectionReason {
        name = 'CoreManagement:DeleteUnitPriceCorrectionReason';
        path = '/message/DeleteUnitPriceCorrectionReason';
        request;
        response;
    }
    CoreManagement.DeleteUnitPriceCorrectionReason = DeleteUnitPriceCorrectionReason;
    /**
     * Delete a failed or unprocessed settlement file

File in state processing or processed can't be deleted due to generated financial events. This is only allowed when no settlents were generated for the file.
     *
     * @export
     * @class DeleteUnprocessedPaymentSettlementFile
     * @implements {EvaService}
     */
    class DeleteUnprocessedPaymentSettlementFile {
        name = 'CoreManagement:DeleteUnprocessedPaymentSettlementFile';
        path = '/message/DeleteUnprocessedPaymentSettlementFile';
        request;
        response;
    }
    CoreManagement.DeleteUnprocessedPaymentSettlementFile = DeleteUnprocessedPaymentSettlementFile;
    /**
     * Deletes a user bought product detail.
     *
     * @export
     * @class DeleteUserBoughtProductDetail
     * @implements {EvaService}
     */
    class DeleteUserBoughtProductDetail {
        name = 'CoreManagement:DeleteUserBoughtProductDetail';
        path = '/message/DeleteUserBoughtProductDetail';
        request;
        response;
    }
    CoreManagement.DeleteUserBoughtProductDetail = DeleteUserBoughtProductDetail;
    /**
     * Delete a UserOrigin
     *
     * @export
     * @class DeleteUserOrigin
     * @implements {EvaService}
     */
    class DeleteUserOrigin {
        name = 'CoreManagement:DeleteUserOrigin';
        path = '/message/DeleteUserOrigin';
        request;
        response;
    }
    CoreManagement.DeleteUserOrigin = DeleteUserOrigin;
    /**
     * Deletes a UserRequirement by its ID.
     *
     * @export
     * @class DeleteUserRequirement
     * @implements {EvaService}
     */
    class DeleteUserRequirement {
        name = 'CoreManagement:DeleteUserRequirement';
        path = '/message/DeleteUserRequirement';
        request;
        response;
    }
    CoreManagement.DeleteUserRequirement = DeleteUserRequirement;
    /**
     * Deletes a UserRequirementSet by its ID. Will also delete the underlying requirements.
     *
     * @export
     * @class DeleteUserRequirementSet
     * @implements {EvaService}
     */
    class DeleteUserRequirementSet {
        name = 'CoreManagement:DeleteUserRequirementSet';
        path = '/message/DeleteUserRequirementSet';
        request;
        response;
    }
    CoreManagement.DeleteUserRequirementSet = DeleteUserRequirementSet;
    /**
     * Delete a VisibilityGroup
     *
     * @export
     * @class DeleteVisibilityGroup
     * @implements {EvaService}
     */
    class DeleteVisibilityGroup {
        name = 'CoreManagement:DeleteVisibilityGroup';
        path = '/message/DeleteVisibilityGroup';
        request;
        response;
    }
    CoreManagement.DeleteVisibilityGroup = DeleteVisibilityGroup;
    /**
     * Delete a VisibilityGroup to VisibilityGroup configuration
     *
     * @export
     * @class DeleteVisibilityGroupConfiguration
     * @implements {EvaService}
     */
    class DeleteVisibilityGroupConfiguration {
        name = 'CoreManagement:DeleteVisibilityGroupConfiguration';
        path = '/message/DeleteVisibilityGroupConfiguration';
        request;
        response;
    }
    CoreManagement.DeleteVisibilityGroupConfiguration = DeleteVisibilityGroupConfiguration;
    /**
     * Deposit loyalty points to a user
     *
     * @export
     * @class DepositLoyaltyPoints
     * @implements {EvaService}
     */
    class DepositLoyaltyPoints {
        name = 'CoreManagement:DepositLoyaltyPoints';
        path = '/message/DepositLoyaltyPoints';
        request;
        response;
    }
    CoreManagement.DepositLoyaltyPoints = DepositLoyaltyPoints;
    /**
     * Detaches functionalities from a role.
     *
     * @export
     * @class DetachFunctionalitiesFromRole
     * @implements {EvaService}
     */
    class DetachFunctionalitiesFromRole {
        name = 'CoreManagement:DetachFunctionalitiesFromRole';
        path = '/message/DetachFunctionalitiesFromRole';
        request;
        response;
    }
    CoreManagement.DetachFunctionalitiesFromRole = DetachFunctionalitiesFromRole;
    /**
     * Detach a loyalty program from an order
     *
     * @export
     * @class DetachLoyaltyProgramFromOrder
     * @implements {EvaService}
     */
    class DetachLoyaltyProgramFromOrder {
        name = 'CoreManagement:DetachLoyaltyProgramFromOrder';
        path = '/message/DetachLoyaltyProgramFromOrder';
        request;
        response;
    }
    CoreManagement.DetachLoyaltyProgramFromOrder = DetachLoyaltyProgramFromOrder;
    /**
     * Disable discounts
     *
     * @export
     * @class DisableDiscounts
     * @implements {EvaService}
     */
    class DisableDiscounts {
        name = 'CoreManagement:DisableDiscounts';
        path = '/message/DisableDiscounts';
        request;
        response;
    }
    CoreManagement.DisableDiscounts = DisableDiscounts;
    /**
     * Disable a point awarding rule
     *
     * @export
     * @class DisablePointAwardingRule
     * @implements {EvaService}
     */
    class DisablePointAwardingRule {
        name = 'CoreManagement:DisablePointAwardingRule';
        path = '/message/DisablePointAwardingRule';
        request;
        response;
    }
    CoreManagement.DisablePointAwardingRule = DisablePointAwardingRule;
    /**
     * Returns an Excel file that contains all products in an assortment, which can then be updated and reuploaded using UploadAssortmentProducts.
     *
     * @export
     * @class DownloadAssortmentProducts
     * @implements {EvaService}
     */
    class DownloadAssortmentProducts {
        name = 'CoreManagement:DownloadAssortmentProducts';
        path = '/message/DownloadAssortmentProducts';
        request;
        response;
    }
    CoreManagement.DownloadAssortmentProducts = DownloadAssortmentProducts;
    /**
     * Exports the coupons for the given discount to Excel.
     *
     * @export
     * @class DownloadCouponExcel
     * @implements {EvaService}
     */
    class DownloadCouponExcel {
        name = 'CoreManagement:DownloadCouponExcel';
        path = '/message/DownloadCouponExcel';
        request;
        response;
    }
    CoreManagement.DownloadCouponExcel = DownloadCouponExcel;
    /**
     * Download template to upload an excel with coupons.
     *
     * @export
     * @class DownloadCouponExcelTemplate
     * @implements {EvaService}
     */
    class DownloadCouponExcelTemplate {
        name = 'CoreManagement:DownloadCouponExcelTemplate';
        path = '/message/DownloadCouponExcelTemplate';
        request;
        response;
    }
    CoreManagement.DownloadCouponExcelTemplate = DownloadCouponExcelTemplate;
    /**
     * Exports the coupons for the given discount to Excel.
     *
     * @export
     * @class DownloadCouponExcel_Async
     * @implements {EvaService}
     */
    class DownloadCouponExcel_Async {
        name = 'CoreManagement:DownloadCouponExcel_Async';
        path = '/async-message/DownloadCouponExcel';
        request;
        response;
    }
    CoreManagement.DownloadCouponExcel_Async = DownloadCouponExcel_Async;
    /**
     * Exports the coupons for the given discount to Excel.
     *
     * @export
     * @class DownloadCouponExcel_AsyncResult
     * @implements {EvaService}
     */
    class DownloadCouponExcel_AsyncResult {
        name = 'CoreManagement:DownloadCouponExcel_AsyncResult';
        path = '/async-result/DownloadCouponExcel';
        request;
        response;
    }
    CoreManagement.DownloadCouponExcel_AsyncResult = DownloadCouponExcel_AsyncResult;
    /**
     * Download an Excel sample which can be filled with customers. The populated excel can be uploaded through the `UploadCustomers` service.
     *
     * @export
     * @class DownloadCustomersSample
     * @implements {EvaService}
     */
    class DownloadCustomersSample {
        name = 'CoreManagement:DownloadCustomersSample';
        path = '/message/DownloadCustomersSample';
        request;
        response;
    }
    CoreManagement.DownloadCustomersSample = DownloadCustomersSample;
    /**
     * Download an Excel sample which can be filled with employees. The populated excel can be uploaded through the `UploadEmployees` service.
     *
     * @export
     * @class DownloadEmployeesSample
     * @implements {EvaService}
     */
    class DownloadEmployeesSample {
        name = 'CoreManagement:DownloadEmployeesSample';
        path = '/message/DownloadEmployeesSample';
        request;
        response;
    }
    CoreManagement.DownloadEmployeesSample = DownloadEmployeesSample;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DownloadFraudItems
     * @implements {EvaService}
     */
    class DownloadFraudItems {
        name = 'CoreManagement:DownloadFraudItems';
        path = '/message/DownloadFraudItems';
        request;
        response;
    }
    CoreManagement.DownloadFraudItems = DownloadFraudItems;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class DownloadInitialInventorySample
     * @implements {EvaService}
     */
    class DownloadInitialInventorySample {
        name = 'CoreManagement:DownloadInitialInventorySample';
        path = '/message/DownloadInitialInventorySample';
        request;
        response;
    }
    CoreManagement.DownloadInitialInventorySample = DownloadInitialInventorySample;
    /**
     * Download a settlement result file
     *
     * @export
     * @class DownloadPaymentSettlementFileResult
     * @implements {EvaService}
     */
    class DownloadPaymentSettlementFileResult {
        name = 'CoreManagement:DownloadPaymentSettlementFileResult';
        path = '/message/DownloadPaymentSettlementFileResult';
        request;
        response;
    }
    CoreManagement.DownloadPaymentSettlementFileResult = DownloadPaymentSettlementFileResult;
    /**
     * Generate an excel file containing all ManualInputPridceListAdjustments for the given PriceListAdjustment.
     *
     * @export
     * @class DownloadPriceListManualInputAdjustments
     * @implements {EvaService}
     */
    class DownloadPriceListManualInputAdjustments {
        name = 'CoreManagement:DownloadPriceListManualInputAdjustments';
        path = '/message/DownloadPriceListManualInputAdjustments';
        request;
        response;
    }
    CoreManagement.DownloadPriceListManualInputAdjustments = DownloadPriceListManualInputAdjustments;
    /**
     * Generate an excel sample file containing all ManualInputPridceListAdjustments for the given PriceListAdjustment.
     *
     * @export
     * @class DownloadPriceListManualInputAdjustmentsSample
     * @implements {EvaService}
     */
    class DownloadPriceListManualInputAdjustmentsSample {
        name = 'CoreManagement:DownloadPriceListManualInputAdjustmentsSample';
        path = '/message/DownloadPriceListManualInputAdjustmentsSample';
        request;
        response;
    }
    CoreManagement.DownloadPriceListManualInputAdjustmentsSample = DownloadPriceListManualInputAdjustmentsSample;
    /**
     * Download ShippingRestrictions. Service returns an URL to an Excel file.
     *
     * @export
     * @class DownloadShippingRestrictions
     * @implements {EvaService}
     */
    class DownloadShippingRestrictions {
        name = 'CoreManagement:DownloadShippingRestrictions';
        path = '/message/DownloadShippingRestrictions';
        request;
        response;
    }
    CoreManagement.DownloadShippingRestrictions = DownloadShippingRestrictions;
    /**
     * Downloads an Excel file containing StockAllocationRules according to the specified PageConfig. To get an empty template Excel, specify a page size of zero.
     *
     * @export
     * @class DownloadStockAllocationRulesExcel
     * @implements {EvaService}
     */
    class DownloadStockAllocationRulesExcel {
        name = 'CoreManagement:DownloadStockAllocationRulesExcel';
        path = '/message/DownloadStockAllocationRulesExcel';
        request;
        response;
    }
    CoreManagement.DownloadStockAllocationRulesExcel = DownloadStockAllocationRulesExcel;
    /**
     * Download an overview of the stock for the specified organization units.
     *
     * @export
     * @class DownloadStockOverview
     * @implements {EvaService}
     */
    class DownloadStockOverview {
        name = 'CoreManagement:DownloadStockOverview';
        path = '/message/DownloadStockOverview';
        request;
        response;
    }
    CoreManagement.DownloadStockOverview = DownloadStockOverview;
    /**
     * Download an overview of the stock for the specified organization units.
     *
     * @export
     * @class DownloadStockOverview_Async
     * @implements {EvaService}
     */
    class DownloadStockOverview_Async {
        name = 'CoreManagement:DownloadStockOverview_Async';
        path = '/async-message/DownloadStockOverview';
        request;
        response;
    }
    CoreManagement.DownloadStockOverview_Async = DownloadStockOverview_Async;
    /**
     * Download an overview of the stock for the specified organization units.
     *
     * @export
     * @class DownloadStockOverview_AsyncResult
     * @implements {EvaService}
     */
    class DownloadStockOverview_AsyncResult {
        name = 'CoreManagement:DownloadStockOverview_AsyncResult';
        path = '/async-result/DownloadStockOverview';
        request;
        response;
    }
    CoreManagement.DownloadStockOverview_AsyncResult = DownloadStockOverview_AsyncResult;
    /**
     * Download the current supplier products.
     *
     * @export
     * @class DownloadSupplierProducts
     * @implements {EvaService}
     */
    class DownloadSupplierProducts {
        name = 'CoreManagement:DownloadSupplierProducts';
        path = '/message/DownloadSupplierProducts';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProducts = DownloadSupplierProducts;
    /**
     * Download the current barcodes for the supplier products.
     *
     * @export
     * @class DownloadSupplierProductsBarcodes
     * @implements {EvaService}
     */
    class DownloadSupplierProductsBarcodes {
        name = 'CoreManagement:DownloadSupplierProductsBarcodes';
        path = '/message/DownloadSupplierProductsBarcodes';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsBarcodes = DownloadSupplierProductsBarcodes;
    /**
     * Download a sample for the `UploadSupplierProductsBarcodes`.
     *
     * @export
     * @class DownloadSupplierProductsBarcodesSample
     * @implements {EvaService}
     */
    class DownloadSupplierProductsBarcodesSample {
        name = 'CoreManagement:DownloadSupplierProductsBarcodesSample';
        path = '/message/DownloadSupplierProductsBarcodesSample';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsBarcodesSample = DownloadSupplierProductsBarcodesSample;
    /**
     * Download the current prices for the supplier products in the given Currency.
     *
     * @export
     * @class DownloadSupplierProductsPricing
     * @implements {EvaService}
     */
    class DownloadSupplierProductsPricing {
        name = 'CoreManagement:DownloadSupplierProductsPricing';
        path = '/message/DownloadSupplierProductsPricing';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsPricing = DownloadSupplierProductsPricing;
    /**
     * Download a sample for the `UploadSupplierProductsPricing`.
     *
     * @export
     * @class DownloadSupplierProductsPricingSample
     * @implements {EvaService}
     */
    class DownloadSupplierProductsPricingSample {
        name = 'CoreManagement:DownloadSupplierProductsPricingSample';
        path = '/message/DownloadSupplierProductsPricingSample';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsPricingSample = DownloadSupplierProductsPricingSample;
    /**
     * Download a sample for the `UploadSupplierProducts`.
     *
     * @export
     * @class DownloadSupplierProductsSample
     * @implements {EvaService}
     */
    class DownloadSupplierProductsSample {
        name = 'CoreManagement:DownloadSupplierProductsSample';
        path = '/message/DownloadSupplierProductsSample';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsSample = DownloadSupplierProductsSample;
    /**
     * Download the current stock for the supplier products.
     *
     * @export
     * @class DownloadSupplierProductsStock
     * @implements {EvaService}
     */
    class DownloadSupplierProductsStock {
        name = 'CoreManagement:DownloadSupplierProductsStock';
        path = '/message/DownloadSupplierProductsStock';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsStock = DownloadSupplierProductsStock;
    /**
     * Download a sample for the `UploadSupplierProductsStock`.
     *
     * @export
     * @class DownloadSupplierProductsStockSample
     * @implements {EvaService}
     */
    class DownloadSupplierProductsStockSample {
        name = 'CoreManagement:DownloadSupplierProductsStockSample';
        path = '/message/DownloadSupplierProductsStockSample';
        request;
        response;
    }
    CoreManagement.DownloadSupplierProductsStockSample = DownloadSupplierProductsStockSample;
    /**
     * Downloads an Excel file containing tax codes according to the specified PageConfig. To get an empty template Excel, specify a page size of zero.
     *
     * @export
     * @class DownloadTaxCodesExcel
     * @implements {EvaService}
     */
    class DownloadTaxCodesExcel {
        name = 'CoreManagement:DownloadTaxCodesExcel';
        path = '/message/DownloadTaxCodesExcel';
        request;
        response;
    }
    CoreManagement.DownloadTaxCodesExcel = DownloadTaxCodesExcel;
    /**
     * Downloads an Excel file containing tax rates according to the specified PageConfig.
     *
     * @export
     * @class DownloadTaxRateExcel
     * @implements {EvaService}
     */
    class DownloadTaxRateExcel {
        name = 'CoreManagement:DownloadTaxRateExcel';
        path = '/message/DownloadTaxRateExcel';
        request;
        response;
    }
    CoreManagement.DownloadTaxRateExcel = DownloadTaxRateExcel;
    /**
     * Duplicates the requested discount x times with it's conditions and action.
A duplicated discount will not be Active and Verified.
     *
     * @export
     * @class DuplicateDiscount
     * @implements {EvaService}
     */
    class DuplicateDiscount {
        name = 'CoreManagement:DuplicateDiscount';
        path = '/message/DuplicateDiscount';
        request;
        response;
    }
    CoreManagement.DuplicateDiscount = DuplicateDiscount;
    /**
     * Duplicates the given discount template.
     *
     * @export
     * @class DuplicateDiscountTemplate
     * @implements {EvaService}
     */
    class DuplicateDiscountTemplate {
        name = 'CoreManagement:DuplicateDiscountTemplate';
        path = '/message/DuplicateDiscountTemplate';
        request;
        response;
    }
    CoreManagement.DuplicateDiscountTemplate = DuplicateDiscountTemplate;
    /**
     * Duplicate the requirements of an existing set to a new set.
     *
     * @export
     * @class DuplicateUserRequirementSet
     * @implements {EvaService}
     */
    class DuplicateUserRequirementSet {
        name = 'CoreManagement:DuplicateUserRequirementSet';
        path = '/message/DuplicateUserRequirementSet';
        request;
        response;
    }
    CoreManagement.DuplicateUserRequirementSet = DuplicateUserRequirementSet;
    /**
     * Enable discounts
     *
     * @export
     * @class EnableDiscounts
     * @implements {EvaService}
     */
    class EnableDiscounts {
        name = 'CoreManagement:EnableDiscounts';
        path = '/message/EnableDiscounts';
        request;
        response;
    }
    CoreManagement.EnableDiscounts = EnableDiscounts;
    /**
     * Enable a point awarding rule
     *
     * @export
     * @class EnablePointAwardingRule
     * @implements {EvaService}
     */
    class EnablePointAwardingRule {
        name = 'CoreManagement:EnablePointAwardingRule';
        path = '/message/EnablePointAwardingRule';
        request;
        response;
    }
    CoreManagement.EnablePointAwardingRule = EnablePointAwardingRule;
    /**
     * Export all Employees with their roles in an excel file
     *
     * @export
     * @class ExportEmployeeRoles
     * @implements {EvaService}
     */
    class ExportEmployeeRoles {
        name = 'CoreManagement:ExportEmployeeRoles';
        path = '/message/ExportEmployeeRoles';
        request;
        response;
    }
    CoreManagement.ExportEmployeeRoles = ExportEmployeeRoles;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ExportGeneralLedgerSummaryToExcel
     * @implements {EvaService}
     */
    class ExportGeneralLedgerSummaryToExcel {
        name = 'CoreManagement:ExportGeneralLedgerSummaryToExcel';
        path = '/message/ExportGeneralLedgerSummaryToExcel';
        request;
        response;
    }
    CoreManagement.ExportGeneralLedgerSummaryToExcel = ExportGeneralLedgerSummaryToExcel;
    /**
     * You can only export up to 100 products at a time.
     *
     * @export
     * @class ExportProductCostPriceLedgerSummary
     * @implements {EvaService}
     */
    class ExportProductCostPriceLedgerSummary {
        name = 'CoreManagement:ExportProductCostPriceLedgerSummary';
        path = '/message/ExportProductCostPriceLedgerSummary';
        request;
        response;
    }
    CoreManagement.ExportProductCostPriceLedgerSummary = ExportProductCostPriceLedgerSummary;
    /**
     * Returns an Excel file containing all settings
     *
     * @export
     * @class ExportSettings
     * @implements {EvaService}
     */
    class ExportSettings {
        name = 'CoreManagement:ExportSettings';
        path = '/message/ExportSettings';
        request;
        response;
    }
    CoreManagement.ExportSettings = ExportSettings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ExportStockMutationSummary
     * @implements {EvaService}
     */
    class ExportStockMutationSummary {
        name = 'CoreManagement:ExportStockMutationSummary';
        path = '/message/ExportStockMutationSummary';
        request;
        response;
    }
    CoreManagement.ExportStockMutationSummary = ExportStockMutationSummary;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ExportUnshippedPurchaseOrdersToExcel
     * @implements {EvaService}
     */
    class ExportUnshippedPurchaseOrdersToExcel {
        name = 'CoreManagement:ExportUnshippedPurchaseOrdersToExcel';
        path = '/message/ExportUnshippedPurchaseOrdersToExcel';
        request;
        response;
    }
    CoreManagement.ExportUnshippedPurchaseOrdersToExcel = ExportUnshippedPurchaseOrdersToExcel;
    /**
     * Export all UserSubscriptions in an excel file
     *
     * @export
     * @class ExportUserSubscriptions
     * @implements {EvaService}
     */
    class ExportUserSubscriptions {
        name = 'CoreManagement:ExportUserSubscriptions';
        path = '/message/ExportUserSubscriptions';
        request;
        response;
    }
    CoreManagement.ExportUserSubscriptions = ExportUserSubscriptions;
    /**
     * Generate a batch DiscountCoupons, they will be emailed to the current user
     *
     * @export
     * @class GenerateDiscountCoupons
     * @implements {EvaService}
     */
    class GenerateDiscountCoupons {
        name = 'CoreManagement:GenerateDiscountCoupons';
        path = '/message/GenerateDiscountCoupons';
        request;
        response;
    }
    CoreManagement.GenerateDiscountCoupons = GenerateDiscountCoupons;
    /**
     * Generate a batch DiscountCoupons, they will be emailed to the current user
     *
     * @export
     * @class GenerateDiscountCoupons_Async
     * @implements {EvaService}
     */
    class GenerateDiscountCoupons_Async {
        name = 'CoreManagement:GenerateDiscountCoupons_Async';
        path = '/async-message/GenerateDiscountCoupons';
        request;
        response;
    }
    CoreManagement.GenerateDiscountCoupons_Async = GenerateDiscountCoupons_Async;
    /**
     * Generate a batch DiscountCoupons, they will be emailed to the current user
     *
     * @export
     * @class GenerateDiscountCoupons_AsyncResult
     * @implements {EvaService}
     */
    class GenerateDiscountCoupons_AsyncResult {
        name = 'CoreManagement:GenerateDiscountCoupons_AsyncResult';
        path = '/async-result/GenerateDiscountCoupons';
        request;
        response;
    }
    CoreManagement.GenerateDiscountCoupons_AsyncResult = GenerateDiscountCoupons_AsyncResult;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GenerateIdentificationCodeForEmployee
     * @implements {EvaService}
     */
    class GenerateIdentificationCodeForEmployee {
        name = 'CoreManagement:GenerateIdentificationCodeForEmployee';
        path = '/message/GenerateIdentificationCodeForEmployee';
        request;
        response;
    }
    CoreManagement.GenerateIdentificationCodeForEmployee = GenerateIdentificationCodeForEmployee;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GenerateIdentificationPinForEmployee
     * @implements {EvaService}
     */
    class GenerateIdentificationPinForEmployee {
        name = 'CoreManagement:GenerateIdentificationPinForEmployee';
        path = '/message/GenerateIdentificationPinForEmployee';
        request;
        response;
    }
    CoreManagement.GenerateIdentificationPinForEmployee = GenerateIdentificationPinForEmployee;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GeneratePurchaseOrderExcelSample
     * @implements {EvaService}
     */
    class GeneratePurchaseOrderExcelSample {
        name = 'CoreManagement:GeneratePurchaseOrderExcelSample';
        path = '/message/GeneratePurchaseOrderExcelSample';
        request;
        response;
    }
    CoreManagement.GeneratePurchaseOrderExcelSample = GeneratePurchaseOrderExcelSample;
    /**
     * Generates a sample file for `UploadSalesOrderExcel` service
     *
     * @export
     * @class GenerateSalesOrderExcelSample
     * @implements {EvaService}
     */
    class GenerateSalesOrderExcelSample {
        name = 'CoreManagement:GenerateSalesOrderExcelSample';
        path = '/message/GenerateSalesOrderExcelSample';
        request;
        response;
    }
    CoreManagement.GenerateSalesOrderExcelSample = GenerateSalesOrderExcelSample;
    /**
     * Get all the properties of an existing Account
     *
     * @export
     * @class GetAccount
     * @implements {EvaService}
     */
    class GetAccount {
        name = 'CoreManagement:GetAccount';
        path = '/message/GetAccount';
        request;
        response;
    }
    CoreManagement.GetAccount = GetAccount;
    /**
     * Get the available info about appsettings that are defined in the templates repo.

This can be used to support some sort of autocompletion while editing appsettings.
     *
     * @export
     * @class GetAppSettingsAutocompleteInfo
     * @implements {EvaService}
     */
    class GetAppSettingsAutocompleteInfo {
        name = 'CoreManagement:GetAppSettingsAutocompleteInfo';
        path = '/message/GetAppSettingsAutocompleteInfo';
        request;
        response;
    }
    CoreManagement.GetAppSettingsAutocompleteInfo = GetAppSettingsAutocompleteInfo;
    /**
     * Gets the appsettings related to given `OrganizationUnitID`, optionally only those starting with `NamePrefix`
     *
     * @export
     * @class GetAppSettingsForOrganizationUnit
     * @implements {EvaService}
     */
    class GetAppSettingsForOrganizationUnit {
        name = 'CoreManagement:GetAppSettingsForOrganizationUnit';
        path = '/message/GetAppSettingsForOrganizationUnit';
        request;
        response;
    }
    CoreManagement.GetAppSettingsForOrganizationUnit = GetAppSettingsForOrganizationUnit;
    /**
     * Get an existing Assortment by ID
     *
     * @export
     * @class GetAssortmentByID
     * @implements {EvaService}
     */
    class GetAssortmentByID {
        name = 'CoreManagement:GetAssortmentByID';
        path = '/message/GetAssortmentByID';
        request;
        response;
    }
    CoreManagement.GetAssortmentByID = GetAssortmentByID;
    /**
     * Get all OrganizationUnits that are connected to the Assortment
     *
     * @export
     * @class GetAssortmentOrganizationUnits
     * @implements {EvaService}
     */
    class GetAssortmentOrganizationUnits {
        name = 'CoreManagement:GetAssortmentOrganizationUnits';
        path = '/message/GetAssortmentOrganizationUnits';
        request;
        response;
    }
    CoreManagement.GetAssortmentOrganizationUnits = GetAssortmentOrganizationUnits;
    /**
     * Returns a paged result of root products in an assortment.
     *
     * @export
     * @class GetAssortmentProductTree
     * @implements {EvaService}
     */
    class GetAssortmentProductTree {
        name = 'CoreManagement:GetAssortmentProductTree';
        path = '/message/GetAssortmentProductTree';
        request;
        response;
    }
    CoreManagement.GetAssortmentProductTree = GetAssortmentProductTree;
    /**
     * Returns a paged result of root products in an assortment.
     *
     * @export
     * @class GetAssortmentRootProducts
     * @implements {EvaService}
     */
    class GetAssortmentRootProducts {
        name = 'CoreManagement:GetAssortmentRootProducts';
        path = '/message/GetAssortmentRootProducts';
        request;
        response;
    }
    CoreManagement.GetAssortmentRootProducts = GetAssortmentRootProducts;
    /**
     * Retrieves the required auditing settings for the specified organization unit, including their value, if set.
     *
     * @export
     * @class GetAuditingSettings
     * @implements {EvaService}
     */
    class GetAuditingSettings {
        name = 'CoreManagement:GetAuditingSettings';
        path = '/message/GetAuditingSettings';
        request;
        response;
    }
    CoreManagement.GetAuditingSettings = GetAuditingSettings;
    /**
     * Returns the available handlers for settlement files
     *
     * @export
     * @class GetAvailablePaymentSettlementFileHandlers
     * @implements {EvaService}
     */
    class GetAvailablePaymentSettlementFileHandlers {
        name = 'CoreManagement:GetAvailablePaymentSettlementFileHandlers';
        path = '/message/GetAvailablePaymentSettlementFileHandlers';
        request;
        response;
    }
    CoreManagement.GetAvailablePaymentSettlementFileHandlers = GetAvailablePaymentSettlementFileHandlers;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetAvailableRoles
     * @implements {EvaService}
     */
    class GetAvailableRoles {
        name = 'CoreManagement:GetAvailableRoles';
        path = '/message/GetAvailableRoles';
        request;
        response;
    }
    CoreManagement.GetAvailableRoles = GetAvailableRoles;
    /**
     * Get all available typed settings

If available a Description and/or DefaultValue will be returned
     *
     * @export
     * @class GetAvailableSettings
     * @implements {EvaService}
     */
    class GetAvailableSettings {
        name = 'CoreManagement:GetAvailableSettings';
        path = '/message/GetAvailableSettings';
        request;
        response;
    }
    CoreManagement.GetAvailableSettings = GetAvailableSettings;
    /**
     * Returns available handlers for shipping methods
     *
     * @export
     * @class GetAvailableShippingMethodHandlers
     * @implements {EvaService}
     */
    class GetAvailableShippingMethodHandlers {
        name = 'CoreManagement:GetAvailableShippingMethodHandlers';
        path = '/message/GetAvailableShippingMethodHandlers';
        request;
        response;
    }
    CoreManagement.GetAvailableShippingMethodHandlers = GetAvailableShippingMethodHandlers;
    /**
     * Returns available survey triggers.
     *
     * @export
     * @class GetAvailableSurveyTriggers
     * @implements {EvaService}
     */
    class GetAvailableSurveyTriggers {
        name = 'CoreManagement:GetAvailableSurveyTriggers';
        path = '/message/GetAvailableSurveyTriggers';
        request;
        response;
    }
    CoreManagement.GetAvailableSurveyTriggers = GetAvailableSurveyTriggers;
    /**
     * Get all available surveys for user
     *
     * @export
     * @class GetAvailableSurveys
     * @implements {EvaService}
     */
    class GetAvailableSurveys {
        name = 'CoreManagement:GetAvailableSurveys';
        path = '/message/GetAvailableSurveys';
        request;
        response;
    }
    CoreManagement.GetAvailableSurveys = GetAvailableSurveys;
    /**
     * Get the available UserProperties on which requirements can be set.
     *
     * @export
     * @class GetAvailableUserRequirementsProperties
     * @implements {EvaService}
     */
    class GetAvailableUserRequirementsProperties {
        name = 'CoreManagement:GetAvailableUserRequirementsProperties';
        path = '/message/GetAvailableUserRequirementsProperties';
        request;
        response;
    }
    CoreManagement.GetAvailableUserRequirementsProperties = GetAvailableUserRequirementsProperties;
    /**
     * Get the configuration required to set up a CustomerFacingDisplay.
     *
     * @export
     * @class GetCFDConfiguration
     * @implements {EvaService}
     */
    class GetCFDConfiguration {
        name = 'CoreManagement:GetCFDConfiguration';
        path = '/message/GetCFDConfiguration';
        request;
        response;
    }
    CoreManagement.GetCFDConfiguration = GetCFDConfiguration;
    /**
     * Get a Carrier
     *
     * @export
     * @class GetCarrierByID
     * @implements {EvaService}
     */
    class GetCarrierByID {
        name = 'CoreManagement:GetCarrierByID';
        path = '/message/GetCarrierByID';
        request;
        response;
    }
    CoreManagement.GetCarrierByID = GetCarrierByID;
    /**
     * Gets a case by its ID.
     *
     * @export
     * @class GetCaseByID
     * @implements {EvaService}
     */
    class GetCaseByID {
        name = 'CoreManagement:GetCaseByID';
        path = '/message/GetCaseByID';
        request;
        response;
    }
    CoreManagement.GetCaseByID = GetCaseByID;
    /**
     * Get case interaction
     *
     * @export
     * @class GetCaseInteraction
     * @implements {EvaService}
     */
    class GetCaseInteraction {
        name = 'CoreManagement:GetCaseInteraction';
        path = '/message/GetCaseInteraction';
        request;
        response;
    }
    CoreManagement.GetCaseInteraction = GetCaseInteraction;
    /**
     * Get case status
     *
     * @export
     * @class GetCaseStatus
     * @implements {EvaService}
     */
    class GetCaseStatus {
        name = 'CoreManagement:GetCaseStatus';
        path = '/message/GetCaseStatus';
        request;
        response;
    }
    CoreManagement.GetCaseStatus = GetCaseStatus;
    /**
     * Get case topic
     *
     * @export
     * @class GetCaseTopic
     * @implements {EvaService}
     */
    class GetCaseTopic {
        name = 'CoreManagement:GetCaseTopic';
        path = '/message/GetCaseTopic';
        request;
        response;
    }
    CoreManagement.GetCaseTopic = GetCaseTopic;
    /**
     * Returns a cash expense type by its ID.
     *
     * @export
     * @class GetCashExpenseTypeByID
     * @implements {EvaService}
     */
    class GetCashExpenseTypeByID {
        name = 'CoreManagement:GetCashExpenseTypeByID';
        path = '/message/GetCashExpenseTypeByID';
        request;
        response;
    }
    CoreManagement.GetCashExpenseTypeByID = GetCashExpenseTypeByID;
    /**
     * Get a CashHandler
     *
     * @export
     * @class GetCashHandlerByID
     * @implements {EvaService}
     */
    class GetCashHandlerByID {
        name = 'CoreManagement:GetCashHandlerByID';
        path = '/message/GetCashHandlerByID';
        request;
        response;
    }
    CoreManagement.GetCashHandlerByID = GetCashHandlerByID;
    /**
     * Get the available checkout option handlers
     *
     * @export
     * @class GetCheckoutOptionHandlers
     * @implements {EvaService}
     */
    class GetCheckoutOptionHandlers {
        name = 'CoreManagement:GetCheckoutOptionHandlers';
        path = '/message/GetCheckoutOptionHandlers';
        request;
        response;
    }
    CoreManagement.GetCheckoutOptionHandlers = GetCheckoutOptionHandlers;
    /**
     * Gets an ClientApplication by its ID
     *
     * @export
     * @class GetClientApplicationByID
     * @implements {EvaService}
     */
    class GetClientApplicationByID {
        name = 'CoreManagement:GetClientApplicationByID';
        path = '/message/GetClientApplicationByID';
        request;
        response;
    }
    CoreManagement.GetClientApplicationByID = GetClientApplicationByID;
    /**
     * Get the details of a specific Company.
     *
     * @export
     * @class GetCompany
     * @implements {EvaService}
     */
    class GetCompany {
        name = 'CoreManagement:GetCompany';
        path = '/message/GetCompany';
        request;
        response;
    }
    CoreManagement.GetCompany = GetCompany;
    /**
     * Get a qrcode to configure/enroll a device when available.

At this moment the supported DeviceTypes are:
 - CustomerDisplay
     *
     * @export
     * @class GetConfigurationQrForDevice
     * @implements {EvaService}
     */
    class GetConfigurationQrForDevice {
        name = 'CoreManagement:GetConfigurationQrForDevice';
        path = '/message/GetConfigurationQrForDevice';
        request;
        response;
    }
    CoreManagement.GetConfigurationQrForDevice = GetConfigurationQrForDevice;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCostPriceCalculation
     * @implements {EvaService}
     */
    class GetCostPriceCalculation {
        name = 'CoreManagement:GetCostPriceCalculation';
        path = '/message/GetCostPriceCalculation';
        request;
        response;
    }
    CoreManagement.GetCostPriceCalculation = GetCostPriceCalculation;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCostPriceCalculations
     * @implements {EvaService}
     */
    class GetCostPriceCalculations {
        name = 'CoreManagement:GetCostPriceCalculations';
        path = '/message/GetCostPriceCalculations';
        request;
        response;
    }
    CoreManagement.GetCostPriceCalculations = GetCostPriceCalculations;
    /**
     * Get a coupon by it's token. When a customer calls this service, the service will only resolve tokens from coupons on which the user is registered. Employees and API's can resolve all coupon tokens.
     *
     * @export
     * @class GetCouponByToken
     * @implements {EvaService}
     */
    class GetCouponByToken {
        name = 'CoreManagement:GetCouponByToken';
        path = '/message/GetCouponByToken';
        request;
        response;
    }
    CoreManagement.GetCouponByToken = GetCouponByToken;
    /**
     * Gets an custom field by its ID and returns the basic information.
     *
     * @export
     * @class GetCustomFieldByID
     * @implements {EvaService}
     */
    class GetCustomFieldByID {
        name = 'CoreManagement:GetCustomFieldByID';
        path = '/message/GetCustomFieldByID';
        request;
        response;
    }
    CoreManagement.GetCustomFieldByID = GetCustomFieldByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetCustomFieldMetadata
     * @implements {EvaService}
     */
    class GetCustomFieldMetadata {
        name = 'CoreManagement:GetCustomFieldMetadata';
        path = '/message/GetCustomFieldMetadata';
        request;
        response;
    }
    CoreManagement.GetCustomFieldMetadata = GetCustomFieldMetadata;
    /**
     * Get the CustomFieldTypes
     *
     * @export
     * @class GetCustomFieldTypes
     * @implements {EvaService}
     */
    class GetCustomFieldTypes {
        name = 'CoreManagement:GetCustomFieldTypes';
        path = '/message/GetCustomFieldTypes';
        request;
        response;
    }
    CoreManagement.GetCustomFieldTypes = GetCustomFieldTypes;
    /**
     * Get all the custom fields for the given organization unit and type.
     *
     * @export
     * @class GetCustomFields
     * @implements {EvaService}
     */
    class GetCustomFields {
        name = 'CoreManagement:GetCustomFields';
        path = '/message/GetCustomFields';
        request;
        response;
    }
    CoreManagement.GetCustomFields = GetCustomFields;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetDataModelForTemplateHandler
     * @implements {EvaService}
     */
    class GetDataModelForTemplateHandler {
        name = 'CoreManagement:GetDataModelForTemplateHandler';
        path = '/message/GetDataModelForTemplateHandler';
        request;
        response;
    }
    CoreManagement.GetDataModelForTemplateHandler = GetDataModelForTemplateHandler;
    /**
     * Get Discount by the given Discount ID
     *
     * @export
     * @class GetDiscountByID
     * @implements {EvaService}
     */
    class GetDiscountByID {
        name = 'CoreManagement:GetDiscountByID';
        path = '/message/GetDiscountByID';
        request;
        response;
    }
    CoreManagement.GetDiscountByID = GetDiscountByID;
    /**
     * Get a DiscountCampaign by ID
     *
     * @export
     * @class GetDiscountCampaignByID
     * @implements {EvaService}
     */
    class GetDiscountCampaignByID {
        name = 'CoreManagement:GetDiscountCampaignByID';
        path = '/message/GetDiscountCampaignByID';
        request;
        response;
    }
    CoreManagement.GetDiscountCampaignByID = GetDiscountCampaignByID;
    /**
     * Get discount coupons by discount ID
     *
     * @export
     * @class GetDiscountCouponByID
     * @implements {EvaService}
     */
    class GetDiscountCouponByID {
        name = 'CoreManagement:GetDiscountCouponByID';
        path = '/message/GetDiscountCouponByID';
        request;
        response;
    }
    CoreManagement.GetDiscountCouponByID = GetDiscountCouponByID;
    /**
     * Get a DiscountLayer by ID
     *
     * @export
     * @class GetDiscountLayerByID
     * @implements {EvaService}
     */
    class GetDiscountLayerByID {
        name = 'CoreManagement:GetDiscountLayerByID';
        path = '/message/GetDiscountLayerByID';
        request;
        response;
    }
    CoreManagement.GetDiscountLayerByID = GetDiscountLayerByID;
    /**
     * Get DiscountTemplate by the given ID
     *
     * @export
     * @class GetDiscountTemplateByID
     * @implements {EvaService}
     */
    class GetDiscountTemplateByID {
        name = 'CoreManagement:GetDiscountTemplateByID';
        path = '/message/GetDiscountTemplateByID';
        request;
        response;
    }
    CoreManagement.GetDiscountTemplateByID = GetDiscountTemplateByID;
    /**
     * Fetch a users employee data by `UserID`.
     *
     * @export
     * @class GetEmployeeData
     * @implements {EvaService}
     */
    class GetEmployeeData {
        name = 'CoreManagement:GetEmployeeData';
        path = '/message/GetEmployeeData';
        request;
        response;
    }
    CoreManagement.GetEmployeeData = GetEmployeeData;
    /**
     * Fetch a users employee data by `ID`.
     *
     * @export
     * @class GetEmployeeDataByID
     * @implements {EvaService}
     */
    class GetEmployeeDataByID {
        name = 'CoreManagement:GetEmployeeDataByID';
        path = '/message/GetEmployeeDataByID';
        request;
        response;
    }
    CoreManagement.GetEmployeeDataByID = GetEmployeeDataByID;
    /**
     * Service for retrieving an existing `EndpointConfiguration`.
     *
     * @export
     * @class GetEndpointConfiguration
     * @implements {EvaService}
     */
    class GetEndpointConfiguration {
        name = 'CoreManagement:GetEndpointConfiguration';
        path = '/message/GetEndpointConfiguration';
        request;
        response;
    }
    CoreManagement.GetEndpointConfiguration = GetEndpointConfiguration;
    /**
     * Service for retrieving a list of existing `EndpointConfiguration`'s
     *
     * @export
     * @class GetEndpointConfigurations
     * @implements {EvaService}
     */
    class GetEndpointConfigurations {
        name = 'CoreManagement:GetEndpointConfigurations';
        path = '/message/GetEndpointConfigurations';
        request;
        response;
    }
    CoreManagement.GetEndpointConfigurations = GetEndpointConfigurations;
    /**
     * Get a entity field validator
     *
     * @export
     * @class GetEntityFieldValidator
     * @implements {EvaService}
     */
    class GetEntityFieldValidator {
        name = 'CoreManagement:GetEntityFieldValidator';
        path = '/message/GetEntityFieldValidator';
        request;
        response;
    }
    CoreManagement.GetEntityFieldValidator = GetEntityFieldValidator;
    /**
     * Get all entity field validators for given entity
     *
     * @export
     * @class GetFieldValidatorsForEntity
     * @implements {EvaService}
     */
    class GetFieldValidatorsForEntity {
        name = 'CoreManagement:GetFieldValidatorsForEntity';
        path = '/message/GetFieldValidatorsForEntity';
        request;
        response;
    }
    CoreManagement.GetFieldValidatorsForEntity = GetFieldValidatorsForEntity;
    /**
     * Retrieve the currently assigned functionalities flattened on specified OU.
     *
     * @export
     * @class GetFlattenedFunctionalityByUserID
     * @implements {EvaService}
     */
    class GetFlattenedFunctionalityByUserID {
        name = 'CoreManagement:GetFlattenedFunctionalityByUserID';
        path = '/message/GetFlattenedFunctionalityByUserID';
        request;
        response;
    }
    CoreManagement.GetFlattenedFunctionalityByUserID = GetFlattenedFunctionalityByUserID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetFraudItem
     * @implements {EvaService}
     */
    class GetFraudItem {
        name = 'CoreManagement:GetFraudItem';
        path = '/message/GetFraudItem';
        request;
        response;
    }
    CoreManagement.GetFraudItem = GetFraudItem;
    /**
     * Returns all available categories for functionalities
     *
     * @export
     * @class GetFunctionalityCategories
     * @implements {EvaService}
     */
    class GetFunctionalityCategories {
        name = 'CoreManagement:GetFunctionalityCategories';
        path = '/message/GetFunctionalityCategories';
        request;
        response;
    }
    CoreManagement.GetFunctionalityCategories = GetFunctionalityCategories;
    /**
     * Get a single GiftCardConfiguration
     *
     * @export
     * @class GetGiftCardConfiguration
     * @implements {EvaService}
     */
    class GetGiftCardConfiguration {
        name = 'CoreManagement:GetGiftCardConfiguration';
        path = '/message/GetGiftCardConfiguration';
        request;
        response;
    }
    CoreManagement.GetGiftCardConfiguration = GetGiftCardConfiguration;
    /**
     * Returns available handlers for gift card configurations
     *
     * @export
     * @class GetGiftCardHandlers
     * @implements {EvaService}
     */
    class GetGiftCardHandlers {
        name = 'CoreManagement:GetGiftCardHandlers';
        path = '/message/GetGiftCardHandlers';
        request;
        response;
    }
    CoreManagement.GetGiftCardHandlers = GetGiftCardHandlers;
    /**
     * Get all available languages
     *
     * @export
     * @class GetLanguages
     * @implements {EvaService}
     */
    class GetLanguages {
        name = 'CoreManagement:GetLanguages';
        path = '/message/GetLanguages';
        request;
        response;
    }
    CoreManagement.GetLanguages = GetLanguages;
    /**
     * Searches the Discounts with the given filter and returns a tree structure based on discount layer and discount.
     *
     * @export
     * @class GetLayerGroupedDiscountsByQuery
     * @implements {EvaService}
     */
    class GetLayerGroupedDiscountsByQuery {
        name = 'CoreManagement:GetLayerGroupedDiscountsByQuery';
        path = '/message/GetLayerGroupedDiscountsByQuery';
        request;
        response;
    }
    CoreManagement.GetLayerGroupedDiscountsByQuery = GetLayerGroupedDiscountsByQuery;
    /**
     * Get the predefined LedgerClasses, in most services it is allowed to use other classes.
     *
     * @export
     * @class GetLedgerClasses
     * @implements {EvaService}
     */
    class GetLedgerClasses {
        name = 'CoreManagement:GetLedgerClasses';
        path = '/message/GetLedgerClasses';
        request;
        response;
    }
    CoreManagement.GetLedgerClasses = GetLedgerClasses;
    /**
     * Get the available point policies
     *
     * @export
     * @class GetLoyaltyPointPolicies
     * @implements {EvaService}
     */
    class GetLoyaltyPointPolicies {
        name = 'CoreManagement:GetLoyaltyPointPolicies';
        path = '/message/GetLoyaltyPointPolicies';
        request;
        response;
    }
    CoreManagement.GetLoyaltyPointPolicies = GetLoyaltyPointPolicies;
    /**
     * Get a LoyaltyProgram
     *
     * @export
     * @class GetLoyaltyProgram
     * @implements {EvaService}
     */
    class GetLoyaltyProgram {
        name = 'CoreManagement:GetLoyaltyProgram';
        path = '/message/GetLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgram = GetLoyaltyProgram;
    /**
     * Get a LoyaltyProgramCondition
     *
     * @export
     * @class GetLoyaltyProgramCondition
     * @implements {EvaService}
     */
    class GetLoyaltyProgramCondition {
        name = 'CoreManagement:GetLoyaltyProgramCondition';
        path = '/message/GetLoyaltyProgramCondition';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramCondition = GetLoyaltyProgramCondition;
    /**
     * Get a LoyaltyProgramGroup
     *
     * @export
     * @class GetLoyaltyProgramGroup
     * @implements {EvaService}
     */
    class GetLoyaltyProgramGroup {
        name = 'CoreManagement:GetLoyaltyProgramGroup';
        path = '/message/GetLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramGroup = GetLoyaltyProgramGroup;
    /**
     * Get the available loyalty program handlers
     *
     * @export
     * @class GetLoyaltyProgramHandlers
     * @implements {EvaService}
     */
    class GetLoyaltyProgramHandlers {
        name = 'CoreManagement:GetLoyaltyProgramHandlers';
        path = '/message/GetLoyaltyProgramHandlers';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramHandlers = GetLoyaltyProgramHandlers;
    /**
     * Get a LoyaltyProgramPaymentType
     *
     * @export
     * @class GetLoyaltyProgramPaymentType
     * @implements {EvaService}
     */
    class GetLoyaltyProgramPaymentType {
        name = 'CoreManagement:GetLoyaltyProgramPaymentType';
        path = '/message/GetLoyaltyProgramPaymentType';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramPaymentType = GetLoyaltyProgramPaymentType;
    /**
     * Get a loyalty program product limitations
     *
     * @export
     * @class GetLoyaltyProgramProductLimitation
     * @implements {EvaService}
     */
    class GetLoyaltyProgramProductLimitation {
        name = 'CoreManagement:GetLoyaltyProgramProductLimitation';
        path = '/message/GetLoyaltyProgramProductLimitation';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramProductLimitation = GetLoyaltyProgramProductLimitation;
    /**
     * Get the loyalty program user usage
     *
     * @export
     * @class GetLoyaltyProgramUserUsage
     * @implements {EvaService}
     */
    class GetLoyaltyProgramUserUsage {
        name = 'CoreManagement:GetLoyaltyProgramUserUsage';
        path = '/message/GetLoyaltyProgramUserUsage';
        request;
        response;
    }
    CoreManagement.GetLoyaltyProgramUserUsage = GetLoyaltyProgramUserUsage;
    /**
     * Get a MessageTemplate
     *
     * @export
     * @class GetMessageTemplateByID
     * @implements {EvaService}
     */
    class GetMessageTemplateByID {
        name = 'CoreManagement:GetMessageTemplateByID';
        path = '/message/GetMessageTemplateByID';
        request;
        response;
    }
    CoreManagement.GetMessageTemplateByID = GetMessageTemplateByID;
    /**
     * Get the history of a MessageTemplate
     *
     * @export
     * @class GetMessageTemplateHistoryByID
     * @implements {EvaService}
     */
    class GetMessageTemplateHistoryByID {
        name = 'CoreManagement:GetMessageTemplateHistoryByID';
        path = '/message/GetMessageTemplateHistoryByID';
        request;
        response;
    }
    CoreManagement.GetMessageTemplateHistoryByID = GetMessageTemplateHistoryByID;
    /**
     * Get OpeningHoursTypes
     *
     * @export
     * @class GetOpeningHoursTypes
     * @implements {EvaService}
     */
    class GetOpeningHoursTypes {
        name = 'CoreManagement:GetOpeningHoursTypes';
        path = '/message/GetOpeningHoursTypes';
        request;
        response;
    }
    CoreManagement.GetOpeningHoursTypes = GetOpeningHoursTypes;
    /**
     * Get the available loyalty program payment methods for the given order.
     *
     * @export
     * @class GetOrderLoyaltyProgramPaymentTypes
     * @implements {EvaService}
     */
    class GetOrderLoyaltyProgramPaymentTypes {
        name = 'CoreManagement:GetOrderLoyaltyProgramPaymentTypes';
        path = '/message/GetOrderLoyaltyProgramPaymentTypes';
        request;
        response;
    }
    CoreManagement.GetOrderLoyaltyProgramPaymentTypes = GetOrderLoyaltyProgramPaymentTypes;
    /**
     * Gets an `OrganizationUnitSet` by its ID and returns the set's basic information.
     *
     * @export
     * @class GetOrganizationUnitSet
     * @implements {EvaService}
     */
    class GetOrganizationUnitSet {
        name = 'CoreManagement:GetOrganizationUnitSet';
        path = '/message/GetOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.GetOrganizationUnitSet = GetOrganizationUnitSet;
    /**
     * Gets a detailed view of an `OrganizationUnitSet` by its ID and returns it. This service recursively returns the set with its subsets and so on.
     *
     * @export
     * @class GetOrganizationUnitSetDetails
     * @implements {EvaService}
     */
    class GetOrganizationUnitSetDetails {
        name = 'CoreManagement:GetOrganizationUnitSetDetails';
        path = '/message/GetOrganizationUnitSetDetails';
        request;
        response;
    }
    CoreManagement.GetOrganizationUnitSetDetails = GetOrganizationUnitSetDetails;
    /**
     * Returns all current scopes.
     *
     * @export
     * @class GetOrganizationUnitSetScopes
     * @implements {EvaService}
     */
    class GetOrganizationUnitSetScopes {
        name = 'CoreManagement:GetOrganizationUnitSetScopes';
        path = '/message/GetOrganizationUnitSetScopes';
        request;
        response;
    }
    CoreManagement.GetOrganizationUnitSetScopes = GetOrganizationUnitSetScopes;
    /**
     * Get an OrganizationUnitShippingMethod
     *
     * @export
     * @class GetOrganizationUnitShippingMethodByID
     * @implements {EvaService}
     */
    class GetOrganizationUnitShippingMethodByID {
        name = 'CoreManagement:GetOrganizationUnitShippingMethodByID';
        path = '/message/GetOrganizationUnitShippingMethodByID';
        request;
        response;
    }
    CoreManagement.GetOrganizationUnitShippingMethodByID = GetOrganizationUnitShippingMethodByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetOrganizationUnitSupplierDataByOrganizationUnitID
     * @implements {EvaService}
     */
    class GetOrganizationUnitSupplierDataByOrganizationUnitID {
        name = 'CoreManagement:GetOrganizationUnitSupplierDataByOrganizationUnitID';
        path = '/message/GetOrganizationUnitSupplierDataByOrganizationUnitID';
        request;
        response;
    }
    CoreManagement.GetOrganizationUnitSupplierDataByOrganizationUnitID = GetOrganizationUnitSupplierDataByOrganizationUnitID;
    /**
     * Get all packages, with dimensions in millimeters (mm) and weight in grams (g).
     *
     * @export
     * @class GetPackages
     * @implements {EvaService}
     */
    class GetPackages {
        name = 'CoreManagement:GetPackages';
        path = '/message/GetPackages';
        request;
        response;
    }
    CoreManagement.GetPackages = GetPackages;
    /**
     * Get all packages for a carrier, with dimensions in millimeters (mm) and weight in grams (g).
     *
     * @export
     * @class GetPackagesForCarrier
     * @implements {EvaService}
     */
    class GetPackagesForCarrier {
        name = 'CoreManagement:GetPackagesForCarrier';
        path = '/message/GetPackagesForCarrier';
        request;
        response;
    }
    CoreManagement.GetPackagesForCarrier = GetPackagesForCarrier;
    /**
     * Gets an PaymentMethod by its ID and returns the basic information.
     *
     * @export
     * @class GetPaymentMethodByID
     * @implements {EvaService}
     */
    class GetPaymentMethodByID {
        name = 'CoreManagement:GetPaymentMethodByID';
        path = '/message/GetPaymentMethodByID';
        request;
        response;
    }
    CoreManagement.GetPaymentMethodByID = GetPaymentMethodByID;
    /**
     * Return all PaymentMethods
     *
     * @export
     * @class GetPaymentMethods
     * @implements {EvaService}
     */
    class GetPaymentMethods {
        name = 'CoreManagement:GetPaymentMethods';
        path = '/message/GetPaymentMethods';
        request;
        response;
    }
    CoreManagement.GetPaymentMethods = GetPaymentMethods;
    /**
     * Gets an PaymentType by its ID and returns the basic information.
     *
     * @export
     * @class GetPaymentTypeByID
     * @implements {EvaService}
     */
    class GetPaymentTypeByID {
        name = 'CoreManagement:GetPaymentTypeByID';
        path = '/message/GetPaymentTypeByID';
        request;
        response;
    }
    CoreManagement.GetPaymentTypeByID = GetPaymentTypeByID;
    /**
     * Get CustomFields for the given payment type.
     *
     * @export
     * @class GetPaymentTypeCustomFields
     * @implements {EvaService}
     */
    class GetPaymentTypeCustomFields {
        name = 'CoreManagement:GetPaymentTypeCustomFields';
        path = '/message/GetPaymentTypeCustomFields';
        request;
        response;
    }
    CoreManagement.GetPaymentTypeCustomFields = GetPaymentTypeCustomFields;
    /**
     * Get's the ID/Name of all paymenttypes to use for filter inputs
     *
     * @export
     * @class GetPaymentTypesForFilter
     * @implements {EvaService}
     */
    class GetPaymentTypesForFilter {
        name = 'CoreManagement:GetPaymentTypesForFilter';
        path = '/message/GetPaymentTypesForFilter';
        request;
        response;
    }
    CoreManagement.GetPaymentTypesForFilter = GetPaymentTypesForFilter;
    /**
     * Get personalized promotion by its ID.
     *
     * @export
     * @class GetPersonalizedPromotionByID
     * @implements {EvaService}
     */
    class GetPersonalizedPromotionByID {
        name = 'CoreManagement:GetPersonalizedPromotionByID';
        path = '/message/GetPersonalizedPromotionByID';
        request;
        response;
    }
    CoreManagement.GetPersonalizedPromotionByID = GetPersonalizedPromotionByID;
    /**
     * Get loyalty point rule.
     *
     * @export
     * @class GetPointAwardingRule
     * @implements {EvaService}
     */
    class GetPointAwardingRule {
        name = 'CoreManagement:GetPointAwardingRule';
        path = '/message/GetPointAwardingRule';
        request;
        response;
    }
    CoreManagement.GetPointAwardingRule = GetPointAwardingRule;
    /**
     * Get a PriceListAdjustment
     *
     * @export
     * @class GetPriceListAdjustmentByID
     * @implements {EvaService}
     */
    class GetPriceListAdjustmentByID {
        name = 'CoreManagement:GetPriceListAdjustmentByID';
        path = '/message/GetPriceListAdjustmentByID';
        request;
        response;
    }
    CoreManagement.GetPriceListAdjustmentByID = GetPriceListAdjustmentByID;
    /**
     * Get a PriceList

A PriceList has a TimeZone, this TimeZone should be used to Display certain DateTime's on the frontend.
For these specific fields the TimeZone of the user should be ignored and instead the one on the PriceList should be used.
     *
     * @export
     * @class GetPriceListByID
     * @implements {EvaService}
     */
    class GetPriceListByID {
        name = 'CoreManagement:GetPriceListByID';
        path = '/message/GetPriceListByID';
        request;
        response;
    }
    CoreManagement.GetPriceListByID = GetPriceListByID;
    /**
     * Get a PriceListManualInputAdjustment by ID
     *
     * @export
     * @class GetPriceListManualInputAdjustmentByID
     * @implements {EvaService}
     */
    class GetPriceListManualInputAdjustmentByID {
        name = 'CoreManagement:GetPriceListManualInputAdjustmentByID';
        path = '/message/GetPriceListManualInputAdjustmentByID';
        request;
        response;
    }
    CoreManagement.GetPriceListManualInputAdjustmentByID = GetPriceListManualInputAdjustmentByID;
    /**
     * Get an existing PriceListOrganizationUnit
     *
     * @export
     * @class GetPriceListOrganizationUnitByID
     * @implements {EvaService}
     */
    class GetPriceListOrganizationUnitByID {
        name = 'CoreManagement:GetPriceListOrganizationUnitByID';
        path = '/message/GetPriceListOrganizationUnitByID';
        request;
        response;
    }
    CoreManagement.GetPriceListOrganizationUnitByID = GetPriceListOrganizationUnitByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetPriceListUsageTypeByID
     * @implements {EvaService}
     */
    class GetPriceListUsageTypeByID {
        name = 'CoreManagement:GetPriceListUsageTypeByID';
        path = '/message/GetPriceListUsageTypeByID';
        request;
        response;
    }
    CoreManagement.GetPriceListUsageTypeByID = GetPriceListUsageTypeByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetPriceListUsageTypes
     * @implements {EvaService}
     */
    class GetPriceListUsageTypes {
        name = 'CoreManagement:GetPriceListUsageTypes';
        path = '/message/GetPriceListUsageTypes';
        request;
        response;
    }
    CoreManagement.GetPriceListUsageTypes = GetPriceListUsageTypes;
    /**
     * Gets a printer type
     *
     * @export
     * @class GetPrinterTypeByID
     * @implements {EvaService}
     */
    class GetPrinterTypeByID {
        name = 'CoreManagement:GetPrinterTypeByID';
        path = '/message/GetPrinterTypeByID';
        request;
        response;
    }
    CoreManagement.GetPrinterTypeByID = GetPrinterTypeByID;
    /**
     * Gets all printer types
     *
     * @export
     * @class GetPrinterTypes
     * @implements {EvaService}
     */
    class GetPrinterTypes {
        name = 'CoreManagement:GetPrinterTypes';
        path = '/message/GetPrinterTypes';
        request;
        response;
    }
    CoreManagement.GetPrinterTypes = GetPrinterTypes;
    /**
     * Get all info for a Product Requirement
     *
     * @export
     * @class GetProductRequirementByID
     * @implements {EvaService}
     */
    class GetProductRequirementByID {
        name = 'CoreManagement:GetProductRequirementByID';
        path = '/message/GetProductRequirementByID';
        request;
        response;
    }
    CoreManagement.GetProductRequirementByID = GetProductRequirementByID;
    /**
     * Get all available custom handler for ProductRequirements

These handlers are custom build to fetch values for ProductRequirements from external systems
     *
     * @export
     * @class GetProductRequirementHandlers
     * @implements {EvaService}
     */
    class GetProductRequirementHandlers {
        name = 'CoreManagement:GetProductRequirementHandlers';
        path = '/message/GetProductRequirementHandlers';
        request;
        response;
    }
    CoreManagement.GetProductRequirementHandlers = GetProductRequirementHandlers;
    /**
     * Get an exisiting ProductSearchTemplate by ID
     *
     * @export
     * @class GetProductSearchTemplateByID
     * @implements {EvaService}
     */
    class GetProductSearchTemplateByID {
        name = 'CoreManagement:GetProductSearchTemplateByID';
        path = '/message/GetProductSearchTemplateByID';
        request;
        response;
    }
    CoreManagement.GetProductSearchTemplateByID = GetProductSearchTemplateByID;
    /**
     * Returns a list of stock mutation reasons that are currently active for the supplied OrganizationUnitID.
     *
     * @export
     * @class GetRecentlyUsedStockMutationReasons
     * @implements {EvaService}
     */
    class GetRecentlyUsedStockMutationReasons {
        name = 'CoreManagement:GetRecentlyUsedStockMutationReasons';
        path = '/message/GetRecentlyUsedStockMutationReasons';
        request;
        response;
    }
    CoreManagement.GetRecentlyUsedStockMutationReasons = GetRecentlyUsedStockMutationReasons;
    /**
     * Returns a single refund reason.
     *
     * @export
     * @class GetRefundCorrectionReason
     * @implements {EvaService}
     */
    class GetRefundCorrectionReason {
        name = 'CoreManagement:GetRefundCorrectionReason';
        path = '/message/GetRefundCorrectionReason';
        request;
        response;
    }
    CoreManagement.GetRefundCorrectionReason = GetRefundCorrectionReason;
    /**
     * Get the reasons by type.
     *
     * @export
     * @class GetReturnReasonsByType
     * @implements {EvaService}
     */
    class GetReturnReasonsByType {
        name = 'CoreManagement:GetReturnReasonsByType';
        path = '/message/GetReturnReasonsByType';
        request;
        response;
    }
    CoreManagement.GetReturnReasonsByType = GetReturnReasonsByType;
    /**
     * Get role with its functionalities by it's ID.
     *
     * @export
     * @class GetRole
     * @implements {EvaService}
     */
    class GetRole {
        name = 'CoreManagement:GetRole';
        path = '/message/GetRole';
        request;
        response;
    }
    CoreManagement.GetRole = GetRole;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetRoleSetByID
     * @implements {EvaService}
     */
    class GetRoleSetByID {
        name = 'CoreManagement:GetRoleSetByID';
        path = '/message/GetRoleSetByID';
        request;
        response;
    }
    CoreManagement.GetRoleSetByID = GetRoleSetByID;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetRolesForOrganizationUnit
     * @implements {EvaService}
     */
    class GetRolesForOrganizationUnit {
        name = 'CoreManagement:GetRolesForOrganizationUnit';
        path = '/message/GetRolesForOrganizationUnit';
        request;
        response;
    }
    CoreManagement.GetRolesForOrganizationUnit = GetRolesForOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetRolesForOrganizationUnitSet
     * @implements {EvaService}
     */
    class GetRolesForOrganizationUnitSet {
        name = 'CoreManagement:GetRolesForOrganizationUnitSet';
        path = '/message/GetRolesForOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.GetRolesForOrganizationUnitSet = GetRolesForOrganizationUnitSet;
    /**
     * Service for retrieving the value of a specific setting.
     *
     * @export
     * @class GetSetting
     * @implements {EvaService}
     */
    class GetSetting {
        name = 'CoreManagement:GetSetting';
        path = '/message/GetSetting';
        request;
        response;
    }
    CoreManagement.GetSetting = GetSetting;
    /**
     * Yields the history of given setting.
     *
     * @export
     * @class GetSettingHistory
     * @implements {EvaService}
     */
    class GetSettingHistory {
        name = 'CoreManagement:GetSettingHistory';
        path = '/message/GetSettingHistory';
        request;
        response;
    }
    CoreManagement.GetSettingHistory = GetSettingHistory;
    /**
     * Get a `ShippingCost`
     *
     * @export
     * @class GetShippingCostByID
     * @implements {EvaService}
     */
    class GetShippingCostByID {
        name = 'CoreManagement:GetShippingCostByID';
        path = '/message/GetShippingCostByID';
        request;
        response;
    }
    CoreManagement.GetShippingCostByID = GetShippingCostByID;
    /**
     * Get an existing ShippingMethod by ID
     *
     * @export
     * @class GetShippingMethodByID
     * @implements {EvaService}
     */
    class GetShippingMethodByID {
        name = 'CoreManagement:GetShippingMethodByID';
        path = '/message/GetShippingMethodByID';
        request;
        response;
    }
    CoreManagement.GetShippingMethodByID = GetShippingMethodByID;
    /**
     * Gets a ShippingRestriction by its ID and returns the set's basic information.
     *
     * @export
     * @class GetShippingRestrictionByID
     * @implements {EvaService}
     */
    class GetShippingRestrictionByID {
        name = 'CoreManagement:GetShippingRestrictionByID';
        path = '/message/GetShippingRestrictionByID';
        request;
        response;
    }
    CoreManagement.GetShippingRestrictionByID = GetShippingRestrictionByID;
    /**
     * Get the available subscription handlers
     *
     * @export
     * @class GetSubscriptionHandlers
     * @implements {EvaService}
     */
    class GetSubscriptionHandlers {
        name = 'CoreManagement:GetSubscriptionHandlers';
        path = '/message/GetSubscriptionHandlers';
        request;
        response;
    }
    CoreManagement.GetSubscriptionHandlers = GetSubscriptionHandlers;
    /**
     * Gets all the SubscriptionOrganizationUnitSets and returns a paged response.
     *
     * @export
     * @class GetSubscriptionOrganizationUnitSets
     * @implements {EvaService}
     */
    class GetSubscriptionOrganizationUnitSets {
        name = 'CoreManagement:GetSubscriptionOrganizationUnitSets';
        path = '/message/GetSubscriptionOrganizationUnitSets';
        request;
        response;
    }
    CoreManagement.GetSubscriptionOrganizationUnitSets = GetSubscriptionOrganizationUnitSets;
    /**
     * Get a SupplierProduct by ID
     *
     * @export
     * @class GetSupplierProductByID
     * @implements {EvaService}
     */
    class GetSupplierProductByID {
        name = 'CoreManagement:GetSupplierProductByID';
        path = '/message/GetSupplierProductByID';
        request;
        response;
    }
    CoreManagement.GetSupplierProductByID = GetSupplierProductByID;
    /**
     * Retrieves the suppliers (Organization Units) for the given Product.
     *
     * @export
     * @class GetSuppliersForProduct
     * @implements {EvaService}
     */
    class GetSuppliersForProduct {
        name = 'CoreManagement:GetSuppliersForProduct';
        path = '/message/GetSuppliersForProduct';
        request;
        response;
    }
    CoreManagement.GetSuppliersForProduct = GetSuppliersForProduct;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class GetSupportedFunctionalities
     * @implements {EvaService}
     */
    class GetSupportedFunctionalities {
        name = 'CoreManagement:GetSupportedFunctionalities';
        path = '/message/GetSupportedFunctionalities';
        request;
        response;
    }
    CoreManagement.GetSupportedFunctionalities = GetSupportedFunctionalities;
    /**
     * Get the survey
     *
     * @export
     * @class GetSurveyByID
     * @implements {EvaService}
     */
    class GetSurveyByID {
        name = 'CoreManagement:GetSurveyByID';
        path = '/message/GetSurveyByID';
        request;
        response;
    }
    CoreManagement.GetSurveyByID = GetSurveyByID;
    /**
     * Get a question that is already answered (to navigate back and forth in the survey)
     *
     * @export
     * @class GetSurveyQuestionAnswer
     * @implements {EvaService}
     */
    class GetSurveyQuestionAnswer {
        name = 'CoreManagement:GetSurveyQuestionAnswer';
        path = '/message/GetSurveyQuestionAnswer';
        request;
        response;
    }
    CoreManagement.GetSurveyQuestionAnswer = GetSurveyQuestionAnswer;
    /**
     * Get the survey question
     *
     * @export
     * @class GetSurveyQuestionByID
     * @implements {EvaService}
     */
    class GetSurveyQuestionByID {
        name = 'CoreManagement:GetSurveyQuestionByID';
        path = '/message/GetSurveyQuestionByID';
        request;
        response;
    }
    CoreManagement.GetSurveyQuestionByID = GetSurveyQuestionByID;
    /**
     * List the UnitOfMeasures
     *
     * @export
     * @class GetUnitOfMeasures
     * @implements {EvaService}
     */
    class GetUnitOfMeasures {
        name = 'CoreManagement:GetUnitOfMeasures';
        path = '/message/GetUnitOfMeasures';
        request;
        response;
    }
    CoreManagement.GetUnitOfMeasures = GetUnitOfMeasures;
    /**
     * Get the user bought product by ID.
     *
     * @export
     * @class GetUserBoughtProduct
     * @implements {EvaService}
     */
    class GetUserBoughtProduct {
        name = 'CoreManagement:GetUserBoughtProduct';
        path = '/message/GetUserBoughtProduct';
        request;
        response;
    }
    CoreManagement.GetUserBoughtProduct = GetUserBoughtProduct;
    /**
     * Get a user bought product by a product's serial number.
     *
     * @export
     * @class GetUserBoughtProductBySerialNumber
     * @implements {EvaService}
     */
    class GetUserBoughtProductBySerialNumber {
        name = 'CoreManagement:GetUserBoughtProductBySerialNumber';
        path = '/message/GetUserBoughtProductBySerialNumber';
        request;
        response;
    }
    CoreManagement.GetUserBoughtProductBySerialNumber = GetUserBoughtProductBySerialNumber;
    /**
     * Get the coupons for a specific user
     *
     * @export
     * @class GetUserCoupons
     * @implements {EvaService}
     */
    class GetUserCoupons {
        name = 'CoreManagement:GetUserCoupons';
        path = '/message/GetUserCoupons';
        request;
        response;
    }
    CoreManagement.GetUserCoupons = GetUserCoupons;
    /**
     * List the UserOrigins
     *
     * @export
     * @class GetUserOrigins
     * @implements {EvaService}
     */
    class GetUserOrigins {
        name = 'CoreManagement:GetUserOrigins';
        path = '/message/GetUserOrigins';
        request;
        response;
    }
    CoreManagement.GetUserOrigins = GetUserOrigins;
    /**
     * Get all products for a personalized promotion for the logged in user or the given user.
     *
     * @export
     * @class GetUserPersonalizedPromotionProducts
     * @implements {EvaService}
     */
    class GetUserPersonalizedPromotionProducts {
        name = 'CoreManagement:GetUserPersonalizedPromotionProducts';
        path = '/message/GetUserPersonalizedPromotionProducts';
        request;
        response;
    }
    CoreManagement.GetUserPersonalizedPromotionProducts = GetUserPersonalizedPromotionProducts;
    /**
     * Gets UserRequirement by its ID.
     *
     * @export
     * @class GetUserRequirement
     * @implements {EvaService}
     */
    class GetUserRequirement {
        name = 'CoreManagement:GetUserRequirement';
        path = '/message/GetUserRequirement';
        request;
        response;
    }
    CoreManagement.GetUserRequirement = GetUserRequirement;
    /**
     * Get the configured UserRequirements for the current, or given, `OrganizationUnit`.
     *
     * @export
     * @class GetUserRequirements
     * @implements {EvaService}
     */
    class GetUserRequirements {
        name = 'CoreManagement:GetUserRequirements';
        path = '/message/GetUserRequirements';
        request;
        response;
    }
    CoreManagement.GetUserRequirements = GetUserRequirements;
    /**
     * Get the configured UserRequirements for the given Subscriptions.
     *
     * @export
     * @class GetUserRequirementsForSubscriptions
     * @implements {EvaService}
     */
    class GetUserRequirementsForSubscriptions {
        name = 'CoreManagement:GetUserRequirementsForSubscriptions';
        path = '/message/GetUserRequirementsForSubscriptions';
        request;
        response;
    }
    CoreManagement.GetUserRequirementsForSubscriptions = GetUserRequirementsForSubscriptions;
    /**
     * Return the current Roles for an User.
     *
     * @export
     * @class GetUserRoles
     * @implements {EvaService}
     */
    class GetUserRoles {
        name = 'CoreManagement:GetUserRoles';
        path = '/message/GetUserRoles';
        request;
        response;
    }
    CoreManagement.GetUserRoles = GetUserRoles;
    /**
     * Fetch the current attached roles to an User in a specific OrganizationUnit
     *
     * @export
     * @class GetUserRolesByUserID
     * @implements {EvaService}
     */
    class GetUserRolesByUserID {
        name = 'CoreManagement:GetUserRolesByUserID';
        path = '/message/GetUserRolesByUserID';
        request;
        response;
    }
    CoreManagement.GetUserRolesByUserID = GetUserRolesByUserID;
    /**
     * Generate a user subscription identifier barcode for the given user and subscription
     *
     * @export
     * @class GetUserSubscriptionBarcode
     * @implements {EvaService}
     */
    class GetUserSubscriptionBarcode {
        name = 'CoreManagement:GetUserSubscriptionBarcode';
        path = '/message/GetUserSubscriptionBarcode';
        request;
        response;
    }
    CoreManagement.GetUserSubscriptionBarcode = GetUserSubscriptionBarcode;
    /**
     * Gets an VisibilityGroup by its ID and returns the basic information.
     *
     * @export
     * @class GetVisibilityGroupByID
     * @implements {EvaService}
     */
    class GetVisibilityGroupByID {
        name = 'CoreManagement:GetVisibilityGroupByID';
        path = '/message/GetVisibilityGroupByID';
        request;
        response;
    }
    CoreManagement.GetVisibilityGroupByID = GetVisibilityGroupByID;
    /**
     * Gets an VisibilityGroup to VisibilityGroup configuration by its unique identifiers and returns the basic information.
     *
     * @export
     * @class GetVisibilityGroupConfiguration
     * @implements {EvaService}
     */
    class GetVisibilityGroupConfiguration {
        name = 'CoreManagement:GetVisibilityGroupConfiguration';
        path = '/message/GetVisibilityGroupConfiguration';
        request;
        response;
    }
    CoreManagement.GetVisibilityGroupConfiguration = GetVisibilityGroupConfiguration;
    /**
     * Get the wishlist by ID.
     *
     * @export
     * @class GetWishlist
     * @implements {EvaService}
     */
    class GetWishlist {
        name = 'CoreManagement:GetWishlist';
        path = '/message/GetWishlist';
        request;
        response;
    }
    CoreManagement.GetWishlist = GetWishlist;
    /**
     * Batch update/create settings through an Excel file (file can be retrieved by calling ExportSettings)
     *
     * @export
     * @class ImportSettings
     * @implements {EvaService}
     */
    class ImportSettings {
        name = 'CoreManagement:ImportSettings';
        path = '/message/ImportSettings';
        request;
        response;
    }
    CoreManagement.ImportSettings = ImportSettings;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class InitialReplenishment
     * @implements {EvaService}
     */
    class InitialReplenishment {
        name = 'CoreManagement:InitialReplenishment';
        path = '/message/InitialReplenishment';
        request;
        response;
    }
    CoreManagement.InitialReplenishment = InitialReplenishment;
    /**
     * List the active accounts

Available filters:
- Name
- ObjectAccount
     *
     * @export
     * @class ListAccounts
     * @implements {EvaService}
     */
    class ListAccounts {
        name = 'CoreManagement:ListAccounts';
        path = '/message/ListAccounts';
        request;
        response;
    }
    CoreManagement.ListAccounts = ListAccounts;
    /**
     * Yields the history of given app setting.
     *
     * @export
     * @class ListAppSettingHistory
     * @implements {EvaService}
     */
    class ListAppSettingHistory {
        name = 'CoreManagement:ListAppSettingHistory';
        path = '/message/ListAppSettingHistory';
        request;
        response;
    }
    CoreManagement.ListAppSettingHistory = ListAppSettingHistory;
    /**
     * List all configured AppSettings

Available filters
- OrganizationUnitID
- Name (partial match)
- App (exact match)
     *
     * @export
     * @class ListAppSettings
     * @implements {EvaService}
     */
    class ListAppSettings {
        name = 'CoreManagement:ListAppSettings';
        path = '/message/ListAppSettings';
        request;
        response;
    }
    CoreManagement.ListAppSettings = ListAppSettings;
    /**
     * Returns a paged result of all products in all assortments, unless a filter is provided on AssortmentID or ProductID.
In this manner, you can either get all products for an assortment (by filtering on AssortmentID), all assortments for a product (by filtering on ProductID)
or to get a specific product in an assortment by filtering on both.
     *
     * @export
     * @class ListAssortmentProducts
     * @implements {EvaService}
     */
    class ListAssortmentProducts {
        name = 'CoreManagement:ListAssortmentProducts';
        path = '/message/ListAssortmentProducts';
        request;
        response;
    }
    CoreManagement.ListAssortmentProducts = ListAssortmentProducts;
    /**
     * List existing assortments
     *
     * @export
     * @class ListAssortments
     * @implements {EvaService}
     */
    class ListAssortments {
        name = 'CoreManagement:ListAssortments';
        path = '/message/ListAssortments';
        request;
        response;
    }
    CoreManagement.ListAssortments = ListAssortments;
    /**
     * Lists the available discount conditions and actions.
     *
     * @export
     * @class ListAvailableDiscountActionsAndConditions
     * @implements {EvaService}
     */
    class ListAvailableDiscountActionsAndConditions {
        name = 'CoreManagement:ListAvailableDiscountActionsAndConditions';
        path = '/message/ListAvailableDiscountActionsAndConditions';
        request;
        response;
    }
    CoreManagement.ListAvailableDiscountActionsAndConditions = ListAvailableDiscountActionsAndConditions;
    /**
     * List all the blobs that are attached to the case.
     *
     * @export
     * @class ListBlobsForCase
     * @implements {EvaService}
     */
    class ListBlobsForCase {
        name = 'CoreManagement:ListBlobsForCase';
        path = '/message/ListBlobsForCase';
        request;
        response;
    }
    CoreManagement.ListBlobsForCase = ListBlobsForCase;
    /**
     * List the Carriers
     *
     * @export
     * @class ListCarriers
     * @implements {EvaService}
     */
    class ListCarriers {
        name = 'CoreManagement:ListCarriers';
        path = '/message/ListCarriers';
        request;
        response;
    }
    CoreManagement.ListCarriers = ListCarriers;
    /**
     * List the case interactions
     *
     * @export
     * @class ListCaseInteractions
     * @implements {EvaService}
     */
    class ListCaseInteractions {
        name = 'CoreManagement:ListCaseInteractions';
        path = '/message/ListCaseInteractions';
        request;
        response;
    }
    CoreManagement.ListCaseInteractions = ListCaseInteractions;
    /**
     * List the case statuses
     *
     * @export
     * @class ListCaseStatuses
     * @implements {EvaService}
     */
    class ListCaseStatuses {
        name = 'CoreManagement:ListCaseStatuses';
        path = '/message/ListCaseStatuses';
        request;
        response;
    }
    CoreManagement.ListCaseStatuses = ListCaseStatuses;
    /**
     * List the case topics
     *
     * @export
     * @class ListCaseTopics
     * @implements {EvaService}
     */
    class ListCaseTopics {
        name = 'CoreManagement:ListCaseTopics';
        path = '/message/ListCaseTopics';
        request;
        response;
    }
    CoreManagement.ListCaseTopics = ListCaseTopics;
    /**
     * List cases. Returns a paged response.
     *
     * @export
     * @class ListCases
     * @implements {EvaService}
     */
    class ListCases {
        name = 'CoreManagement:ListCases';
        path = '/message/ListCases';
        request;
        response;
    }
    CoreManagement.ListCases = ListCases;
    /**
     * Returns a paged result of all the cash correction reasons.
     *
     * @export
     * @class ListCashCorrectionReasons
     * @implements {EvaService}
     */
    class ListCashCorrectionReasons {
        name = 'CoreManagement:ListCashCorrectionReasons';
        path = '/message/ListCashCorrectionReasons';
        request;
        response;
    }
    CoreManagement.ListCashCorrectionReasons = ListCashCorrectionReasons;
    /**
     * Returns a paged result of all the cash expsense types.
     *
     * @export
     * @class ListCashExpenseTypes
     * @implements {EvaService}
     */
    class ListCashExpenseTypes {
        name = 'CoreManagement:ListCashExpenseTypes';
        path = '/message/ListCashExpenseTypes';
        request;
        response;
    }
    CoreManagement.ListCashExpenseTypes = ListCashExpenseTypes;
    /**
     * List CashHandlers
     *
     * @export
     * @class ListCashHandlers
     * @implements {EvaService}
     */
    class ListCashHandlers {
        name = 'CoreManagement:ListCashHandlers';
        path = '/message/ListCashHandlers';
        request;
        response;
    }
    CoreManagement.ListCashHandlers = ListCashHandlers;
    /**
     * List the CheckoutOptionCategories
     *
     * @export
     * @class ListCheckoutOptionCategories
     * @implements {EvaService}
     */
    class ListCheckoutOptionCategories {
        name = 'CoreManagement:ListCheckoutOptionCategories';
        path = '/message/ListCheckoutOptionCategories';
        request;
        response;
    }
    CoreManagement.ListCheckoutOptionCategories = ListCheckoutOptionCategories;
    /**
     * List ClientApplications. Returns a paged response.
     *
     * @export
     * @class ListClientApplications
     * @implements {EvaService}
     */
    class ListClientApplications {
        name = 'CoreManagement:ListClientApplications';
        path = '/message/ListClientApplications';
        request;
        response;
    }
    CoreManagement.ListClientApplications = ListClientApplications;
    /**
     * List Companies, optionally filtered.
     *
     * @export
     * @class ListCompanies
     * @implements {EvaService}
     */
    class ListCompanies {
        name = 'CoreManagement:ListCompanies';
        path = '/message/ListCompanies';
        request;
        response;
    }
    CoreManagement.ListCompanies = ListCompanies;
    /**
     * List the coupons
     *
     * @export
     * @class ListCouponsByQuery
     * @implements {EvaService}
     */
    class ListCouponsByQuery {
        name = 'CoreManagement:ListCouponsByQuery';
        path = '/message/ListCouponsByQuery';
        request;
        response;
    }
    CoreManagement.ListCouponsByQuery = ListCouponsByQuery;
    /**
     * List the available Cultures
     *
     * @export
     * @class ListCultures
     * @implements {EvaService}
     */
    class ListCultures {
        name = 'CoreManagement:ListCultures';
        path = '/message/ListCultures';
        request;
        response;
    }
    CoreManagement.ListCultures = ListCultures;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListCumulativeStock
     * @implements {EvaService}
     */
    class ListCumulativeStock {
        name = 'CoreManagement:ListCumulativeStock';
        path = '/message/ListCumulativeStock';
        request;
        response;
    }
    CoreManagement.ListCumulativeStock = ListCumulativeStock;
    /**
     * Lists all filter operators for every customfield datatype.
     *
     * @export
     * @class ListCustomFieldDataTypesOperators
     * @implements {EvaService}
     */
    class ListCustomFieldDataTypesOperators {
        name = 'CoreManagement:ListCustomFieldDataTypesOperators';
        path = '/message/ListCustomFieldDataTypesOperators';
        request;
        response;
    }
    CoreManagement.ListCustomFieldDataTypesOperators = ListCustomFieldDataTypesOperators;
    /**
     * Get all eligibility fields for the given custom field type.
     *
     * @export
     * @class ListCustomFieldEligibilityScripts
     * @implements {EvaService}
     */
    class ListCustomFieldEligibilityScripts {
        name = 'CoreManagement:ListCustomFieldEligibilityScripts';
        path = '/message/ListCustomFieldEligibilityScripts';
        request;
        response;
    }
    CoreManagement.ListCustomFieldEligibilityScripts = ListCustomFieldEligibilityScripts;
    /**
     * List options for custom fields
     *
     * @export
     * @class ListCustomFieldOptions
     * @implements {EvaService}
     */
    class ListCustomFieldOptions {
        name = 'CoreManagement:ListCustomFieldOptions';
        path = '/message/ListCustomFieldOptions';
        request;
        response;
    }
    CoreManagement.ListCustomFieldOptions = ListCustomFieldOptions;
    /**
     * List CustomFields. Returns a paged response.
     *
     * @export
     * @class ListCustomFields
     * @implements {EvaService}
     */
    class ListCustomFields {
        name = 'CoreManagement:ListCustomFields';
        path = '/message/ListCustomFields';
        request;
        response;
    }
    CoreManagement.ListCustomFields = ListCustomFields;
    /**
     * List the DiscountCampaigns
     *
     * @export
     * @class ListDiscountCampaigns
     * @implements {EvaService}
     */
    class ListDiscountCampaigns {
        name = 'CoreManagement:ListDiscountCampaigns';
        path = '/message/ListDiscountCampaigns';
        request;
        response;
    }
    CoreManagement.ListDiscountCampaigns = ListDiscountCampaigns;
    /**
     * List the DiscountLayers
     *
     * @export
     * @class ListDiscountLayers
     * @implements {EvaService}
     */
    class ListDiscountLayers {
        name = 'CoreManagement:ListDiscountLayers';
        path = '/message/ListDiscountLayers';
        request;
        response;
    }
    CoreManagement.ListDiscountLayers = ListDiscountLayers;
    /**
     * Searches the DiscountTemplates with the given filter and returns a paged response.
     *
     * @export
     * @class ListDiscountTemplates
     * @implements {EvaService}
     */
    class ListDiscountTemplates {
        name = 'CoreManagement:ListDiscountTemplates';
        path = '/message/ListDiscountTemplates';
        request;
        response;
    }
    CoreManagement.ListDiscountTemplates = ListDiscountTemplates;
    /**
     * Lists the available discount user usage reload strategies.
     *
     * @export
     * @class ListDiscountUserUsageReloadStrategies
     * @implements {EvaService}
     */
    class ListDiscountUserUsageReloadStrategies {
        name = 'CoreManagement:ListDiscountUserUsageReloadStrategies';
        path = '/message/ListDiscountUserUsageReloadStrategies';
        request;
        response;
    }
    CoreManagement.ListDiscountUserUsageReloadStrategies = ListDiscountUserUsageReloadStrategies;
    /**
     * List a users employee data.
     *
     * @export
     * @class ListEmployeeDatas
     * @implements {EvaService}
     */
    class ListEmployeeDatas {
        name = 'CoreManagement:ListEmployeeDatas';
        path = '/message/ListEmployeeDatas';
        request;
        response;
    }
    CoreManagement.ListEmployeeDatas = ListEmployeeDatas;
    /**
     * List all entity field validator entities and entity names
     *
     * @export
     * @class ListEntityFieldValidatorEntityFieldNames
     * @implements {EvaService}
     */
    class ListEntityFieldValidatorEntityFieldNames {
        name = 'CoreManagement:ListEntityFieldValidatorEntityFieldNames';
        path = '/message/ListEntityFieldValidatorEntityFieldNames';
        request;
        response;
    }
    CoreManagement.ListEntityFieldValidatorEntityFieldNames = ListEntityFieldValidatorEntityFieldNames;
    /**
     * list all entity field validators
     *
     * @export
     * @class ListEntityFieldValidators
     * @implements {EvaService}
     */
    class ListEntityFieldValidators {
        name = 'CoreManagement:ListEntityFieldValidators';
        path = '/message/ListEntityFieldValidators';
        request;
        response;
    }
    CoreManagement.ListEntityFieldValidators = ListEntityFieldValidators;
    /**
     * List the ExchangeRates
     *
     * @export
     * @class ListExchangeRates
     * @implements {EvaService}
     */
    class ListExchangeRates {
        name = 'CoreManagement:ListExchangeRates';
        path = '/message/ListExchangeRates';
        request;
        response;
    }
    CoreManagement.ListExchangeRates = ListExchangeRates;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListFraudItems
     * @implements {EvaService}
     */
    class ListFraudItems {
        name = 'CoreManagement:ListFraudItems';
        path = '/message/ListFraudItems';
        request;
        response;
    }
    CoreManagement.ListFraudItems = ListFraudItems;
    /**
     * List the GiftCardConfigurations

`GiftCardConfiguration`: an item that describes the giftcard properties of a product with type GiftCard
     *
     * @export
     * @class ListGiftCardConfigurations
     * @implements {EvaService}
     */
    class ListGiftCardConfigurations {
        name = 'CoreManagement:ListGiftCardConfigurations';
        path = '/message/ListGiftCardConfigurations';
        request;
        response;
    }
    CoreManagement.ListGiftCardConfigurations = ListGiftCardConfigurations;
    /**
     * List the inquiries
     *
     * @export
     * @class ListInquiries
     * @implements {EvaService}
     */
    class ListInquiries {
        name = 'CoreManagement:ListInquiries';
        path = '/message/ListInquiries';
        request;
        response;
    }
    CoreManagement.ListInquiries = ListInquiries;
    /**
     * Lists all payment types under the Loyalty payment method that aren't already connected to a loyalty program.
     *
     * @export
     * @class ListLoyaltyPaymentMethodTypes
     * @implements {EvaService}
     */
    class ListLoyaltyPaymentMethodTypes {
        name = 'CoreManagement:ListLoyaltyPaymentMethodTypes';
        path = '/message/ListLoyaltyPaymentMethodTypes';
        request;
        response;
    }
    CoreManagement.ListLoyaltyPaymentMethodTypes = ListLoyaltyPaymentMethodTypes;
    /**
     * List the LoyaltyProgramCondition
     *
     * @export
     * @class ListLoyaltyProgramConditions
     * @implements {EvaService}
     */
    class ListLoyaltyProgramConditions {
        name = 'CoreManagement:ListLoyaltyProgramConditions';
        path = '/message/ListLoyaltyProgramConditions';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramConditions = ListLoyaltyProgramConditions;
    /**
     * List the LoyaltyProgramGroups
     *
     * @export
     * @class ListLoyaltyProgramGroups
     * @implements {EvaService}
     */
    class ListLoyaltyProgramGroups {
        name = 'CoreManagement:ListLoyaltyProgramGroups';
        path = '/message/ListLoyaltyProgramGroups';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramGroups = ListLoyaltyProgramGroups;
    /**
     * List the LoyaltyProgramPaymentType
     *
     * @export
     * @class ListLoyaltyProgramPaymentTypes
     * @implements {EvaService}
     */
    class ListLoyaltyProgramPaymentTypes {
        name = 'CoreManagement:ListLoyaltyProgramPaymentTypes';
        path = '/message/ListLoyaltyProgramPaymentTypes';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramPaymentTypes = ListLoyaltyProgramPaymentTypes;
    /**
     * List the loyalty program pricelists
     *
     * @export
     * @class ListLoyaltyProgramPriceLists
     * @implements {EvaService}
     */
    class ListLoyaltyProgramPriceLists {
        name = 'CoreManagement:ListLoyaltyProgramPriceLists';
        path = '/message/ListLoyaltyProgramPriceLists';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramPriceLists = ListLoyaltyProgramPriceLists;
    /**
     * List the loyalty program product limitations
     *
     * @export
     * @class ListLoyaltyProgramProductLimitations
     * @implements {EvaService}
     */
    class ListLoyaltyProgramProductLimitations {
        name = 'CoreManagement:ListLoyaltyProgramProductLimitations';
        path = '/message/ListLoyaltyProgramProductLimitations';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramProductLimitations = ListLoyaltyProgramProductLimitations;
    /**
     * List the loyalty program CustomFieldRequirements
     *
     * @export
     * @class ListLoyaltyProgramRequiredCustomFields
     * @implements {EvaService}
     */
    class ListLoyaltyProgramRequiredCustomFields {
        name = 'CoreManagement:ListLoyaltyProgramRequiredCustomFields';
        path = '/message/ListLoyaltyProgramRequiredCustomFields';
        request;
        response;
    }
    CoreManagement.ListLoyaltyProgramRequiredCustomFields = ListLoyaltyProgramRequiredCustomFields;
    /**
     * List the LoyaltyPrograms
     *
     * @export
     * @class ListLoyaltyPrograms
     * @implements {EvaService}
     */
    class ListLoyaltyPrograms {
        name = 'CoreManagement:ListLoyaltyPrograms';
        path = '/message/ListLoyaltyPrograms';
        request;
        response;
    }
    CoreManagement.ListLoyaltyPrograms = ListLoyaltyPrograms;
    /**
     * List the ShippingMethods
     *
     * @export
     * @class ListManagementShippingMethods
     * @implements {EvaService}
     */
    class ListManagementShippingMethods {
        name = 'CoreManagement:ListManagementShippingMethods';
        path = '/message/ListManagementShippingMethods';
        request;
        response;
    }
    CoreManagement.ListManagementShippingMethods = ListManagementShippingMethods;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListMessageTemplateLayouts
     * @implements {EvaService}
     */
    class ListMessageTemplateLayouts {
        name = 'CoreManagement:ListMessageTemplateLayouts';
        path = '/message/ListMessageTemplateLayouts';
        request;
        response;
    }
    CoreManagement.ListMessageTemplateLayouts = ListMessageTemplateLayouts;
    /**
     * List the MessageTemplates
     *
     * @export
     * @class ListMessageTemplates
     * @implements {EvaService}
     */
    class ListMessageTemplates {
        name = 'CoreManagement:ListMessageTemplates';
        path = '/message/ListMessageTemplates';
        request;
        response;
    }
    CoreManagement.ListMessageTemplates = ListMessageTemplates;
    /**
     * List organizationunit openinghours
     *
     * @export
     * @class ListOpeningHours
     * @implements {EvaService}
     */
    class ListOpeningHours {
        name = 'CoreManagement:ListOpeningHours';
        path = '/message/ListOpeningHours';
        request;
        response;
    }
    CoreManagement.ListOpeningHours = ListOpeningHours;
    /**
     * List the coupons that are generated on an order
     *
     * @export
     * @class ListOrderGeneratedCoupons
     * @implements {EvaService}
     */
    class ListOrderGeneratedCoupons {
        name = 'CoreManagement:ListOrderGeneratedCoupons';
        path = '/message/ListOrderGeneratedCoupons';
        request;
        response;
    }
    CoreManagement.ListOrderGeneratedCoupons = ListOrderGeneratedCoupons;
    /**
     * Returns a list of "OrderLedgerType"
     *
     * @export
     * @class ListOrderLedgerTypes
     * @implements {EvaService}
     */
    class ListOrderLedgerTypes {
        name = 'CoreManagement:ListOrderLedgerTypes';
        path = '/message/ListOrderLedgerTypes';
        request;
        response;
    }
    CoreManagement.ListOrderLedgerTypes = ListOrderLedgerTypes;
    /**
     * List the organization unit countries.
     *
     * @export
     * @class ListOrganizationUnitCountries
     * @implements {EvaService}
     */
    class ListOrganizationUnitCountries {
        name = 'CoreManagement:ListOrganizationUnitCountries';
        path = '/message/ListOrganizationUnitCountries';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitCountries = ListOrganizationUnitCountries;
    /**
     * List the configured additional currencies for the given OrganizationUnit

It is required to set the OrganizationUnitID on the filter.
     *
     * @export
     * @class ListOrganizationUnitCurrencies
     * @implements {EvaService}
     */
    class ListOrganizationUnitCurrencies {
        name = 'CoreManagement:ListOrganizationUnitCurrencies';
        path = '/message/ListOrganizationUnitCurrencies';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitCurrencies = ListOrganizationUnitCurrencies;
    /**
     * Retrieve a list of OrganizationUnit languages
     *
     * @export
     * @class ListOrganizationUnitLanguages
     * @implements {EvaService}
     */
    class ListOrganizationUnitLanguages {
        name = 'CoreManagement:ListOrganizationUnitLanguages';
        path = '/message/ListOrganizationUnitLanguages';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitLanguages = ListOrganizationUnitLanguages;
    /**
     * List the OrganizationUnitSetPaymentTypes

There are filters available on:
 - PaymentTypeID
 - OrganizationUnitSetID
 - RefundPriority
 - CaptureMoment
 - DisableForDeliveryOrders
 - DisableForReserveOrders
 - DisableForCarryOutOrders
     *
     * @export
     * @class ListOrganizationUnitSetPaymentTypes
     * @implements {EvaService}
     */
    class ListOrganizationUnitSetPaymentTypes {
        name = 'CoreManagement:ListOrganizationUnitSetPaymentTypes';
        path = '/message/ListOrganizationUnitSetPaymentTypes';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitSetPaymentTypes = ListOrganizationUnitSetPaymentTypes;
    /**
     * Lists OrganizationUnitSets, optionally filtered and paged.
     *
     * @export
     * @class ListOrganizationUnitSets
     * @implements {EvaService}
     */
    class ListOrganizationUnitSets {
        name = 'CoreManagement:ListOrganizationUnitSets';
        path = '/message/ListOrganizationUnitSets';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitSets = ListOrganizationUnitSets;
    /**
     * List the OrganizationUnitShippingMethods

There are filters available on:
 - ShippingMethodID
 - OrganizationUnitID
     *
     * @export
     * @class ListOrganizationUnitShippingMethods
     * @implements {EvaService}
     */
    class ListOrganizationUnitShippingMethods {
        name = 'CoreManagement:ListOrganizationUnitShippingMethods';
        path = '/message/ListOrganizationUnitShippingMethods';
        request;
        response;
    }
    CoreManagement.ListOrganizationUnitShippingMethods = ListOrganizationUnitShippingMethods;
    /**
     * List PaymentMethods. Returns a paged response.
     *
     * @export
     * @class ListPaymentMethods
     * @implements {EvaService}
     */
    class ListPaymentMethods {
        name = 'CoreManagement:ListPaymentMethods';
        path = '/message/ListPaymentMethods';
        request;
        response;
    }
    CoreManagement.ListPaymentMethods = ListPaymentMethods;
    /**
     * List uploaded settlement files

Filters available:
- Name
- Status
- Handler
     *
     * @export
     * @class ListPaymentSettlementFiles
     * @implements {EvaService}
     */
    class ListPaymentSettlementFiles {
        name = 'CoreManagement:ListPaymentSettlementFiles';
        path = '/message/ListPaymentSettlementFiles';
        request;
        response;
    }
    CoreManagement.ListPaymentSettlementFiles = ListPaymentSettlementFiles;
    /**
     * List created settlements

Filters available:
- PaymentTransactionID
- TypeID
- FinancialPeriodID
- OrganizationUnitID
     *
     * @export
     * @class ListPaymentSettlements
     * @implements {EvaService}
     */
    class ListPaymentSettlements {
        name = 'CoreManagement:ListPaymentSettlements';
        path = '/message/ListPaymentSettlements';
        request;
        response;
    }
    CoreManagement.ListPaymentSettlements = ListPaymentSettlements;
    /**
     * List paymenttransactionCaptures

All available filters are typed in the PageConfig.Filter property.
     *
     * @export
     * @class ListPaymentTransactionCaptures
     * @implements {EvaService}
     */
    class ListPaymentTransactionCaptures {
        name = 'CoreManagement:ListPaymentTransactionCaptures';
        path = '/message/ListPaymentTransactionCaptures';
        request;
        response;
    }
    CoreManagement.ListPaymentTransactionCaptures = ListPaymentTransactionCaptures;
    /**
     * List paymenttransactionssettlements

Filters available to be sent in the request:
- FinancialPeriodID
- PaymentReference
- MerchantReference
- Type
- SubType
     *
     * @export
     * @class ListPaymentTransactionSettlements
     * @implements {EvaService}
     */
    class ListPaymentTransactionSettlements {
        name = 'CoreManagement:ListPaymentTransactionSettlements';
        path = '/message/ListPaymentTransactionSettlements';
        request;
        response;
    }
    CoreManagement.ListPaymentTransactionSettlements = ListPaymentTransactionSettlements;
    /**
     * List paymenttransactions

All available filters are typed in the PageConfig.Filter property.
     *
     * @export
     * @class ListPaymentTransactions
     * @implements {EvaService}
     */
    class ListPaymentTransactions {
        name = 'CoreManagement:ListPaymentTransactions';
        path = '/message/ListPaymentTransactions';
        request;
        response;
    }
    CoreManagement.ListPaymentTransactions = ListPaymentTransactions;
    /**
     * List PaymentTypes. Returns a paged response.
     *
     * @export
     * @class ListPaymentTypes
     * @implements {EvaService}
     */
    class ListPaymentTypes {
        name = 'CoreManagement:ListPaymentTypes';
        path = '/message/ListPaymentTypes';
        request;
        response;
    }
    CoreManagement.ListPaymentTypes = ListPaymentTypes;
    /**
     * List personalized promotions. Returns a paged response.
     *
     * @export
     * @class ListPersonalizedPromotions
     * @implements {EvaService}
     */
    class ListPersonalizedPromotions {
        name = 'CoreManagement:ListPersonalizedPromotions';
        path = '/message/ListPersonalizedPromotions';
        request;
        response;
    }
    CoreManagement.ListPersonalizedPromotions = ListPersonalizedPromotions;
    /**
     * List loyalty point rules. Returns a paged response.
     *
     * @export
     * @class ListPointAwardingRules
     * @implements {EvaService}
     */
    class ListPointAwardingRules {
        name = 'CoreManagement:ListPointAwardingRules';
        path = '/message/ListPointAwardingRules';
        request;
        response;
    }
    CoreManagement.ListPointAwardingRules = ListPointAwardingRules;
    /**
     * List the PriceListAdjustments
     *
     * @export
     * @class ListPriceListAdjustments
     * @implements {EvaService}
     */
    class ListPriceListAdjustments {
        name = 'CoreManagement:ListPriceListAdjustments';
        path = '/message/ListPriceListAdjustments';
        request;
        response;
    }
    CoreManagement.ListPriceListAdjustments = ListPriceListAdjustments;
    /**
     * List the PriceListManualInputAdjustments, it is required to supply at least an PriceListAdjustmentID in the Filter
     *
     * @export
     * @class ListPriceListManualInputAdjustments
     * @implements {EvaService}
     */
    class ListPriceListManualInputAdjustments {
        name = 'CoreManagement:ListPriceListManualInputAdjustments';
        path = '/message/ListPriceListManualInputAdjustments';
        request;
        response;
    }
    CoreManagement.ListPriceListManualInputAdjustments = ListPriceListManualInputAdjustments;
    /**
     * List the PriceListOrganizationUnits
     *
     * @export
     * @class ListPriceListOrganizationUnits
     * @implements {EvaService}
     */
    class ListPriceListOrganizationUnits {
        name = 'CoreManagement:ListPriceListOrganizationUnits';
        path = '/message/ListPriceListOrganizationUnits';
        request;
        response;
    }
    CoreManagement.ListPriceListOrganizationUnits = ListPriceListOrganizationUnits;
    /**
     * List PriceLists
     *
     * @export
     * @class ListPriceLists
     * @implements {EvaService}
     */
    class ListPriceLists {
        name = 'CoreManagement:ListPriceLists';
        path = '/message/ListPriceLists';
        request;
        response;
    }
    CoreManagement.ListPriceLists = ListPriceLists;
    /**
     * Retrieve a list of OrganizationUnit PriceLists

It's required to set the OrganizationUnitID filter
     *
     * @export
     * @class ListPriceListsForOrganizationUnit
     * @implements {EvaService}
     */
    class ListPriceListsForOrganizationUnit {
        name = 'CoreManagement:ListPriceListsForOrganizationUnit';
        path = '/message/ListPriceListsForOrganizationUnit';
        request;
        response;
    }
    CoreManagement.ListPriceListsForOrganizationUnit = ListPriceListsForOrganizationUnit;
    /**
     * The page size `Limit` has a maximum value of `1.000` for this service.
     *
     * @export
     * @class ListProductBarcodes
     * @implements {EvaService}
     */
    class ListProductBarcodes {
        name = 'CoreManagement:ListProductBarcodes';
        path = '/message/ListProductBarcodes';
        request;
        response;
    }
    CoreManagement.ListProductBarcodes = ListProductBarcodes;
    /**
     * This service lets you view the ProductCostPriceLedger, optionally filtered by ProductID/OrganizationUnitID and others.

The ProductCostPriceLedger is used to determine the cost prices of stock for OrganizationUnits that use CostPriceCalculationMethod = Fifo.

For those OrganizationUnits, whenever stock is received in them, a record is stored in the ProductCostPriceLedger noting the quantity and the purchase price of that stock and then whenever
stock is reduced this ledger is consulted in a first-in-first-out manner to determine the cost price of that stock mutation. This service gives you insight into that ledger.
     *
     * @export
     * @class ListProductCostPriceLedger
     * @implements {EvaService}
     */
    class ListProductCostPriceLedger {
        name = 'CoreManagement:ListProductCostPriceLedger';
        path = '/message/ListProductCostPriceLedger';
        request;
        response;
    }
    CoreManagement.ListProductCostPriceLedger = ListProductCostPriceLedger;
    /**
     * List the ProductGiftCards

`ProductGiftCard`: an item that describes the giftcard properties of a product with type GiftCard
     *
     * @export
     * @class ListProductGiftCards
     * @implements {EvaService}
     */
    class ListProductGiftCards {
        name = 'CoreManagement:ListProductGiftCards';
        path = '/message/ListProductGiftCards';
        request;
        response;
    }
    CoreManagement.ListProductGiftCards = ListProductGiftCards;
    /**
     * List the pricechanges

It is required to supply some OrganizationUnitIDs or some ProductIDs in the PageConfig filter.
     *
     * @export
     * @class ListProductPriceLedger
     * @implements {EvaService}
     */
    class ListProductPriceLedger {
        name = 'CoreManagement:ListProductPriceLedger';
        path = '/message/ListProductPriceLedger';
        request;
        response;
    }
    CoreManagement.ListProductPriceLedger = ListProductPriceLedger;
    /**
     * List existing Product Requirements
     *
     * @export
     * @class ListProductRequirements
     * @implements {EvaService}
     */
    class ListProductRequirements {
        name = 'CoreManagement:ListProductRequirements';
        path = '/message/ListProductRequirements';
        request;
        response;
    }
    CoreManagement.ListProductRequirements = ListProductRequirements;
    /**
     * Lists the persisted output of product search templates
     *
     * @export
     * @class ListProductSearchTemplateResults
     * @implements {EvaService}
     */
    class ListProductSearchTemplateResults {
        name = 'CoreManagement:ListProductSearchTemplateResults';
        path = '/message/ListProductSearchTemplateResults';
        request;
        response;
    }
    CoreManagement.ListProductSearchTemplateResults = ListProductSearchTemplateResults;
    /**
     * List the ProductSearchTemplates
     *
     * @export
     * @class ListProductSearchTemplates
     * @implements {EvaService}
     */
    class ListProductSearchTemplates {
        name = 'CoreManagement:ListProductSearchTemplates';
        path = '/message/ListProductSearchTemplates';
        request;
        response;
    }
    CoreManagement.ListProductSearchTemplates = ListProductSearchTemplates;
    /**
     * List the ProductUnitOfMeasures
     *
     * @export
     * @class ListProductUnitOfMeasures
     * @implements {EvaService}
     */
    class ListProductUnitOfMeasures {
        name = 'CoreManagement:ListProductUnitOfMeasures';
        path = '/message/ListProductUnitOfMeasures';
        request;
        response;
    }
    CoreManagement.ListProductUnitOfMeasures = ListProductUnitOfMeasures;
    /**
     * Returns a paged result of all the refund reasons.
     *
     * @export
     * @class ListRefundCorrectionReasons
     * @implements {EvaService}
     */
    class ListRefundCorrectionReasons {
        name = 'CoreManagement:ListRefundCorrectionReasons';
        path = '/message/ListRefundCorrectionReasons';
        request;
        response;
    }
    CoreManagement.ListRefundCorrectionReasons = ListRefundCorrectionReasons;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListRestockedProducts
     * @implements {EvaService}
     */
    class ListRestockedProducts {
        name = 'CoreManagement:ListRestockedProducts';
        path = '/message/ListRestockedProducts';
        request;
        response;
    }
    CoreManagement.ListRestockedProducts = ListRestockedProducts;
    /**
     * List all return reasons. Does not support sorting. Always sorted by `Priority`
     *
     * @export
     * @class ListReturnReasons
     * @implements {EvaService}
     */
    class ListReturnReasons {
        name = 'CoreManagement:ListReturnReasons';
        path = '/message/ListReturnReasons';
        request;
        response;
    }
    CoreManagement.ListReturnReasons = ListReturnReasons;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListRoleSets
     * @implements {EvaService}
     */
    class ListRoleSets {
        name = 'CoreManagement:ListRoleSets';
        path = '/message/ListRoleSets';
        request;
        response;
    }
    CoreManagement.ListRoleSets = ListRoleSets;
    /**
     * List all roles.
     *
     * @export
     * @class ListRoles
     * @implements {EvaService}
     */
    class ListRoles {
        name = 'CoreManagement:ListRoles';
        path = '/message/ListRoles';
        request;
        response;
    }
    CoreManagement.ListRoles = ListRoles;
    /**
     * Yields the history of given setting.
     *
     * @export
     * @class ListSettingHistory
     * @implements {EvaService}
     */
    class ListSettingHistory {
        name = 'CoreManagement:ListSettingHistory';
        path = '/message/ListSettingHistory';
        request;
        response;
    }
    CoreManagement.ListSettingHistory = ListSettingHistory;
    /**
     * List the settings related to given `OrganizationUnitID`.
     *
     * @export
     * @class ListSettings
     * @implements {EvaService}
     */
    class ListSettings {
        name = 'CoreManagement:ListSettings';
        path = '/message/ListSettings';
        request;
        response;
    }
    CoreManagement.ListSettings = ListSettings;
    /**
     * List all settings of the user's current organization unit and its 'children', per organization unit.
     *
     * @export
     * @class ListSettingsPerOrganizationUnit
     * @implements {EvaService}
     */
    class ListSettingsPerOrganizationUnit {
        name = 'CoreManagement:ListSettingsPerOrganizationUnit';
        path = '/message/ListSettingsPerOrganizationUnit';
        request;
        response;
    }
    CoreManagement.ListSettingsPerOrganizationUnit = ListSettingsPerOrganizationUnit;
    /**
     * List the available `ShippingCost`
     *
     * @export
     * @class ListShippingCosts
     * @implements {EvaService}
     */
    class ListShippingCosts {
        name = 'CoreManagement:ListShippingCosts';
        path = '/message/ListShippingCosts';
        request;
        response;
    }
    CoreManagement.ListShippingCosts = ListShippingCosts;
    /**
     * Lists current ShippingMethodTransportationTimes, optionally filtered.
     *
     * @export
     * @class ListShippingMethodTransportationTimes
     * @implements {EvaService}
     */
    class ListShippingMethodTransportationTimes {
        name = 'CoreManagement:ListShippingMethodTransportationTimes';
        path = '/message/ListShippingMethodTransportationTimes';
        request;
        response;
    }
    CoreManagement.ListShippingMethodTransportationTimes = ListShippingMethodTransportationTimes;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListShippingMethods
     * @implements {EvaService}
     */
    class ListShippingMethods {
        name = 'CoreManagement:ListShippingMethods';
        path = '/message/ListShippingMethods';
        request;
        response;
    }
    CoreManagement.ListShippingMethods = ListShippingMethods;
    /**
     * List ShippingRestrictions. Returns a paged response. Filter options are;
     *
     * @export
     * @class ListShippingRestrictions
     * @implements {EvaService}
     */
    class ListShippingRestrictions {
        name = 'CoreManagement:ListShippingRestrictions';
        path = '/message/ListShippingRestrictions';
        request;
        response;
    }
    CoreManagement.ListShippingRestrictions = ListShippingRestrictions;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListStockAllocationRules
     * @implements {EvaService}
     */
    class ListStockAllocationRules {
        name = 'CoreManagement:ListStockAllocationRules';
        path = '/message/ListStockAllocationRules';
        request;
        response;
    }
    CoreManagement.ListStockAllocationRules = ListStockAllocationRules;
    /**
     * List the Stock per product/stocklabel for a subset of OrganizationUnits.

The page size `Limit` has a maximum value of `1.024` for this service (unless `DownloadOverview` is `true`).

If neither `OrganizationUnitIDs` nor `OrganizationUnitSetID` are specified, the service will return an empty result.
     *
     * @export
     * @class ListStockForOrganizationUnits
     * @implements {EvaService}
     */
    class ListStockForOrganizationUnits {
        name = 'CoreManagement:ListStockForOrganizationUnits';
        path = '/message/ListStockForOrganizationUnits';
        request;
        response;
    }
    CoreManagement.ListStockForOrganizationUnits = ListStockForOrganizationUnits;
    /**
     * List internal and custom stock mutation reasons.
     *
     * @export
     * @class ListStockMutationReasons
     * @implements {EvaService}
     */
    class ListStockMutationReasons {
        name = 'CoreManagement:ListStockMutationReasons';
        path = '/message/ListStockMutationReasons';
        request;
        response;
    }
    CoreManagement.ListStockMutationReasons = ListStockMutationReasons;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListStockMutationUnitCostSourceLedger
     * @implements {EvaService}
     */
    class ListStockMutationUnitCostSourceLedger {
        name = 'CoreManagement:ListStockMutationUnitCostSourceLedger';
        path = '/message/ListStockMutationUnitCostSourceLedger';
        request;
        response;
    }
    CoreManagement.ListStockMutationUnitCostSourceLedger = ListStockMutationUnitCostSourceLedger;
    /**
     * List all users attached to a subscription. Requires View rights on Subscriptions and Customers functionalities.
     *
     * @export
     * @class ListSubscriptionUsers
     * @implements {EvaService}
     */
    class ListSubscriptionUsers {
        name = 'CoreManagement:ListSubscriptionUsers';
        path = '/message/ListSubscriptionUsers';
        request;
        response;
    }
    CoreManagement.ListSubscriptionUsers = ListSubscriptionUsers;
    /**
     * List the Subscriptions
     *
     * @export
     * @class ListSubscriptions
     * @implements {EvaService}
     */
    class ListSubscriptions {
        name = 'CoreManagement:ListSubscriptions';
        path = '/message/ListSubscriptions';
        request;
        response;
    }
    CoreManagement.ListSubscriptions = ListSubscriptions;
    /**
     * List the SupplierProducts

`SupplierProduct`: an item that describes the giftcard properties of a product with type GiftCard
     *
     * @export
     * @class ListSupplierProducts
     * @implements {EvaService}
     */
    class ListSupplierProducts {
        name = 'CoreManagement:ListSupplierProducts';
        path = '/message/ListSupplierProducts';
        request;
        response;
    }
    CoreManagement.ListSupplierProducts = ListSupplierProducts;
    /**
     * List the survey questions
     *
     * @export
     * @class ListSurveyQuestions
     * @implements {EvaService}
     */
    class ListSurveyQuestions {
        name = 'CoreManagement:ListSurveyQuestions';
        path = '/message/ListSurveyQuestions';
        request;
        response;
    }
    CoreManagement.ListSurveyQuestions = ListSurveyQuestions;
    /**
     * List the surveys
     *
     * @export
     * @class ListSurveys
     * @implements {EvaService}
     */
    class ListSurveys {
        name = 'CoreManagement:ListSurveys';
        path = '/message/ListSurveys';
        request;
        response;
    }
    CoreManagement.ListSurveys = ListSurveys;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ListTemplateHandlers
     * @implements {EvaService}
     */
    class ListTemplateHandlers {
        name = 'CoreManagement:ListTemplateHandlers';
        path = '/message/ListTemplateHandlers';
        request;
        response;
    }
    CoreManagement.ListTemplateHandlers = ListTemplateHandlers;
    /**
     * Returns a paged result of all the unit price correction reasons.
     *
     * @export
     * @class ListUnitPriceCorrectionReasons
     * @implements {EvaService}
     */
    class ListUnitPriceCorrectionReasons {
        name = 'CoreManagement:ListUnitPriceCorrectionReasons';
        path = '/message/ListUnitPriceCorrectionReasons';
        request;
        response;
    }
    CoreManagement.ListUnitPriceCorrectionReasons = ListUnitPriceCorrectionReasons;
    /**
     * List the users bought products.
     *
     * @export
     * @class ListUserBoughtProducts
     * @implements {EvaService}
     */
    class ListUserBoughtProducts {
        name = 'CoreManagement:ListUserBoughtProducts';
        path = '/message/ListUserBoughtProducts';
        request;
        response;
    }
    CoreManagement.ListUserBoughtProducts = ListUserBoughtProducts;
    /**
     * Lists organization units and roles for user
     *
     * @export
     * @class ListUserOrganizationUnitRoles
     * @implements {EvaService}
     */
    class ListUserOrganizationUnitRoles {
        name = 'CoreManagement:ListUserOrganizationUnitRoles';
        path = '/message/ListUserOrganizationUnitRoles';
        request;
        response;
    }
    CoreManagement.ListUserOrganizationUnitRoles = ListUserOrganizationUnitRoles;
    /**
     * Get all personalized promotions for the logged in user or the given user.
     *
     * @export
     * @class ListUserPersonalizedPromotions
     * @implements {EvaService}
     */
    class ListUserPersonalizedPromotions {
        name = 'CoreManagement:ListUserPersonalizedPromotions';
        path = '/message/ListUserPersonalizedPromotions';
        request;
        response;
    }
    CoreManagement.ListUserPersonalizedPromotions = ListUserPersonalizedPromotions;
    /**
     * List the UserRequirementSets.
     *
     * @export
     * @class ListUserRequirementSets
     * @implements {EvaService}
     */
    class ListUserRequirementSets {
        name = 'CoreManagement:ListUserRequirementSets';
        path = '/message/ListUserRequirementSets';
        request;
        response;
    }
    CoreManagement.ListUserRequirementSets = ListUserRequirementSets;
    /**
     * List the UserRequirements.
     *
     * @export
     * @class ListUserRequirements
     * @implements {EvaService}
     */
    class ListUserRequirements {
        name = 'CoreManagement:ListUserRequirements';
        path = '/message/ListUserRequirements';
        request;
        response;
    }
    CoreManagement.ListUserRequirements = ListUserRequirements;
    /**
     * List VisibilityGroupVisibilityGroups. Returns a paged response.
     *
     * @export
     * @class ListVisibilityGroupConfigurations
     * @implements {EvaService}
     */
    class ListVisibilityGroupConfigurations {
        name = 'CoreManagement:ListVisibilityGroupConfigurations';
        path = '/message/ListVisibilityGroupConfigurations';
        request;
        response;
    }
    CoreManagement.ListVisibilityGroupConfigurations = ListVisibilityGroupConfigurations;
    /**
     * List VisibilityGroups. Returns a paged response.
     *
     * @export
     * @class ListVisibilityGroups
     * @implements {EvaService}
     */
    class ListVisibilityGroups {
        name = 'CoreManagement:ListVisibilityGroups';
        path = '/message/ListVisibilityGroups';
        request;
        response;
    }
    CoreManagement.ListVisibilityGroups = ListVisibilityGroups;
    /**
     * List the wishlists.
     *
     * @export
     * @class ListWishlists
     * @implements {EvaService}
     */
    class ListWishlists {
        name = 'CoreManagement:ListWishlists';
        path = '/message/ListWishlists';
        request;
        response;
    }
    CoreManagement.ListWishlists = ListWishlists;
    /**
     * Creates a localized Name and Description for the OpenCashDrawerReason.
Language is required, Country is optional.
     *
     * @export
     * @class LocalizeOpenCashDrawerReason
     * @implements {EvaService}
     */
    class LocalizeOpenCashDrawerReason {
        name = 'CoreManagement:LocalizeOpenCashDrawerReason';
        path = '/message/LocalizeOpenCashDrawerReason';
        request;
        response;
    }
    CoreManagement.LocalizeOpenCashDrawerReason = LocalizeOpenCashDrawerReason;
    /**
     * Check or perform the migration for setting `PaymentMethods:PaymentTypeAvailabilityByOuSetType`.

Omitting `SaveChanges` will default to `false`, returning the changes it would have done, but don't actually persist them. Pass `true` explicitly if you want to actually migrate (use with caution!).

The payment type property `OrganizationUnitSetID` is hence-forth known as 'the legacy filter', where as the configured list of `OrganizationUnitSetPaymentType` is called 'the sets' or 'a set'.

Will execute for each active payment type;

- If it has no legacy filter configured, will remove any set that might be configured for this payment type
- If it *has* a legacy filter configured;
 - This legacy filter will be removed
 - If there is no matching set configured, it will add it
 - If there is a matching set configured but it is limited (disabled for delivery etc.), those limitations will be lifted
 - If there are any other set configured, those will be removed

And finally, the setting will be enabled on root level.

This migration will not run if the setting is already set (at any level!).
     *
     * @export
     * @class MigratePaymentTypeOrganizationUnitSetting
     * @implements {EvaService}
     */
    class MigratePaymentTypeOrganizationUnitSetting {
        name = 'CoreManagement:MigratePaymentTypeOrganizationUnitSetting';
        path = '/message/MigratePaymentTypeOrganizationUnitSetting';
        request;
        response;
    }
    CoreManagement.MigratePaymentTypeOrganizationUnitSetting = MigratePaymentTypeOrganizationUnitSetting;
    /**
     * Move an existing DiscountLayer to a new postion.

The Layer will be placed after the `AfterDiscountLayerID`. If no `AfterDiscountLayerID` is given, the layer will be placed on the first position.
     *
     * @export
     * @class MoveDiscountLayer
     * @implements {EvaService}
     */
    class MoveDiscountLayer {
        name = 'CoreManagement:MoveDiscountLayer';
        path = '/message/MoveDiscountLayer';
        request;
        response;
    }
    CoreManagement.MoveDiscountLayer = MoveDiscountLayer;
    /**
     * Preview the result of the MessageTemplate
     *
     * @export
     * @class PreviewMessageTemplate
     * @implements {EvaService}
     */
    class PreviewMessageTemplate {
        name = 'CoreManagement:PreviewMessageTemplate';
        path = '/message/PreviewMessageTemplate';
        request;
        response;
    }
    CoreManagement.PreviewMessageTemplate = PreviewMessageTemplate;
    /**
     * Returns a what-if preview of what the set would contain if it existed with the provided definition (optional) or has provided sets as its subsets.
     *
     * @export
     * @class PreviewOrganizationUnitSet
     * @implements {EvaService}
     */
    class PreviewOrganizationUnitSet {
        name = 'CoreManagement:PreviewOrganizationUnitSet';
        path = '/message/PreviewOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.PreviewOrganizationUnitSet = PreviewOrganizationUnitSet;
    /**
     * Given the data on how rounding should be applied this service will perform the rounding on the given example prices to preview what the rounding would look like.
     *
     * @export
     * @class PreviewPriceListRoundingAdjustment
     * @implements {EvaService}
     */
    class PreviewPriceListRoundingAdjustment {
        name = 'CoreManagement:PreviewPriceListRoundingAdjustment';
        path = '/message/PreviewPriceListRoundingAdjustment';
        request;
        response;
    }
    CoreManagement.PreviewPriceListRoundingAdjustment = PreviewPriceListRoundingAdjustment;
    /**
     * Print a qrcode on a thermal receipt.

It's required to select a Station, this can be done by providing the `EVA-StationID` header, or by setting the StationID property.

Also the MessageTemplate `QRCodePrintingTemplate` can be configured in Stencil.
     *
     * @export
     * @class PrintQRCode
     * @implements {EvaService}
     */
    class PrintQRCode {
        name = 'CoreManagement:PrintQRCode';
        path = '/message/PrintQRCode';
        request;
        response;
    }
    CoreManagement.PrintQRCode = PrintQRCode;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ProcessUnshippedPurchaseOrdersFromExcel
     * @implements {EvaService}
     */
    class ProcessUnshippedPurchaseOrdersFromExcel {
        name = 'CoreManagement:ProcessUnshippedPurchaseOrdersFromExcel';
        path = '/message/ProcessUnshippedPurchaseOrdersFromExcel';
        request;
        response;
    }
    CoreManagement.ProcessUnshippedPurchaseOrdersFromExcel = ProcessUnshippedPurchaseOrdersFromExcel;
    /**
     * Publishes all changes made to the survey.

Service will return an error when the survey is already published.

Survey cannot be published by the same user as the one who created / modified the survey, unless they have the right 'SurveySelfPublish'.
The service will return an error if the same user without the right 'SurveySelfPublish' tries to publish the survey.
     *
     * @export
     * @class PublishSurvey
     * @implements {EvaService}
     */
    class PublishSurvey {
        name = 'CoreManagement:PublishSurvey';
        path = '/message/PublishSurvey';
        request;
        response;
    }
    CoreManagement.PublishSurvey = PublishSurvey;
    /**
     * Push bought products for users. Only accepts 10000 users per request
     *
     * @export
     * @class PushBoughtProductsForUsers
     * @implements {EvaService}
     */
    class PushBoughtProductsForUsers {
        name = 'CoreManagement:PushBoughtProductsForUsers';
        path = '/message/PushBoughtProductsForUsers';
        request;
        response;
    }
    CoreManagement.PushBoughtProductsForUsers = PushBoughtProductsForUsers;
    /**
     * Push bought products for users. Only accepts 10000 users per request
     *
     * @export
     * @class PushBoughtProductsForUsers_Async
     * @implements {EvaService}
     */
    class PushBoughtProductsForUsers_Async {
        name = 'CoreManagement:PushBoughtProductsForUsers_Async';
        path = '/async-message/PushBoughtProductsForUsers';
        request;
        response;
    }
    CoreManagement.PushBoughtProductsForUsers_Async = PushBoughtProductsForUsers_Async;
    /**
     * Push bought products for users. Only accepts 10000 users per request
     *
     * @export
     * @class PushBoughtProductsForUsers_AsyncResult
     * @implements {EvaService}
     */
    class PushBoughtProductsForUsers_AsyncResult {
        name = 'CoreManagement:PushBoughtProductsForUsers_AsyncResult';
        path = '/async-result/PushBoughtProductsForUsers';
        request;
        response;
    }
    CoreManagement.PushBoughtProductsForUsers_AsyncResult = PushBoughtProductsForUsers_AsyncResult;
    /**
     * Push and import a case.
     *
     * @export
     * @class PushCase
     * @implements {EvaService}
     */
    class PushCase {
        name = 'CoreManagement:PushCase';
        path = '/message/PushCase';
        request;
        response;
    }
    CoreManagement.PushCase = PushCase;
    /**
     * Push multiple companies at once.
If a company doesn't exist it will be created, otherwise is will be updated.
There is a limit (1000) of companies that can be pushed a once.
     *
     * @export
     * @class PushCompanies
     * @implements {EvaService}
     */
    class PushCompanies {
        name = 'CoreManagement:PushCompanies';
        path = '/message/PushCompanies';
        request;
        response;
    }
    CoreManagement.PushCompanies = PushCompanies;
    /**
     * Push multiple companies at once.
If a company doesn't exist it will be created, otherwise is will be updated.
There is a limit (1000) of companies that can be pushed a once.
     *
     * @export
     * @class PushCompanies_Async
     * @implements {EvaService}
     */
    class PushCompanies_Async {
        name = 'CoreManagement:PushCompanies_Async';
        path = '/async-message/PushCompanies';
        request;
        response;
    }
    CoreManagement.PushCompanies_Async = PushCompanies_Async;
    /**
     * Push multiple companies at once.
If a company doesn't exist it will be created, otherwise is will be updated.
There is a limit (1000) of companies that can be pushed a once.
     *
     * @export
     * @class PushCompanies_AsyncResult
     * @implements {EvaService}
     */
    class PushCompanies_AsyncResult {
        name = 'CoreManagement:PushCompanies_AsyncResult';
        path = '/async-result/PushCompanies';
        request;
        response;
    }
    CoreManagement.PushCompanies_AsyncResult = PushCompanies_AsyncResult;
    /**
     * Push a company. If it doesn't exist it will be created, otherwise is will be updated.
     *
     * @export
     * @class PushCompany
     * @implements {EvaService}
     */
    class PushCompany {
        name = 'CoreManagement:PushCompany';
        path = '/message/PushCompany';
        request;
        response;
    }
    CoreManagement.PushCompany = PushCompany;
    /**
     * Push a company. If it doesn't exist it will be created, otherwise is will be updated.
     *
     * @export
     * @class PushCompany_Async
     * @implements {EvaService}
     */
    class PushCompany_Async {
        name = 'CoreManagement:PushCompany_Async';
        path = '/async-message/PushCompany';
        request;
        response;
    }
    CoreManagement.PushCompany_Async = PushCompany_Async;
    /**
     * Push a company. If it doesn't exist it will be created, otherwise is will be updated.
     *
     * @export
     * @class PushCompany_AsyncResult
     * @implements {EvaService}
     */
    class PushCompany_AsyncResult {
        name = 'CoreManagement:PushCompany_AsyncResult';
        path = '/async-result/PushCompany';
        request;
        response;
    }
    CoreManagement.PushCompany_AsyncResult = PushCompany_AsyncResult;
    /**
     * Push a DiscountCoupon
     *
     * @export
     * @class PushDiscountCoupons
     * @implements {EvaService}
     */
    class PushDiscountCoupons {
        name = 'CoreManagement:PushDiscountCoupons';
        path = '/message/PushDiscountCoupons';
        request;
        response;
    }
    CoreManagement.PushDiscountCoupons = PushDiscountCoupons;
    /**
     * Push a LoyaltyProgram.
If it doesn't exist it will be created, otherwise is will be updated.
Sub entities will also be created or updated, but will not be removed.
     *
     * @export
     * @class PushLoyaltyProgram
     * @implements {EvaService}
     */
    class PushLoyaltyProgram {
        name = 'CoreManagement:PushLoyaltyProgram';
        path = '/message/PushLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgram = PushLoyaltyProgram;
    /**
     * Push a LoyaltyProgramGroup.
If it doesn't exist it will be created, otherwise is will be updated.

ATTENTION!
When the currency is changed, the budget usages will be reset to 0!

ATTENTION!
When a change to Status, StartDate, EndDate or Currency leads to the group being deactivated, all related loyalty programs will also be deactivated.
When a change to Status, StartDate, EndDate or Currency leads to the group being reactivated, all related loyalty programs will also be reactivated when the option ReactivateProgramsWhenPossible is set to true. Otherwise all deactivated programs need to be manually reactivated.

ATTENTION!
When the budget is lowered below the current used budget and the `DeactivateWhenBudgetIsReached` is set to true, all related programs will be deactivated.
When the budget is cleared or raised above the current used budget, or `DeactivateWhenBudgetIsReached` is set to false, and the `ReactivateProgramsWhenPossible` is set to true, all programs that were deactivate by the group budget will be reactivated when possible.
     *
     * @export
     * @class PushLoyaltyProgramGroup
     * @implements {EvaService}
     */
    class PushLoyaltyProgramGroup {
        name = 'CoreManagement:PushLoyaltyProgramGroup';
        path = '/message/PushLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgramGroup = PushLoyaltyProgramGroup;
    /**
     * Push a LoyaltyProgramGroup.
If it doesn't exist it will be created, otherwise is will be updated.

ATTENTION!
When the currency is changed, the budget usages will be reset to 0!

ATTENTION!
When a change to Status, StartDate, EndDate or Currency leads to the group being deactivated, all related loyalty programs will also be deactivated.
When a change to Status, StartDate, EndDate or Currency leads to the group being reactivated, all related loyalty programs will also be reactivated when the option ReactivateProgramsWhenPossible is set to true. Otherwise all deactivated programs need to be manually reactivated.

ATTENTION!
When the budget is lowered below the current used budget and the `DeactivateWhenBudgetIsReached` is set to true, all related programs will be deactivated.
When the budget is cleared or raised above the current used budget, or `DeactivateWhenBudgetIsReached` is set to false, and the `ReactivateProgramsWhenPossible` is set to true, all programs that were deactivate by the group budget will be reactivated when possible.
     *
     * @export
     * @class PushLoyaltyProgramGroup_Async
     * @implements {EvaService}
     */
    class PushLoyaltyProgramGroup_Async {
        name = 'CoreManagement:PushLoyaltyProgramGroup_Async';
        path = '/async-message/PushLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgramGroup_Async = PushLoyaltyProgramGroup_Async;
    /**
     * Push a LoyaltyProgramGroup.
If it doesn't exist it will be created, otherwise is will be updated.

ATTENTION!
When the currency is changed, the budget usages will be reset to 0!

ATTENTION!
When a change to Status, StartDate, EndDate or Currency leads to the group being deactivated, all related loyalty programs will also be deactivated.
When a change to Status, StartDate, EndDate or Currency leads to the group being reactivated, all related loyalty programs will also be reactivated when the option ReactivateProgramsWhenPossible is set to true. Otherwise all deactivated programs need to be manually reactivated.

ATTENTION!
When the budget is lowered below the current used budget and the `DeactivateWhenBudgetIsReached` is set to true, all related programs will be deactivated.
When the budget is cleared or raised above the current used budget, or `DeactivateWhenBudgetIsReached` is set to false, and the `ReactivateProgramsWhenPossible` is set to true, all programs that were deactivate by the group budget will be reactivated when possible.
     *
     * @export
     * @class PushLoyaltyProgramGroup_AsyncResult
     * @implements {EvaService}
     */
    class PushLoyaltyProgramGroup_AsyncResult {
        name = 'CoreManagement:PushLoyaltyProgramGroup_AsyncResult';
        path = '/async-result/PushLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgramGroup_AsyncResult = PushLoyaltyProgramGroup_AsyncResult;
    /**
     * Push a LoyaltyProgram.
If it doesn't exist it will be created, otherwise is will be updated.
Sub entities will also be created or updated, but will not be removed.
     *
     * @export
     * @class PushLoyaltyProgram_Async
     * @implements {EvaService}
     */
    class PushLoyaltyProgram_Async {
        name = 'CoreManagement:PushLoyaltyProgram_Async';
        path = '/async-message/PushLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgram_Async = PushLoyaltyProgram_Async;
    /**
     * Push a LoyaltyProgram.
If it doesn't exist it will be created, otherwise is will be updated.
Sub entities will also be created or updated, but will not be removed.
     *
     * @export
     * @class PushLoyaltyProgram_AsyncResult
     * @implements {EvaService}
     */
    class PushLoyaltyProgram_AsyncResult {
        name = 'CoreManagement:PushLoyaltyProgram_AsyncResult';
        path = '/async-result/PushLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.PushLoyaltyProgram_AsyncResult = PushLoyaltyProgram_AsyncResult;
    /**
     * Push multiple loyalty programs at once.
If a loyalty program doesn't exist it will be created, otherwise it will be updated.
Sub entities will also be created or updated, but will not be removed.
There is a limit (1000) of loyalty programs that can be pushed a once.
     *
     * @export
     * @class PushLoyaltyPrograms
     * @implements {EvaService}
     */
    class PushLoyaltyPrograms {
        name = 'CoreManagement:PushLoyaltyPrograms';
        path = '/message/PushLoyaltyPrograms';
        request;
        response;
    }
    CoreManagement.PushLoyaltyPrograms = PushLoyaltyPrograms;
    /**
     * Push multiple loyalty programs at once.
If a loyalty program doesn't exist it will be created, otherwise it will be updated.
Sub entities will also be created or updated, but will not be removed.
There is a limit (1000) of loyalty programs that can be pushed a once.
     *
     * @export
     * @class PushLoyaltyPrograms_Async
     * @implements {EvaService}
     */
    class PushLoyaltyPrograms_Async {
        name = 'CoreManagement:PushLoyaltyPrograms_Async';
        path = '/async-message/PushLoyaltyPrograms';
        request;
        response;
    }
    CoreManagement.PushLoyaltyPrograms_Async = PushLoyaltyPrograms_Async;
    /**
     * Push multiple loyalty programs at once.
If a loyalty program doesn't exist it will be created, otherwise it will be updated.
Sub entities will also be created or updated, but will not be removed.
There is a limit (1000) of loyalty programs that can be pushed a once.
     *
     * @export
     * @class PushLoyaltyPrograms_AsyncResult
     * @implements {EvaService}
     */
    class PushLoyaltyPrograms_AsyncResult {
        name = 'CoreManagement:PushLoyaltyPrograms_AsyncResult';
        path = '/async-result/PushLoyaltyPrograms';
        request;
        response;
    }
    CoreManagement.PushLoyaltyPrograms_AsyncResult = PushLoyaltyPrograms_AsyncResult;
    /**
     * Push user bought product.
     *
     * @export
     * @class PushUserBoughtProduct
     * @implements {EvaService}
     */
    class PushUserBoughtProduct {
        name = 'CoreManagement:PushUserBoughtProduct';
        path = '/message/PushUserBoughtProduct';
        request;
        response;
    }
    CoreManagement.PushUserBoughtProduct = PushUserBoughtProduct;
    /**
     * Set products for personalized promotion for the given user. Overwrites existing products and product selection. Will unset products and selection when no products are provided.
     *
     * @export
     * @class PushUserPersonalizedPromotionProducts
     * @implements {EvaService}
     */
    class PushUserPersonalizedPromotionProducts {
        name = 'CoreManagement:PushUserPersonalizedPromotionProducts';
        path = '/message/PushUserPersonalizedPromotionProducts';
        request;
        response;
    }
    CoreManagement.PushUserPersonalizedPromotionProducts = PushUserPersonalizedPromotionProducts;
    /**
     * The service enables endpoints to push user subscriptions based on the user backend id and subscription backend id.
Multiple subscriptions can be pushed at once.

Additionally, a SubscriptionID and Balance can be provided
NOTE THAT Only subscriptions that allow for local storage can be pushed. Subscriptions fully depending on external services cannot be pushed.
NOTE THAT Balance can only be provided for loyalty subscriptions that have a EVA loyalty handler.
     *
     * @export
     * @class PushUserSubscription
     * @implements {EvaService}
     */
    class PushUserSubscription {
        name = 'CoreManagement:PushUserSubscription';
        path = '/message/PushUserSubscription';
        request;
        response;
    }
    CoreManagement.PushUserSubscription = PushUserSubscription;
    /**
     * Rebalance loyalty points of a user
     *
     * @export
     * @class RebalanceLoyaltyPoints
     * @implements {EvaService}
     */
    class RebalanceLoyaltyPoints {
        name = 'CoreManagement:RebalanceLoyaltyPoints';
        path = '/message/RebalanceLoyaltyPoints';
        request;
        response;
    }
    CoreManagement.RebalanceLoyaltyPoints = RebalanceLoyaltyPoints;
    /**
     * Asynchronously rebalance loyalty points of multiple users for a loyalty program.
This service is not transactional, meaning that if a mutation fails, other mutations that have already succeeded will not be reverted.
The maximum amount of users that can be rebalanced in a single request is 10,000.
     *
     * @export
     * @class RebalanceLoyaltyPointsForUsers
     * @implements {EvaService}
     */
    class RebalanceLoyaltyPointsForUsers {
        name = 'CoreManagement:RebalanceLoyaltyPointsForUsers';
        path = '/message/RebalanceLoyaltyPointsForUsers';
        request;
        response;
    }
    CoreManagement.RebalanceLoyaltyPointsForUsers = RebalanceLoyaltyPointsForUsers;
    /**
     * Asynchronously rebalance loyalty points of multiple users for a loyalty program.
This service is not transactional, meaning that if a mutation fails, other mutations that have already succeeded will not be reverted.
The maximum amount of users that can be rebalanced in a single request is 10,000.
     *
     * @export
     * @class RebalanceLoyaltyPointsForUsers_Async
     * @implements {EvaService}
     */
    class RebalanceLoyaltyPointsForUsers_Async {
        name = 'CoreManagement:RebalanceLoyaltyPointsForUsers_Async';
        path = '/async-message/RebalanceLoyaltyPointsForUsers';
        request;
        response;
    }
    CoreManagement.RebalanceLoyaltyPointsForUsers_Async = RebalanceLoyaltyPointsForUsers_Async;
    /**
     * Asynchronously rebalance loyalty points of multiple users for a loyalty program.
This service is not transactional, meaning that if a mutation fails, other mutations that have already succeeded will not be reverted.
The maximum amount of users that can be rebalanced in a single request is 10,000.
     *
     * @export
     * @class RebalanceLoyaltyPointsForUsers_AsyncResult
     * @implements {EvaService}
     */
    class RebalanceLoyaltyPointsForUsers_AsyncResult {
        name = 'CoreManagement:RebalanceLoyaltyPointsForUsers_AsyncResult';
        path = '/async-result/RebalanceLoyaltyPointsForUsers';
        request;
        response;
    }
    CoreManagement.RebalanceLoyaltyPointsForUsers_AsyncResult = RebalanceLoyaltyPointsForUsers_AsyncResult;
    /**
     * Reallocates the stock for a StockLocationRule with `Type` = `Limitation`.
     *
     * @export
     * @class RefillStockAllocation
     * @implements {EvaService}
     */
    class RefillStockAllocation {
        name = 'CoreManagement:RefillStockAllocation';
        path = '/message/RefillStockAllocation';
        request;
        response;
    }
    CoreManagement.RefillStockAllocation = RefillStockAllocation;
    /**
     * Register user bought product.
     *
     * @export
     * @class RegisterUserBoughtProduct
     * @implements {EvaService}
     */
    class RegisterUserBoughtProduct {
        name = 'CoreManagement:RegisterUserBoughtProduct';
        path = '/message/RegisterUserBoughtProduct';
        request;
        response;
    }
    CoreManagement.RegisterUserBoughtProduct = RegisterUserBoughtProduct;
    /**
     * Remove a blob from a case interaction.
     *
     * @export
     * @class RemoveCaseInteractionBlob
     * @implements {EvaService}
     */
    class RemoveCaseInteractionBlob {
        name = 'CoreManagement:RemoveCaseInteractionBlob';
        path = '/message/RemoveCaseInteractionBlob';
        request;
        response;
    }
    CoreManagement.RemoveCaseInteractionBlob = RemoveCaseInteractionBlob;
    /**
     * Remove case related items.
     *
     * @export
     * @class RemoveCaseRelatedItems
     * @implements {EvaService}
     */
    class RemoveCaseRelatedItems {
        name = 'CoreManagement:RemoveCaseRelatedItems';
        path = '/message/RemoveCaseRelatedItems';
        request;
        response;
    }
    CoreManagement.RemoveCaseRelatedItems = RemoveCaseRelatedItems;
    /**
     * Removes a price list from a loyalty program.
     *
     * @export
     * @class RemoveLoyaltyProgramPriceList
     * @implements {EvaService}
     */
    class RemoveLoyaltyProgramPriceList {
        name = 'CoreManagement:RemoveLoyaltyProgramPriceList';
        path = '/message/RemoveLoyaltyProgramPriceList';
        request;
        response;
    }
    CoreManagement.RemoveLoyaltyProgramPriceList = RemoveLoyaltyProgramPriceList;
    /**
     * Removes a custom field requirement from a loyalty program.
     *
     * @export
     * @class RemoveLoyaltyProgramRequiredCustomField
     * @implements {EvaService}
     */
    class RemoveLoyaltyProgramRequiredCustomField {
        name = 'CoreManagement:RemoveLoyaltyProgramRequiredCustomField';
        path = '/message/RemoveLoyaltyProgramRequiredCustomField';
        request;
        response;
    }
    CoreManagement.RemoveLoyaltyProgramRequiredCustomField = RemoveLoyaltyProgramRequiredCustomField;
    /**
     * Remove a package from a carrier
     *
     * @export
     * @class RemovePackageFromCarrier
     * @implements {EvaService}
     */
    class RemovePackageFromCarrier {
        name = 'CoreManagement:RemovePackageFromCarrier';
        path = '/message/RemovePackageFromCarrier';
        request;
        response;
    }
    CoreManagement.RemovePackageFromCarrier = RemovePackageFromCarrier;
    /**
     * Remove personalized promotion products attached to a user. Either ProductIDs or RemoveAll is required.
     *
     * @export
     * @class RemovePersonalizedPromotionProducts
     * @implements {EvaService}
     */
    class RemovePersonalizedPromotionProducts {
        name = 'CoreManagement:RemovePersonalizedPromotionProducts';
        path = '/message/RemovePersonalizedPromotionProducts';
        request;
        response;
    }
    CoreManagement.RemovePersonalizedPromotionProducts = RemovePersonalizedPromotionProducts;
    /**
     * Removes products from an assortment. When the product is not part of the assortment an error is returned.
     *
     * @export
     * @class RemoveProductsFromAssortment
     * @implements {EvaService}
     */
    class RemoveProductsFromAssortment {
        name = 'CoreManagement:RemoveProductsFromAssortment';
        path = '/message/RemoveProductsFromAssortment';
        request;
        response;
    }
    CoreManagement.RemoveProductsFromAssortment = RemoveProductsFromAssortment;
    /**
     * Remove required custom fields from ManualDiscount
     *
     * @export
     * @class RemoveRequiredCustomFieldsFromManualDiscount
     * @implements {EvaService}
     */
    class RemoveRequiredCustomFieldsFromManualDiscount {
        name = 'CoreManagement:RemoveRequiredCustomFieldsFromManualDiscount';
        path = '/message/RemoveRequiredCustomFieldsFromManualDiscount';
        request;
        response;
    }
    CoreManagement.RemoveRequiredCustomFieldsFromManualDiscount = RemoveRequiredCustomFieldsFromManualDiscount;
    /**
     * Remove security roles from ManualDiscount
     *
     * @export
     * @class RemoveRolesFromManualDiscount
     * @implements {EvaService}
     */
    class RemoveRolesFromManualDiscount {
        name = 'CoreManagement:RemoveRolesFromManualDiscount';
        path = '/message/RemoveRolesFromManualDiscount';
        request;
        response;
    }
    CoreManagement.RemoveRolesFromManualDiscount = RemoveRolesFromManualDiscount;
    /**
     * Service for generating a new SecretKey for an `EndpointConfiguration`.

- Make sure to catch & store the `SecretKey1` or `SecretKey2`, as there will be no other way of retrieving them after this service call!
     *
     * @export
     * @class RotateEndpointConfigurationKey
     * @implements {EvaService}
     */
    class RotateEndpointConfigurationKey {
        name = 'CoreManagement:RotateEndpointConfigurationKey';
        path = '/message/RotateEndpointConfigurationKey';
        request;
        response;
    }
    CoreManagement.RotateEndpointConfigurationKey = RotateEndpointConfigurationKey;
    /**
     * Searches the Discounts with the given filter and returns a paged response.
     *
     * @export
     * @class SearchDiscountsByQuery
     * @implements {EvaService}
     */
    class SearchDiscountsByQuery {
        name = 'CoreManagement:SearchDiscountsByQuery';
        path = '/message/SearchDiscountsByQuery';
        request;
        response;
    }
    CoreManagement.SearchDiscountsByQuery = SearchDiscountsByQuery;
    /**
     * This service allows retrieval of StockMutations, filtered by a Query and/or a set of filters.
     *
     * @export
     * @class SearchStockMutations
     * @implements {EvaService}
     */
    class SearchStockMutations {
        name = 'CoreManagement:SearchStockMutations';
        path = '/message/SearchStockMutations';
        request;
        response;
    }
    CoreManagement.SearchStockMutations = SearchStockMutations;
    /**
     * Set selected products for personalized promotion for the logged in user or the given user. Overwrites existing selection.
     *
     * @export
     * @class SelectUserPersonalizedPromotionProducts
     * @implements {EvaService}
     */
    class SelectUserPersonalizedPromotionProducts {
        name = 'CoreManagement:SelectUserPersonalizedPromotionProducts';
        path = '/message/SelectUserPersonalizedPromotionProducts';
        request;
        response;
    }
    CoreManagement.SelectUserPersonalizedPromotionProducts = SelectUserPersonalizedPromotionProducts;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SendSampleMailMessageTemplate
     * @implements {EvaService}
     */
    class SendSampleMailMessageTemplate {
        name = 'CoreManagement:SendSampleMailMessageTemplate';
        path = '/message/SendSampleMailMessageTemplate';
        request;
        response;
    }
    CoreManagement.SendSampleMailMessageTemplate = SendSampleMailMessageTemplate;
    /**
     * Set the value for an AppSetting

- OrganizationUnitID defaults to the root OrganizationUnit
- Name is required

Values for a specific App wil only be returned in the ApplicationConfiguration if the requesting UserAgent matches {App}/*
     *
     * @export
     * @class SetAppSetting
     * @implements {EvaService}
     */
    class SetAppSetting {
        name = 'CoreManagement:SetAppSetting';
        path = '/message/SetAppSetting';
        request;
        response;
    }
    CoreManagement.SetAppSetting = SetAppSetting;
    /**
     * Set multiple AppSettings at once

- OrganizationUnitID defaults to the root OrganizationUnit
- Name is required

Values for a specific App wil only be returned in the ApplicationConfiguration if the requesting UserAgent matches {App}/*
     *
     * @export
     * @class SetAppSettings
     * @implements {EvaService}
     */
    class SetAppSettings {
        name = 'CoreManagement:SetAppSettings';
        path = '/message/SetAppSettings';
        request;
        response;
    }
    CoreManagement.SetAppSettings = SetAppSettings;
    /**
     * Sets the required auditing settings for the specific organization unit
     *
     * @export
     * @class SetAuditingSettings
     * @implements {EvaService}
     */
    class SetAuditingSettings {
        name = 'CoreManagement:SetAuditingSettings';
        path = '/message/SetAuditingSettings';
        request;
        response;
    }
    CoreManagement.SetAuditingSettings = SetAuditingSettings;
    /**
     * Set case related data.
You can provide an OrderID (optional)
You can provide an ExternalOrderID (optional)
You can provide further details by setting RelatedItems. These can either
- contain a OrderLineID (can only be provided if OrderID is also provided. The ProductID of the orderline will copied to the ProductID of the RelatedItem)
- contain a ProductID
- a SerialNumber (is settable whether you provided a OrderLineID or ProductID)
- a IsWarranty indicator (is settable when there's an associated ProductID or the orderline contains a product)
     *
     * @export
     * @class SetCaseRelatedData
     * @implements {EvaService}
     */
    class SetCaseRelatedData {
        name = 'CoreManagement:SetCaseRelatedData';
        path = '/message/SetCaseRelatedData';
        request;
        response;
    }
    CoreManagement.SetCaseRelatedData = SetCaseRelatedData;
    /**
     * Set options for custom fields
     *
     * @export
     * @class SetCustomFieldOptions
     * @implements {EvaService}
     */
    class SetCustomFieldOptions {
        name = 'CoreManagement:SetCustomFieldOptions';
        path = '/message/SetCustomFieldOptions';
        request;
        response;
    }
    CoreManagement.SetCustomFieldOptions = SetCustomFieldOptions;
    /**
     * Takes in all discount layers and sets their sequences. All layers except the system layer are required.
     *
     * @export
     * @class SetDiscountLayerSequences
     * @implements {EvaService}
     */
    class SetDiscountLayerSequences {
        name = 'CoreManagement:SetDiscountLayerSequences';
        path = '/message/SetDiscountLayerSequences';
        request;
        response;
    }
    CoreManagement.SetDiscountLayerSequences = SetDiscountLayerSequences;
    /**
     * Set the optional loyalty program payment types for the order.
     *
     * @export
     * @class SetOrderLoyaltyProgramPaymentTypes
     * @implements {EvaService}
     */
    class SetOrderLoyaltyProgramPaymentTypes {
        name = 'CoreManagement:SetOrderLoyaltyProgramPaymentTypes';
        path = '/message/SetOrderLoyaltyProgramPaymentTypes';
        request;
        response;
    }
    CoreManagement.SetOrderLoyaltyProgramPaymentTypes = SetOrderLoyaltyProgramPaymentTypes;
    /**
     * Takes in all subsets of an organization unit set and sets their sequences. All subsets are required.
     *
     * @export
     * @class SetOrganizationUnitSubsetSequences
     * @implements {EvaService}
     */
    class SetOrganizationUnitSubsetSequences {
        name = 'CoreManagement:SetOrganizationUnitSubsetSequences';
        path = '/message/SetOrganizationUnitSubsetSequences';
        request;
        response;
    }
    CoreManagement.SetOrganizationUnitSubsetSequences = SetOrganizationUnitSubsetSequences;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetOrganizationUnitSupplierData
     * @implements {EvaService}
     */
    class SetOrganizationUnitSupplierData {
        name = 'CoreManagement:SetOrganizationUnitSupplierData';
        path = '/message/SetOrganizationUnitSupplierData';
        request;
        response;
    }
    CoreManagement.SetOrganizationUnitSupplierData = SetOrganizationUnitSupplierData;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetPaymentTypeRoles
     * @implements {EvaService}
     */
    class SetPaymentTypeRoles {
        name = 'CoreManagement:SetPaymentTypeRoles';
        path = '/message/SetPaymentTypeRoles';
        request;
        response;
    }
    CoreManagement.SetPaymentTypeRoles = SetPaymentTypeRoles;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class SetRolesForRoleSet
     * @implements {EvaService}
     */
    class SetRolesForRoleSet {
        name = 'CoreManagement:SetRolesForRoleSet';
        path = '/message/SetRolesForRoleSet';
        request;
        response;
    }
    CoreManagement.SetRolesForRoleSet = SetRolesForRoleSet;
    /**
     * Set a new value for a setting within an OrganizationUnit or apply it to all OrganizationUnits in the selected set
     *
     * @export
     * @class SetSetting
     * @implements {EvaService}
     */
    class SetSetting {
        name = 'CoreManagement:SetSetting';
        path = '/message/SetSetting';
        request;
        response;
    }
    CoreManagement.SetSetting = SetSetting;
    /**
     * Service for setting multiple settings at once

Will apply all changes or no changes in case of an error
     *
     * @export
     * @class SetSettings
     * @implements {EvaService}
     */
    class SetSettings {
        name = 'CoreManagement:SetSettings';
        path = '/message/SetSettings';
        request;
        response;
    }
    CoreManagement.SetSettings = SetSettings;
    /**
     * Takes in all routings of a question and sets their sequences.
     *
     * @export
     * @class SetSurveyQuestionRoutingSequences
     * @implements {EvaService}
     */
    class SetSurveyQuestionRoutingSequences {
        name = 'CoreManagement:SetSurveyQuestionRoutingSequences';
        path = '/message/SetSurveyQuestionRoutingSequences';
        request;
        response;
    }
    CoreManagement.SetSurveyQuestionRoutingSequences = SetSurveyQuestionRoutingSequences;
    /**
     * Update the Roles for an User. The roles provided will replace any existing roles on this user!

When an empty list is provided all roles will be removed.

The UserType defines as which UserType the User will act when logging in. For employees this wil normally be UserTypes.Employee (1)
     *
     * @export
     * @class SetUserRoles
     * @implements {EvaService}
     */
    class SetUserRoles {
        name = 'CoreManagement:SetUserRoles';
        path = '/message/SetUserRoles';
        request;
        response;
    }
    CoreManagement.SetUserRoles = SetUserRoles;
    /**
     * Start a survey
     *
     * @export
     * @class StartSurvey
     * @implements {EvaService}
     */
    class StartSurvey {
        name = 'CoreManagement:StartSurvey';
        path = '/message/StartSurvey';
        request;
        response;
    }
    CoreManagement.StartSurvey = StartSurvey;
    /**
     * Unblock a users subscription.
     *
     * @export
     * @class UnblockUserSubscription
     * @implements {EvaService}
     */
    class UnblockUserSubscription {
        name = 'CoreManagement:UnblockUserSubscription';
        path = '/message/UnblockUserSubscription';
        request;
        response;
    }
    CoreManagement.UnblockUserSubscription = UnblockUserSubscription;
    /**
     * Removes the value for an AppSetting

- OrganizationUnitID is required
- Name is required
     *
     * @export
     * @class UnsetAppSetting
     * @implements {EvaService}
     */
    class UnsetAppSetting {
        name = 'CoreManagement:UnsetAppSetting';
        path = '/message/UnsetAppSetting';
        request;
        response;
    }
    CoreManagement.UnsetAppSetting = UnsetAppSetting;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UnsetCustomFieldOptions
     * @implements {EvaService}
     */
    class UnsetCustomFieldOptions {
        name = 'CoreManagement:UnsetCustomFieldOptions';
        path = '/message/UnsetCustomFieldOptions';
        request;
        response;
    }
    CoreManagement.UnsetCustomFieldOptions = UnsetCustomFieldOptions;
    /**
     * Service for unsetting a setting
     *
     * @export
     * @class UnsetSetting
     * @implements {EvaService}
     */
    class UnsetSetting {
        name = 'CoreManagement:UnsetSetting';
        path = '/message/UnsetSetting';
        request;
        response;
    }
    CoreManagement.UnsetSetting = UnsetSetting;
    /**
     * Update an existing Account. Make sure all properties are filled.
     *
     * @export
     * @class UpdateAccount
     * @implements {EvaService}
     */
    class UpdateAccount {
        name = 'CoreManagement:UpdateAccount';
        path = '/message/UpdateAccount';
        request;
        response;
    }
    CoreManagement.UpdateAccount = UpdateAccount;
    /**
     * Update an existing assortment
     *
     * @export
     * @class UpdateAssortment
     * @implements {EvaService}
     */
    class UpdateAssortment {
        name = 'CoreManagement:UpdateAssortment';
        path = '/message/UpdateAssortment';
        request;
        response;
    }
    CoreManagement.UpdateAssortment = UpdateAssortment;
    /**
     * Update a Carrier
     *
     * @export
     * @class UpdateCarrier
     * @implements {EvaService}
     */
    class UpdateCarrier {
        name = 'CoreManagement:UpdateCarrier';
        path = '/message/UpdateCarrier';
        request;
        response;
    }
    CoreManagement.UpdateCarrier = UpdateCarrier;
    /**
     * Update an existing case.
     *
     * @export
     * @class UpdateCase
     * @implements {EvaService}
     */
    class UpdateCase {
        name = 'CoreManagement:UpdateCase';
        path = '/message/UpdateCase';
        request;
        response;
    }
    CoreManagement.UpdateCase = UpdateCase;
    /**
     * Update a case interaction
     *
     * @export
     * @class UpdateCaseInteraction
     * @implements {EvaService}
     */
    class UpdateCaseInteraction {
        name = 'CoreManagement:UpdateCaseInteraction';
        path = '/message/UpdateCaseInteraction';
        request;
        response;
    }
    CoreManagement.UpdateCaseInteraction = UpdateCaseInteraction;
    /**
     * Update an existing case state.
     *
     * @export
     * @class UpdateCaseState
     * @implements {EvaService}
     */
    class UpdateCaseState {
        name = 'CoreManagement:UpdateCaseState';
        path = '/message/UpdateCaseState';
        request;
        response;
    }
    CoreManagement.UpdateCaseState = UpdateCaseState;
    /**
     * Update a case status
     *
     * @export
     * @class UpdateCaseStatus
     * @implements {EvaService}
     */
    class UpdateCaseStatus {
        name = 'CoreManagement:UpdateCaseStatus';
        path = '/message/UpdateCaseStatus';
        request;
        response;
    }
    CoreManagement.UpdateCaseStatus = UpdateCaseStatus;
    /**
     * Update an existing case summary.
     *
     * @export
     * @class UpdateCaseSummary
     * @implements {EvaService}
     */
    class UpdateCaseSummary {
        name = 'CoreManagement:UpdateCaseSummary';
        path = '/message/UpdateCaseSummary';
        request;
        response;
    }
    CoreManagement.UpdateCaseSummary = UpdateCaseSummary;
    /**
     * Update a case topic
     *
     * @export
     * @class UpdateCaseTopic
     * @implements {EvaService}
     */
    class UpdateCaseTopic {
        name = 'CoreManagement:UpdateCaseTopic';
        path = '/message/UpdateCaseTopic';
        request;
        response;
    }
    CoreManagement.UpdateCaseTopic = UpdateCaseTopic;
    /**
     * Updates a cash expense type. All properties except for its Name can be updated.
     *
     * @export
     * @class UpdateCashExpenseType
     * @implements {EvaService}
     */
    class UpdateCashExpenseType {
        name = 'CoreManagement:UpdateCashExpenseType';
        path = '/message/UpdateCashExpenseType';
        request;
        response;
    }
    CoreManagement.UpdateCashExpenseType = UpdateCashExpenseType;
    /**
     * Update an existing CashHandler
     *
     * @export
     * @class UpdateCashHandler
     * @implements {EvaService}
     */
    class UpdateCashHandler {
        name = 'CoreManagement:UpdateCashHandler';
        path = '/message/UpdateCashHandler';
        request;
        response;
    }
    CoreManagement.UpdateCashHandler = UpdateCashHandler;
    /**
     * Update an existing CheckoutOption
     *
     * @export
     * @class UpdateCheckoutOption
     * @implements {EvaService}
     */
    class UpdateCheckoutOption {
        name = 'CoreManagement:UpdateCheckoutOption';
        path = '/message/UpdateCheckoutOption';
        request;
        response;
    }
    CoreManagement.UpdateCheckoutOption = UpdateCheckoutOption;
    /**
     * Update an existing CheckoutOptionCategory
     *
     * @export
     * @class UpdateCheckoutOptionCategory
     * @implements {EvaService}
     */
    class UpdateCheckoutOptionCategory {
        name = 'CoreManagement:UpdateCheckoutOptionCategory';
        path = '/message/UpdateCheckoutOptionCategory';
        request;
        response;
    }
    CoreManagement.UpdateCheckoutOptionCategory = UpdateCheckoutOptionCategory;
    /**
     * Updates the sequence of supplied CheckoutOptions `IDs` matching the order they were submitted. CheckoutOptions not supplied are not touched.

The first supplied CheckoutOption will get `Sequence=0` and thus will be returned first. The second will get `Sequence=1`, and so on.
     *
     * @export
     * @class UpdateCheckoutOptionSequences
     * @implements {EvaService}
     */
    class UpdateCheckoutOptionSequences {
        name = 'CoreManagement:UpdateCheckoutOptionSequences';
        path = '/message/UpdateCheckoutOptionSequences';
        request;
        response;
    }
    CoreManagement.UpdateCheckoutOptionSequences = UpdateCheckoutOptionSequences;
    /**
     * Update an existing ClientApplication.
     *
     * @export
     * @class UpdateClientApplication
     * @implements {EvaService}
     */
    class UpdateClientApplication {
        name = 'CoreManagement:UpdateClientApplication';
        path = '/message/UpdateClientApplication';
        request;
        response;
    }
    CoreManagement.UpdateClientApplication = UpdateClientApplication;
    /**
     * Updates a Company. Fields not provided in the request are ignored.
     *
     * @export
     * @class UpdateCompany
     * @implements {EvaService}
     */
    class UpdateCompany {
        name = 'CoreManagement:UpdateCompany';
        path = '/message/UpdateCompany';
        request;
        response;
    }
    CoreManagement.UpdateCompany = UpdateCompany;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateCostPriceCalculation
     * @implements {EvaService}
     */
    class UpdateCostPriceCalculation {
        name = 'CoreManagement:UpdateCostPriceCalculation';
        path = '/message/UpdateCostPriceCalculation';
        request;
        response;
    }
    CoreManagement.UpdateCostPriceCalculation = UpdateCostPriceCalculation;
    /**
     * Update an existing custom CustomField.
     *
     * @export
     * @class UpdateCustomField
     * @implements {EvaService}
     */
    class UpdateCustomField {
        name = 'CoreManagement:UpdateCustomField';
        path = '/message/UpdateCustomField';
        request;
        response;
    }
    CoreManagement.UpdateCustomField = UpdateCustomField;
    /**
     * Updates a device
     *
     * @export
     * @class UpdateDevice
     * @implements {EvaService}
     */
    class UpdateDevice {
        name = 'CoreManagement:UpdateDevice';
        path = '/message/UpdateDevice';
        request;
        response;
    }
    CoreManagement.UpdateDevice = UpdateDevice;
    /**
     * Update an existing discount
     *
     * @export
     * @class UpdateDiscount
     * @implements {EvaService}
     */
    class UpdateDiscount {
        name = 'CoreManagement:UpdateDiscount';
        path = '/message/UpdateDiscount';
        request;
        response;
    }
    CoreManagement.UpdateDiscount = UpdateDiscount;
    /**
     * Update an existing DiscountCampaign
     *
     * @export
     * @class UpdateDiscountCampaign
     * @implements {EvaService}
     */
    class UpdateDiscountCampaign {
        name = 'CoreManagement:UpdateDiscountCampaign';
        path = '/message/UpdateDiscountCampaign';
        request;
        response;
    }
    CoreManagement.UpdateDiscountCampaign = UpdateDiscountCampaign;
    /**
     * Update the budget on the discount campaign.
When the budget is lowerd below the current `TotalDiscountGiven` and the `DeactivateWhenBudgetReached` is set to true, all related discounts will be deactivated.
When the budget is cleared or raised above the current `TotalDiscountGiven`, or `DeactivateWhenBudgetReached` is set to false, all discounts that were deactivate by the discount campaign budget will be reactivated.
     *
     * @export
     * @class UpdateDiscountCampaignBudget
     * @implements {EvaService}
     */
    class UpdateDiscountCampaignBudget {
        name = 'CoreManagement:UpdateDiscountCampaignBudget';
        path = '/message/UpdateDiscountCampaignBudget';
        request;
        response;
    }
    CoreManagement.UpdateDiscountCampaignBudget = UpdateDiscountCampaignBudget;
    /**
     * Update an existing DiscountCoupon
     *
     * @export
     * @class UpdateDiscountCoupon
     * @implements {EvaService}
     */
    class UpdateDiscountCoupon {
        name = 'CoreManagement:UpdateDiscountCoupon';
        path = '/message/UpdateDiscountCoupon';
        request;
        response;
    }
    CoreManagement.UpdateDiscountCoupon = UpdateDiscountCoupon;
    /**
     * Update an existing DiscountLayer
     *
     * @export
     * @class UpdateDiscountLayer
     * @implements {EvaService}
     */
    class UpdateDiscountLayer {
        name = 'CoreManagement:UpdateDiscountLayer';
        path = '/message/UpdateDiscountLayer';
        request;
        response;
    }
    CoreManagement.UpdateDiscountLayer = UpdateDiscountLayer;
    /**
     * Update an existing discount template
     *
     * @export
     * @class UpdateDiscountTemplate
     * @implements {EvaService}
     */
    class UpdateDiscountTemplate {
        name = 'CoreManagement:UpdateDiscountTemplate';
        path = '/message/UpdateDiscountTemplate';
        request;
        response;
    }
    CoreManagement.UpdateDiscountTemplate = UpdateDiscountTemplate;
    /**
     * Service for updating a existing `EndpointConfiguration`
     *
     * @export
     * @class UpdateEndpointConfiguration
     * @implements {EvaService}
     */
    class UpdateEndpointConfiguration {
        name = 'CoreManagement:UpdateEndpointConfiguration';
        path = '/message/UpdateEndpointConfiguration';
        request;
        response;
    }
    CoreManagement.UpdateEndpointConfiguration = UpdateEndpointConfiguration;
    /**
     * Update a entity field validator
     *
     * @export
     * @class UpdateEntityFieldValidator
     * @implements {EvaService}
     */
    class UpdateEntityFieldValidator {
        name = 'CoreManagement:UpdateEntityFieldValidator';
        path = '/message/UpdateEntityFieldValidator';
        request;
        response;
    }
    CoreManagement.UpdateEntityFieldValidator = UpdateEntityFieldValidator;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateFraudItem
     * @implements {EvaService}
     */
    class UpdateFraudItem {
        name = 'CoreManagement:UpdateFraudItem';
        path = '/message/UpdateFraudItem';
        request;
        response;
    }
    CoreManagement.UpdateFraudItem = UpdateFraudItem;
    /**
     * Update an existing GiftCardConfiguration
     *
     * @export
     * @class UpdateGiftCardConfiguration
     * @implements {EvaService}
     */
    class UpdateGiftCardConfiguration {
        name = 'CoreManagement:UpdateGiftCardConfiguration';
        path = '/message/UpdateGiftCardConfiguration';
        request;
        response;
    }
    CoreManagement.UpdateGiftCardConfiguration = UpdateGiftCardConfiguration;
    /**
     * Update an inquiry
     *
     * @export
     * @class UpdateInquiry
     * @implements {EvaService}
     */
    class UpdateInquiry {
        name = 'CoreManagement:UpdateInquiry';
        path = '/message/UpdateInquiry';
        request;
        response;
    }
    CoreManagement.UpdateInquiry = UpdateInquiry;
    /**
     * Updates an inquiry item
     *
     * @export
     * @class UpdateInquiryItem
     * @implements {EvaService}
     */
    class UpdateInquiryItem {
        name = 'CoreManagement:UpdateInquiryItem';
        path = '/message/UpdateInquiryItem';
        request;
        response;
    }
    CoreManagement.UpdateInquiryItem = UpdateInquiryItem;
    /**
     * Update an existing LoyaltyProgram
     *
     * @export
     * @class UpdateLoyaltyProgram
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgram {
        name = 'CoreManagement:UpdateLoyaltyProgram';
        path = '/message/UpdateLoyaltyProgram';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgram = UpdateLoyaltyProgram;
    /**
     * Update the budget on the loyalty program group.
ATTENTION! When the currency is changed, the used budget registration will be reset to 0!
When the budget is lowered below the current used budget and the `DeactivateWhenBudgetIsReached` is set to true, all related programs will be deactivated.
When the budget is cleared or raised above the current used budget, or `DeactivateWhenBudgetIsReached` is set to false, and the `ReactivateProgramsWhenPossible` is set to true, all programs that were deactivate by the group budget will be reactivated when possible.
     *
     * @export
     * @class UpdateLoyaltyProgramBudget
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramBudget {
        name = 'CoreManagement:UpdateLoyaltyProgramBudget';
        path = '/message/UpdateLoyaltyProgramBudget';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramBudget = UpdateLoyaltyProgramBudget;
    /**
     * Update an existing LoyaltyProgramCondition
     *
     * @export
     * @class UpdateLoyaltyProgramCondition
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramCondition {
        name = 'CoreManagement:UpdateLoyaltyProgramCondition';
        path = '/message/UpdateLoyaltyProgramCondition';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramCondition = UpdateLoyaltyProgramCondition;
    /**
     * Update an existing LoyaltyProgramGroup

ATTENTION!
When the currency is changed, the budget usages will be reset to 0!

ATTENTION!
When a change to Status, StartDate, EndDate or Currency leads to the group being deactivated, all related loyalty programs will also be deactivated.
When a change to Status, StartDate, EndDate or Currency leads to the group being reactivate, all related loyalty programs will also be reactive when the option ReactivateProgramsWhenPossible is set to true. Otherwise all deactivated programs need to be manually reactivated.
     *
     * @export
     * @class UpdateLoyaltyProgramGroup
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramGroup {
        name = 'CoreManagement:UpdateLoyaltyProgramGroup';
        path = '/message/UpdateLoyaltyProgramGroup';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramGroup = UpdateLoyaltyProgramGroup;
    /**
     * Update the budget on the loyalty program group.
ATTENTION!
When the budget is lowered below the current used budget and the `DeactivateWhenBudgetIsReached` is set to true, all related programs will be deactivated.
When the budget is cleared or raised above the current used budget, or `DeactivateWhenBudgetIsReached` is set to false, and the `ReactivateProgramsWhenPossible` is set to true, all programs that were deactivate by the group budget will be reactivated when possible.
     *
     * @export
     * @class UpdateLoyaltyProgramGroupBudget
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramGroupBudget {
        name = 'CoreManagement:UpdateLoyaltyProgramGroupBudget';
        path = '/message/UpdateLoyaltyProgramGroupBudget';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramGroupBudget = UpdateLoyaltyProgramGroupBudget;
    /**
     * Update an existing LoyaltyProgramPaymentType
     *
     * @export
     * @class UpdateLoyaltyProgramPaymentType
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramPaymentType {
        name = 'CoreManagement:UpdateLoyaltyProgramPaymentType';
        path = '/message/UpdateLoyaltyProgramPaymentType';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramPaymentType = UpdateLoyaltyProgramPaymentType;
    /**
     * Update a loyalty program product limitation.
     *
     * @export
     * @class UpdateLoyaltyProgramProductLimitation
     * @implements {EvaService}
     */
    class UpdateLoyaltyProgramProductLimitation {
        name = 'CoreManagement:UpdateLoyaltyProgramProductLimitation';
        path = '/message/UpdateLoyaltyProgramProductLimitation';
        request;
        response;
    }
    CoreManagement.UpdateLoyaltyProgramProductLimitation = UpdateLoyaltyProgramProductLimitation;
    /**
     * Update an existing MessageTemplate
     *
     * @export
     * @class UpdateMessageTemplate
     * @implements {EvaService}
     */
    class UpdateMessageTemplate {
        name = 'CoreManagement:UpdateMessageTemplate';
        path = '/message/UpdateMessageTemplate';
        request;
        response;
    }
    CoreManagement.UpdateMessageTemplate = UpdateMessageTemplate;
    /**
     * Updates an existing OpenCashDrawerReason with a new Name and Description.
     *
     * @export
     * @class UpdateOpenCashDrawerReason
     * @implements {EvaService}
     */
    class UpdateOpenCashDrawerReason {
        name = 'CoreManagement:UpdateOpenCashDrawerReason';
        path = '/message/UpdateOpenCashDrawerReason';
        request;
        response;
    }
    CoreManagement.UpdateOpenCashDrawerReason = UpdateOpenCashDrawerReason;
    /**
     * Update an existing OpeningHoursType
     *
     * @export
     * @class UpdateOpeningHoursType
     * @implements {EvaService}
     */
    class UpdateOpeningHoursType {
        name = 'CoreManagement:UpdateOpeningHoursType';
        path = '/message/UpdateOpeningHoursType';
        request;
        response;
    }
    CoreManagement.UpdateOpeningHoursType = UpdateOpeningHoursType;
    /**
     * Update existing "OrderLedgerType"
     *
     * @export
     * @class UpdateOrderLedgerType
     * @implements {EvaService}
     */
    class UpdateOrderLedgerType {
        name = 'CoreManagement:UpdateOrderLedgerType';
        path = '/message/UpdateOrderLedgerType';
        request;
        response;
    }
    CoreManagement.UpdateOrderLedgerType = UpdateOrderLedgerType;
    /**
     * Update the Cashhandler for an additional Currency
     *
     * @export
     * @class UpdateOrganizationUnitCurrency
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitCurrency {
        name = 'CoreManagement:UpdateOrganizationUnitCurrency';
        path = '/message/UpdateOrganizationUnitCurrency';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitCurrency = UpdateOrganizationUnitCurrency;
    /**
     * Update existing OpeningHours for OrganizationUnits

Multiple items can be updated in a single request. Also multiple OrganizationUnits are allowed.
     *
     * @export
     * @class UpdateOrganizationUnitOpeningHours
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitOpeningHours {
        name = 'CoreManagement:UpdateOrganizationUnitOpeningHours';
        path = '/message/UpdateOrganizationUnitOpeningHours';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitOpeningHours = UpdateOrganizationUnitOpeningHours;
    /**
     * Update the regular openinghours for an OrganizationUnit

This service accepts a request like this:
```
{
  "OrganizationUnitID": 123, // required
  "TypeID": 2, // required, OpeningHoursType
  "Sunday": {
    "IsClosed": false, // required
    "StartTime": "10:00:00", // optional
    "EndTime": "18:00:00", // optional
    "Description": "Repairs closed"// optional
  }, // required
  "Monday": ..., //required
  "Tuesday": ..., //required
  "Wednesday": ..., //required
  "Thursday": ..., //required
  "Friday": ..., //required
  "Saturday": ..., //required
  }
```
All days are required, days can be closed and contain a description

To manage non-regular OpeningHours the existing CreateOrganizationUnitOpeningHours, UpdateOrganizationUnitOpeningHours, DeleteOrganizationUnitOpeningHours can be used.
They have a TypeID property on the OpeningHours object to specify the OpeningHoursType.
     *
     * @export
     * @class UpdateOrganizationUnitRegularOpeningHours
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitRegularOpeningHours {
        name = 'CoreManagement:UpdateOrganizationUnitRegularOpeningHours';
        path = '/message/UpdateOrganizationUnitRegularOpeningHours';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitRegularOpeningHours = UpdateOrganizationUnitRegularOpeningHours;
    /**
     * Updates an OrganizationUnitSet.

  Optionally a definition can be provided, which defines a set of filters.
  Any `OrganizationUnit` that matches the filters are automatically part of the set.

  To remove a definition from a set, pass it as `null` or as an empty object to this service. If you don't want to override
  it, pass the definition you got back from the `GetOrganizationUnitSet` service.
     *
     * @export
     * @class UpdateOrganizationUnitSet
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitSet {
        name = 'CoreManagement:UpdateOrganizationUnitSet';
        path = '/message/UpdateOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitSet = UpdateOrganizationUnitSet;
    /**
     * Updates a OrganizationUnitSetScope.

When OrganizationUnitUniqueInScope is specified as true, then a single OrganizationUnit can only occur once
among all OrganizationUnitSets that have this scope.
     *
     * @export
     * @class UpdateOrganizationUnitSetScope
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitSetScope {
        name = 'CoreManagement:UpdateOrganizationUnitSetScope';
        path = '/message/UpdateOrganizationUnitSetScope';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitSetScope = UpdateOrganizationUnitSetScope;
    /**
     * Update an OrganizationUnitShippingMethod

A ShippingMethod, OrganizationUnit and Priority are required
     *
     * @export
     * @class UpdateOrganizationUnitShippingMethod
     * @implements {EvaService}
     */
    class UpdateOrganizationUnitShippingMethod {
        name = 'CoreManagement:UpdateOrganizationUnitShippingMethod';
        path = '/message/UpdateOrganizationUnitShippingMethod';
        request;
        response;
    }
    CoreManagement.UpdateOrganizationUnitShippingMethod = UpdateOrganizationUnitShippingMethod;
    /**
     * Update a package, with dimensions in millimeters (mm) and weight in grams (g).
     *
     * @export
     * @class UpdatePackage
     * @implements {EvaService}
     */
    class UpdatePackage {
        name = 'CoreManagement:UpdatePackage';
        path = '/message/UpdatePackage';
        request;
        response;
    }
    CoreManagement.UpdatePackage = UpdatePackage;
    /**
     * Update an existing custom PaymentMethod.
     *
     * @export
     * @class UpdatePaymentMethod
     * @implements {EvaService}
     */
    class UpdatePaymentMethod {
        name = 'CoreManagement:UpdatePaymentMethod';
        path = '/message/UpdatePaymentMethod';
        request;
        response;
    }
    CoreManagement.UpdatePaymentMethod = UpdatePaymentMethod;
    /**
     * Update the description of a PaymentTransactionLedgerType. Only custom made types can be updated.
     *
     * @export
     * @class UpdatePaymentTransactionLedgerType
     * @implements {EvaService}
     */
    class UpdatePaymentTransactionLedgerType {
        name = 'CoreManagement:UpdatePaymentTransactionLedgerType';
        path = '/message/UpdatePaymentTransactionLedgerType';
        request;
        response;
    }
    CoreManagement.UpdatePaymentTransactionLedgerType = UpdatePaymentTransactionLedgerType;
    /**
     * Update an existing PaymentType.
     *
     * @export
     * @class UpdatePaymentType
     * @implements {EvaService}
     */
    class UpdatePaymentType {
        name = 'CoreManagement:UpdatePaymentType';
        path = '/message/UpdatePaymentType';
        request;
        response;
    }
    CoreManagement.UpdatePaymentType = UpdatePaymentType;
    /**
     * Update an existing personalized promotion.
     *
     * @export
     * @class UpdatePersonalizedPromotion
     * @implements {EvaService}
     */
    class UpdatePersonalizedPromotion {
        name = 'CoreManagement:UpdatePersonalizedPromotion';
        path = '/message/UpdatePersonalizedPromotion';
        request;
        response;
    }
    CoreManagement.UpdatePersonalizedPromotion = UpdatePersonalizedPromotion;
    /**
     * Update a point awarding rule
     *
     * @export
     * @class UpdatePointAwardingRule
     * @implements {EvaService}
     */
    class UpdatePointAwardingRule {
        name = 'CoreManagement:UpdatePointAwardingRule';
        path = '/message/UpdatePointAwardingRule';
        request;
        response;
    }
    CoreManagement.UpdatePointAwardingRule = UpdatePointAwardingRule;
    /**
     * Update an existing PriceList
     *
     * @export
     * @class UpdatePriceList
     * @implements {EvaService}
     */
    class UpdatePriceList {
        name = 'CoreManagement:UpdatePriceList';
        path = '/message/UpdatePriceList';
        request;
        response;
    }
    CoreManagement.UpdatePriceList = UpdatePriceList;
    /**
     * Update an existing PriceListAdjustment
     *
     * @export
     * @class UpdatePriceListAdjustment
     * @implements {EvaService}
     */
    class UpdatePriceListAdjustment {
        name = 'CoreManagement:UpdatePriceListAdjustment';
        path = '/message/UpdatePriceListAdjustment';
        request;
        response;
    }
    CoreManagement.UpdatePriceListAdjustment = UpdatePriceListAdjustment;
    /**
     * Update an existing new PriceListManualInputAdjustment
     *
     * @export
     * @class UpdatePriceListManualInputAdjustment
     * @implements {EvaService}
     */
    class UpdatePriceListManualInputAdjustment {
        name = 'CoreManagement:UpdatePriceListManualInputAdjustment';
        path = '/message/UpdatePriceListManualInputAdjustment';
        request;
        response;
    }
    CoreManagement.UpdatePriceListManualInputAdjustment = UpdatePriceListManualInputAdjustment;
    /**
     * Update an existing PriceListOrganizationUnit
     *
     * @export
     * @class UpdatePriceListOrganizationUnit
     * @implements {EvaService}
     */
    class UpdatePriceListOrganizationUnit {
        name = 'CoreManagement:UpdatePriceListOrganizationUnit';
        path = '/message/UpdatePriceListOrganizationUnit';
        request;
        response;
    }
    CoreManagement.UpdatePriceListOrganizationUnit = UpdatePriceListOrganizationUnit;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdatePriceListUsageType
     * @implements {EvaService}
     */
    class UpdatePriceListUsageType {
        name = 'CoreManagement:UpdatePriceListUsageType';
        path = '/message/UpdatePriceListUsageType';
        request;
        response;
    }
    CoreManagement.UpdatePriceListUsageType = UpdatePriceListUsageType;
    /**
     * Updates a printer type
     *
     * @export
     * @class UpdatePrinterType
     * @implements {EvaService}
     */
    class UpdatePrinterType {
        name = 'CoreManagement:UpdatePrinterType';
        path = '/message/UpdatePrinterType';
        request;
        response;
    }
    CoreManagement.UpdatePrinterType = UpdatePrinterType;
    /**
     * Update an existing ProductGiftCard
     *
     * @export
     * @class UpdateProductGiftCard
     * @implements {EvaService}
     */
    class UpdateProductGiftCard {
        name = 'CoreManagement:UpdateProductGiftCard';
        path = '/message/UpdateProductGiftCard';
        request;
        response;
    }
    CoreManagement.UpdateProductGiftCard = UpdateProductGiftCard;
    /**
     * Update an existing Product Requirement
     *
     * @export
     * @class UpdateProductRequirement
     * @implements {EvaService}
     */
    class UpdateProductRequirement {
        name = 'CoreManagement:UpdateProductRequirement';
        path = '/message/UpdateProductRequirement';
        request;
        response;
    }
    CoreManagement.UpdateProductRequirement = UpdateProductRequirement;
    /**
     * Update an existing ProductSearchTemplate
     *
     * @export
     * @class UpdateProductSearchTemplate
     * @implements {EvaService}
     */
    class UpdateProductSearchTemplate {
        name = 'CoreManagement:UpdateProductSearchTemplate';
        path = '/message/UpdateProductSearchTemplate';
        request;
        response;
    }
    CoreManagement.UpdateProductSearchTemplate = UpdateProductSearchTemplate;
    /**
     * Update an existing ProductUnitOfMeasure
     *
     * @export
     * @class UpdateProductUnitOfMeasure
     * @implements {EvaService}
     */
    class UpdateProductUnitOfMeasure {
        name = 'CoreManagement:UpdateProductUnitOfMeasure';
        path = '/message/UpdateProductUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.UpdateProductUnitOfMeasure = UpdateProductUnitOfMeasure;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateRefundCorrectionReason
     * @implements {EvaService}
     */
    class UpdateRefundCorrectionReason {
        name = 'CoreManagement:UpdateRefundCorrectionReason';
        path = '/message/UpdateRefundCorrectionReason';
        request;
        response;
    }
    CoreManagement.UpdateRefundCorrectionReason = UpdateRefundCorrectionReason;
    /**
     * Update a return reason
     *
     * @export
     * @class UpdateReturnReason
     * @implements {EvaService}
     */
    class UpdateReturnReason {
        name = 'CoreManagement:UpdateReturnReason';
        path = '/message/UpdateReturnReason';
        request;
        response;
    }
    CoreManagement.UpdateReturnReason = UpdateReturnReason;
    /**
     * Update a role.
     *
     * @export
     * @class UpdateRole
     * @implements {EvaService}
     */
    class UpdateRole {
        name = 'CoreManagement:UpdateRole';
        path = '/message/UpdateRole';
        request;
        response;
    }
    CoreManagement.UpdateRole = UpdateRole;
    /**
     * Update functionalities on a role.
     *
     * @export
     * @class UpdateRoleFunctionalities
     * @implements {EvaService}
     */
    class UpdateRoleFunctionalities {
        name = 'CoreManagement:UpdateRoleFunctionalities';
        path = '/message/UpdateRoleFunctionalities';
        request;
        response;
    }
    CoreManagement.UpdateRoleFunctionalities = UpdateRoleFunctionalities;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateRoleSet
     * @implements {EvaService}
     */
    class UpdateRoleSet {
        name = 'CoreManagement:UpdateRoleSet';
        path = '/message/UpdateRoleSet';
        request;
        response;
    }
    CoreManagement.UpdateRoleSet = UpdateRoleSet;
    /**
     * Update a `ShippingCost`
     *
     * @export
     * @class UpdateShippingCost
     * @implements {EvaService}
     */
    class UpdateShippingCost {
        name = 'CoreManagement:UpdateShippingCost';
        path = '/message/UpdateShippingCost';
        request;
        response;
    }
    CoreManagement.UpdateShippingCost = UpdateShippingCost;
    /**
     * Update an existing ShippingMethod
     *
     * @export
     * @class UpdateShippingMethod
     * @implements {EvaService}
     */
    class UpdateShippingMethod {
        name = 'CoreManagement:UpdateShippingMethod';
        path = '/message/UpdateShippingMethod';
        request;
        response;
    }
    CoreManagement.UpdateShippingMethod = UpdateShippingMethod;
    /**
     * Updates a ShippingMethodTransportationTime.
If you want to preserve the current value of a field, provide it to this service as the current value;
 if it's sent in as null the value will be set to null.
     *
     * @export
     * @class UpdateShippingMethodTransportationTime
     * @implements {EvaService}
     */
    class UpdateShippingMethodTransportationTime {
        name = 'CoreManagement:UpdateShippingMethodTransportationTime';
        path = '/message/UpdateShippingMethodTransportationTime';
        request;
        response;
    }
    CoreManagement.UpdateShippingMethodTransportationTime = UpdateShippingMethodTransportationTime;
    /**
     * Updates a ShippingRestriction.
     *
     * @export
     * @class UpdateShippingRestriction
     * @implements {EvaService}
     */
    class UpdateShippingRestriction {
        name = 'CoreManagement:UpdateShippingRestriction';
        path = '/message/UpdateShippingRestriction';
        request;
        response;
    }
    CoreManagement.UpdateShippingRestriction = UpdateShippingRestriction;
    /**
     * Updates a station.
     *
     * @export
     * @class UpdateStation
     * @implements {EvaService}
     */
    class UpdateStation {
        name = 'CoreManagement:UpdateStation';
        path = '/message/UpdateStation';
        request;
        response;
    }
    CoreManagement.UpdateStation = UpdateStation;
    /**
     * Allows updating a StockAllocationRule. Only `Value`, `ValueType`, `RefillPeriodInDays`, `Priority`, `StartDate` and `EndDate` can be updated. To update the other fields, the rule must be re-created.
     *
     * @export
     * @class UpdateStockAllocationRule
     * @implements {EvaService}
     */
    class UpdateStockAllocationRule {
        name = 'CoreManagement:UpdateStockAllocationRule';
        path = '/message/UpdateStockAllocationRule';
        request;
        response;
    }
    CoreManagement.UpdateStockAllocationRule = UpdateStockAllocationRule;
    /**
     * Update the description or ledgerclass of StockLabel
     *
     * @export
     * @class UpdateStockLabel
     * @implements {EvaService}
     */
    class UpdateStockLabel {
        name = 'CoreManagement:UpdateStockLabel';
        path = '/message/UpdateStockLabel';
        request;
        response;
    }
    CoreManagement.UpdateStockLabel = UpdateStockLabel;
    /**
     * Update a custom or internal stock mutation reason. The name cannot be modified for internal reasons.
     *
     * @export
     * @class UpdateStockMutationReason
     * @implements {EvaService}
     */
    class UpdateStockMutationReason {
        name = 'CoreManagement:UpdateStockMutationReason';
        path = '/message/UpdateStockMutationReason';
        request;
        response;
    }
    CoreManagement.UpdateStockMutationReason = UpdateStockMutationReason;
    /**
     * Update an existing Subscription
     *
     * @export
     * @class UpdateSubscription
     * @implements {EvaService}
     */
    class UpdateSubscription {
        name = 'CoreManagement:UpdateSubscription';
        path = '/message/UpdateSubscription';
        request;
        response;
    }
    CoreManagement.UpdateSubscription = UpdateSubscription;
    /**
     * Updates an existing SubscriptionOrganizationUnitSet.
     *
     * @export
     * @class UpdateSubscriptionOrganizationUnitSet
     * @implements {EvaService}
     */
    class UpdateSubscriptionOrganizationUnitSet {
        name = 'CoreManagement:UpdateSubscriptionOrganizationUnitSet';
        path = '/message/UpdateSubscriptionOrganizationUnitSet';
        request;
        response;
    }
    CoreManagement.UpdateSubscriptionOrganizationUnitSet = UpdateSubscriptionOrganizationUnitSet;
    /**
     * Update all UserRequirements on a Subscription.

Updates the given requirements and removes all other requirements from the Subscription
     *
     * @export
     * @class UpdateSubscriptionUserRequirements
     * @implements {EvaService}
     */
    class UpdateSubscriptionUserRequirements {
        name = 'CoreManagement:UpdateSubscriptionUserRequirements';
        path = '/message/UpdateSubscriptionUserRequirements';
        request;
        response;
    }
    CoreManagement.UpdateSubscriptionUserRequirements = UpdateSubscriptionUserRequirements;
    /**
     * Update an existing SupplierProduct
     *
     * @export
     * @class UpdateSupplierProduct
     * @implements {EvaService}
     */
    class UpdateSupplierProduct {
        name = 'CoreManagement:UpdateSupplierProduct';
        path = '/message/UpdateSupplierProduct';
        request;
        response;
    }
    CoreManagement.UpdateSupplierProduct = UpdateSupplierProduct;
    /**
     * Update the prices of a SupplierProduct, this is handled in the background
     *
     * @export
     * @class UpdateSupplierProductPrices
     * @implements {EvaService}
     */
    class UpdateSupplierProductPrices {
        name = 'CoreManagement:UpdateSupplierProductPrices';
        path = '/message/UpdateSupplierProductPrices';
        request;
        response;
    }
    CoreManagement.UpdateSupplierProductPrices = UpdateSupplierProductPrices;
    /**
     * Update the stock of a SupplierProduct, this is handled in the background
     *
     * @export
     * @class UpdateSupplierProductStock
     * @implements {EvaService}
     */
    class UpdateSupplierProductStock {
        name = 'CoreManagement:UpdateSupplierProductStock';
        path = '/message/UpdateSupplierProductStock';
        request;
        response;
    }
    CoreManagement.UpdateSupplierProductStock = UpdateSupplierProductStock;
    /**
     * Update a survey.
NOTE THAT after update, the published survey will remain active and the current data will be taken into draft mode for republishing.
After publishing you can no longer change the OrganizationUnitSetID, SurveyContext, TriggerEventType and (depending on the TriggerEventType) some of the TriggerEventData properties.
     *
     * @export
     * @class UpdateSurvey
     * @implements {EvaService}
     */
    class UpdateSurvey {
        name = 'CoreManagement:UpdateSurvey';
        path = '/message/UpdateSurvey';
        request;
        response;
    }
    CoreManagement.UpdateSurvey = UpdateSurvey;
    /**
     * Update a survey question
     *
     * @export
     * @class UpdateSurveyQuestion
     * @implements {EvaService}
     */
    class UpdateSurveyQuestion {
        name = 'CoreManagement:UpdateSurveyQuestion';
        path = '/message/UpdateSurveyQuestion';
        request;
        response;
    }
    CoreManagement.UpdateSurveyQuestion = UpdateSurveyQuestion;
    /**
     * Update a survey question route
     *
     * @export
     * @class UpdateSurveyQuestionRoute
     * @implements {EvaService}
     */
    class UpdateSurveyQuestionRoute {
        name = 'CoreManagement:UpdateSurveyQuestionRoute';
        path = '/message/UpdateSurveyQuestionRoute';
        request;
        response;
    }
    CoreManagement.UpdateSurveyQuestionRoute = UpdateSurveyQuestionRoute;
    /**
     * Update an existing UnitOfMeasure
     *
     * @export
     * @class UpdateUnitOfMeasure
     * @implements {EvaService}
     */
    class UpdateUnitOfMeasure {
        name = 'CoreManagement:UpdateUnitOfMeasure';
        path = '/message/UpdateUnitOfMeasure';
        request;
        response;
    }
    CoreManagement.UpdateUnitOfMeasure = UpdateUnitOfMeasure;
    /**
     * Update an existing UnitPriceCorrectionReason
     *
     * @export
     * @class UpdateUnitPriceCorrectionReason
     * @implements {EvaService}
     */
    class UpdateUnitPriceCorrectionReason {
        name = 'CoreManagement:UpdateUnitPriceCorrectionReason';
        path = '/message/UpdateUnitPriceCorrectionReason';
        request;
        response;
    }
    CoreManagement.UpdateUnitPriceCorrectionReason = UpdateUnitPriceCorrectionReason;
    /**
     * Register user bought product.
     *
     * @export
     * @class UpdateUserBoughtProductDetail
     * @implements {EvaService}
     */
    class UpdateUserBoughtProductDetail {
        name = 'CoreManagement:UpdateUserBoughtProductDetail';
        path = '/message/UpdateUserBoughtProductDetail';
        request;
        response;
    }
    CoreManagement.UpdateUserBoughtProductDetail = UpdateUserBoughtProductDetail;
    /**
     * Update user bought product warranty.
     *
     * @export
     * @class UpdateUserBoughtProductWarranty
     * @implements {EvaService}
     */
    class UpdateUserBoughtProductWarranty {
        name = 'CoreManagement:UpdateUserBoughtProductWarranty';
        path = '/message/UpdateUserBoughtProductWarranty';
        request;
        response;
    }
    CoreManagement.UpdateUserBoughtProductWarranty = UpdateUserBoughtProductWarranty;
    /**
     * Update an existing UserOrigin
     *
     * @export
     * @class UpdateUserOrigin
     * @implements {EvaService}
     */
    class UpdateUserOrigin {
        name = 'CoreManagement:UpdateUserOrigin';
        path = '/message/UpdateUserOrigin';
        request;
        response;
    }
    CoreManagement.UpdateUserOrigin = UpdateUserOrigin;
    /**
     * Updates an existing UserRequirement.
     *
     * @export
     * @class UpdateUserRequirement
     * @implements {EvaService}
     */
    class UpdateUserRequirement {
        name = 'CoreManagement:UpdateUserRequirement';
        path = '/message/UpdateUserRequirement';
        request;
        response;
    }
    CoreManagement.UpdateUserRequirement = UpdateUserRequirement;
    /**
     * Updates an existing UserRequirementSet.
     *
     * @export
     * @class UpdateUserRequirementSet
     * @implements {EvaService}
     */
    class UpdateUserRequirementSet {
        name = 'CoreManagement:UpdateUserRequirementSet';
        path = '/message/UpdateUserRequirementSet';
        request;
        response;
    }
    CoreManagement.UpdateUserRequirementSet = UpdateUserRequirementSet;
    /**
     * Update all requirements on a UserRequirementSet.
     *
     * @export
     * @class UpdateUserRequirementSetRequirements
     * @implements {EvaService}
     */
    class UpdateUserRequirementSetRequirements {
        name = 'CoreManagement:UpdateUserRequirementSetRequirements';
        path = '/message/UpdateUserRequirementSetRequirements';
        request;
        response;
    }
    CoreManagement.UpdateUserRequirementSetRequirements = UpdateUserRequirementSetRequirements;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UpdateUserRoles
     * @implements {EvaService}
     */
    class UpdateUserRoles {
        name = 'CoreManagement:UpdateUserRoles';
        path = '/message/UpdateUserRoles';
        request;
        response;
    }
    CoreManagement.UpdateUserRoles = UpdateUserRoles;
    /**
     * Update an existing VisibilityGroup.
     *
     * @export
     * @class UpdateVisibilityGroup
     * @implements {EvaService}
     */
    class UpdateVisibilityGroup {
        name = 'CoreManagement:UpdateVisibilityGroup';
        path = '/message/UpdateVisibilityGroup';
        request;
        response;
    }
    CoreManagement.UpdateVisibilityGroup = UpdateVisibilityGroup;
    /**
     * Performs a bulk update of an assortment's products.
The data for this service can be gotten by first calling DownloadAssortmentProducts, then make your changes and reupload it using this service.
     *
     * @export
     * @class UploadAssortmentProducts
     * @implements {EvaService}
     */
    class UploadAssortmentProducts {
        name = 'CoreManagement:UploadAssortmentProducts';
        path = '/message/UploadAssortmentProducts';
        request;
        response;
    }
    CoreManagement.UploadAssortmentProducts = UploadAssortmentProducts;
    /**
     * Upload an excel with coupons.
     *
     * @export
     * @class UploadCouponExcel
     * @implements {EvaService}
     */
    class UploadCouponExcel {
        name = 'CoreManagement:UploadCouponExcel';
        path = '/message/UploadCouponExcel';
        request;
        response;
    }
    CoreManagement.UploadCouponExcel = UploadCouponExcel;
    /**
     * Upload an excel with coupons.
     *
     * @export
     * @class UploadCouponExcel_Async
     * @implements {EvaService}
     */
    class UploadCouponExcel_Async {
        name = 'CoreManagement:UploadCouponExcel_Async';
        path = '/async-message/UploadCouponExcel';
        request;
        response;
    }
    CoreManagement.UploadCouponExcel_Async = UploadCouponExcel_Async;
    /**
     * Upload an excel with coupons.
     *
     * @export
     * @class UploadCouponExcel_AsyncResult
     * @implements {EvaService}
     */
    class UploadCouponExcel_AsyncResult {
        name = 'CoreManagement:UploadCouponExcel_AsyncResult';
        path = '/async-result/UploadCouponExcel';
        request;
        response;
    }
    CoreManagement.UploadCouponExcel_AsyncResult = UploadCouponExcel_AsyncResult;
    /**
     * Upload the Excel based on the sample from `DownloadCustomersSample`.

The uploaded file will be processed in the background and the results will be mailed to the uploader.
     *
     * @export
     * @class UploadCustomers
     * @implements {EvaService}
     */
    class UploadCustomers {
        name = 'CoreManagement:UploadCustomers';
        path = '/message/UploadCustomers';
        request;
        response;
    }
    CoreManagement.UploadCustomers = UploadCustomers;
    /**
     * Upload the Excel based on the sample from `DownloadEmployeesSample`. The uploaded file will be processed in the background and the results will be mailed to the uploader.
     *
     * @export
     * @class UploadEmployees
     * @implements {EvaService}
     */
    class UploadEmployees {
        name = 'CoreManagement:UploadEmployees';
        path = '/message/UploadEmployees';
        request;
        response;
    }
    CoreManagement.UploadEmployees = UploadEmployees;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UploadFraudItems
     * @implements {EvaService}
     */
    class UploadFraudItems {
        name = 'CoreManagement:UploadFraudItems';
        path = '/message/UploadFraudItems';
        request;
        response;
    }
    CoreManagement.UploadFraudItems = UploadFraudItems;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UploadInitialInventory
     * @implements {EvaService}
     */
    class UploadInitialInventory {
        name = 'CoreManagement:UploadInitialInventory';
        path = '/message/UploadInitialInventory';
        request;
        response;
    }
    CoreManagement.UploadInitialInventory = UploadInitialInventory;
    /**
     * Upload a new settlement file

The settelements in the file will be imported and booked into financialevents to allow processing in cookbook.

It is required to supply the Handler to use. Available handlers can be fetched with the GetAvailablePaymentSettlementFileHandlers service.

For Settlement records that don't have a matching PaymentTransaction in EVA there will be financial events generated. The OrganizationUnit where this should happen can be defined with the OrganizationUnitID property.
     *
     * @export
     * @class UploadPaymentSettlementFile
     * @implements {EvaService}
     */
    class UploadPaymentSettlementFile {
        name = 'CoreManagement:UploadPaymentSettlementFile';
        path = '/message/UploadPaymentSettlementFile';
        request;
        response;
    }
    CoreManagement.UploadPaymentSettlementFile = UploadPaymentSettlementFile;
    /**
     * Upload an excel file containing all ManualInputPriceListAdjustments for the given PriceListAdjustment. These will replace all exisiting adjustments.
     *
     * @export
     * @class UploadPriceListManualInputAdjustments
     * @implements {EvaService}
     */
    class UploadPriceListManualInputAdjustments {
        name = 'CoreManagement:UploadPriceListManualInputAdjustments';
        path = '/message/UploadPriceListManualInputAdjustments';
        request;
        response;
    }
    CoreManagement.UploadPriceListManualInputAdjustments = UploadPriceListManualInputAdjustments;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class UploadPurchaseOrderExcel
     * @implements {EvaService}
     */
    class UploadPurchaseOrderExcel {
        name = 'CoreManagement:UploadPurchaseOrderExcel';
        path = '/message/UploadPurchaseOrderExcel';
        request;
        response;
    }
    CoreManagement.UploadPurchaseOrderExcel = UploadPurchaseOrderExcel;
    /**
     * Uploads a new sales order, attached to specified customer (but not paid, placed, or anything!)
     *
     * @export
     * @class UploadSalesOrderExcel
     * @implements {EvaService}
     */
    class UploadSalesOrderExcel {
        name = 'CoreManagement:UploadSalesOrderExcel';
        path = '/message/UploadSalesOrderExcel';
        request;
        response;
    }
    CoreManagement.UploadSalesOrderExcel = UploadSalesOrderExcel;
    /**
     * Upload ShippingRestrictions. Expected format is an Excel file.
     *
     * @export
     * @class UploadShippingRestrictions
     * @implements {EvaService}
     */
    class UploadShippingRestrictions {
        name = 'CoreManagement:UploadShippingRestrictions';
        path = '/message/UploadShippingRestrictions';
        request;
        response;
    }
    CoreManagement.UploadShippingRestrictions = UploadShippingRestrictions;
    /**
     * A service to upload an Excel containing StockAllocationRules that should be created or updated according to the values specified in the sheet.

An example Excel file containing the expected structure can be retrieved by calling the `DownloadStockAllocationRulesExcel` service. Important to note however
is that the first column ('C/U/D' which stands for Create/Update/Delete) will be empty in the Excel file returned by `DownloadStockAllocationRulesExcel`, but to update
or create a record the first column must have a value according to what you want to do with it. To create a row, the first column must contain 'C', to update it must contain 'U' (and the ID column must have a value pointing to the correct record)
and to delete it it must contain 'D'.
     *
     * @export
     * @class UploadStockAllocationRulesExcel
     * @implements {EvaService}
     */
    class UploadStockAllocationRulesExcel {
        name = 'CoreManagement:UploadStockAllocationRulesExcel';
        path = '/message/UploadStockAllocationRulesExcel';
        request;
        response;
    }
    CoreManagement.UploadStockAllocationRulesExcel = UploadStockAllocationRulesExcel;
    /**
     * Upload new products for a Supplier.
Fetch a sample with the `DownloadSupplierProductsSample`.
Fetch the current products with the `DownloadSupplierProducts`.
     *
     * @export
     * @class UploadSupplierProducts
     * @implements {EvaService}
     */
    class UploadSupplierProducts {
        name = 'CoreManagement:UploadSupplierProducts';
        path = '/message/UploadSupplierProducts';
        request;
        response;
    }
    CoreManagement.UploadSupplierProducts = UploadSupplierProducts;
    /**
     * Upload new barcodes for the products of a Supplier.
Fetch a sample with the `DownloadSupplierProductsBarcodesSample`.
Fetch the current prices with the `DownloadSupplierProductsBarcodes`.
     *
     * @export
     * @class UploadSupplierProductsBarcodes
     * @implements {EvaService}
     */
    class UploadSupplierProductsBarcodes {
        name = 'CoreManagement:UploadSupplierProductsBarcodes';
        path = '/message/UploadSupplierProductsBarcodes';
        request;
        response;
    }
    CoreManagement.UploadSupplierProductsBarcodes = UploadSupplierProductsBarcodes;
    /**
     * Upload new prices for the products of a Supplier.
Fetch a sample with the `DownloadSupplierProductsPricingSample`.
Fetch the current prices with the `DownloadSupplierProductsPricing`.
     *
     * @export
     * @class UploadSupplierProductsPricing
     * @implements {EvaService}
     */
    class UploadSupplierProductsPricing {
        name = 'CoreManagement:UploadSupplierProductsPricing';
        path = '/message/UploadSupplierProductsPricing';
        request;
        response;
    }
    CoreManagement.UploadSupplierProductsPricing = UploadSupplierProductsPricing;
    /**
     * Upload new stock for the products of a Supplier.
Fetch a sample with the `DownloadSupplierProductsStockSample`.
Fetch the current stock with the `DownloadSupplierProductsStock`.
     *
     * @export
     * @class UploadSupplierProductsStock
     * @implements {EvaService}
     */
    class UploadSupplierProductsStock {
        name = 'CoreManagement:UploadSupplierProductsStock';
        path = '/message/UploadSupplierProductsStock';
        request;
        response;
    }
    CoreManagement.UploadSupplierProductsStock = UploadSupplierProductsStock;
    /**
     * A service to upload an Excel containing tax codes info that.
The actions that can be taken on the tax codes are: create(C), update(U) or delete(D), according to the value specified in 'Action' column.
     *
     * @export
     * @class UploadTaxCodesExcel
     * @implements {EvaService}
     */
    class UploadTaxCodesExcel {
        name = 'CoreManagement:UploadTaxCodesExcel';
        path = '/message/UploadTaxCodesExcel';
        request;
        response;
    }
    CoreManagement.UploadTaxCodesExcel = UploadTaxCodesExcel;
    /**
     * A service to upload an Excel containing tax rates.
The actions that can be applied on the tax rates are: Create, Update or Delete, according to the value specified in 'Action' column.
     *
     * @export
     * @class UploadTaxRateExcel
     * @implements {EvaService}
     */
    class UploadTaxRateExcel {
        name = 'CoreManagement:UploadTaxRateExcel';
        path = '/message/UploadTaxRateExcel';
        request;
        response;
    }
    CoreManagement.UploadTaxRateExcel = UploadTaxRateExcel;
    /**
     * TODO: Needs documentation
     *
     * @export
     * @class ValidateCompany
     * @implements {EvaService}
     */
    class ValidateCompany {
        name = 'CoreManagement:ValidateCompany';
        path = '/message/ValidateCompany';
        request;
        response;
    }
    CoreManagement.ValidateCompany = ValidateCompany;
    /**
     * Validates the given discount information
     *
     * @export
     * @class ValidateDiscount
     * @implements {EvaService}
     */
    class ValidateDiscount {
        name = 'CoreManagement:ValidateDiscount';
        path = '/message/ValidateDiscount';
        request;
        response;
    }
    CoreManagement.ValidateDiscount = ValidateDiscount;
    /**
     * Validates the given discount template information
     *
     * @export
     * @class ValidateDiscountTemplate
     * @implements {EvaService}
     */
    class ValidateDiscountTemplate {
        name = 'CoreManagement:ValidateDiscountTemplate';
        path = '/message/ValidateDiscountTemplate';
        request;
        response;
    }
    CoreManagement.ValidateDiscountTemplate = ValidateDiscountTemplate;
    /**
     * Marks the Discount with the given Discount ID as verified.

Service will return an error when de discount is already verified.

Discount cannot be verified by the same user as the one who created / modified the discount, unless they have the right 'DiscountSelfVerification'.
The service will return an error if the same user without the right 'DiscountSelfVerification' tries to verify the discount.
     *
     * @export
     * @class VerifyDiscount
     * @implements {EvaService}
     */
    class VerifyDiscount {
        name = 'CoreManagement:VerifyDiscount';
        path = '/message/VerifyDiscount';
        request;
        response;
    }
    CoreManagement.VerifyDiscount = VerifyDiscount;
    /**
     * Withdraw loyalty points from a user
     *
     * @export
     * @class WithdrawLoyaltyPoints
     * @implements {EvaService}
     */
    class WithdrawLoyaltyPoints {
        name = 'CoreManagement:WithdrawLoyaltyPoints';
        path = '/message/WithdrawLoyaltyPoints';
        request;
        response;
    }
    CoreManagement.WithdrawLoyaltyPoints = WithdrawLoyaltyPoints;
})(CoreManagement || (CoreManagement = {}));
//# sourceMappingURL=EVA.Core.Management.Services.js.map